var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Button, Checkbox, Divider, Grid, IconButton, InputAdornment, Typography, useMediaQuery } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import dayjs from "dayjs";
import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { UploadImage } from '../../../api/api';
import { Config } from '../../../api/config';
import { ApllyUCN, AppointmentServiceAdvisorList, autoFillServiceTypeLabourtUrl, autoFillServiceTypePartUrl, ByCoverageTypeUrl, checkAMCContractURL, checkBajajCareAMCURL, checkFFMContractURL, CheckKMUrl, CheckRepeatUrl, convertedInspectionAPI, createAttachment, CustomerComplaintUrl, deleteAllAttachmentUrl, fetchPreviousFutureAdviceByIBURL, futureAdviceClonePreviousJCURL, GetActiveAccidentalConfigurationUrl, getAlertsByJobCardIdURL, getAppointmnetSlotsUrl, GetCompaignList, getDownloadPreJobCardDocumentAttachmentUrl, getPreJobCardDocumentAttachmentUploadUrl, getSavedJobItemsUrl, getSlotAPI, getUCNByDocumentIdUrl, inwardAppointmentAPI, NatureOfAccidentListUrl, odometerStatus, precheckAttachmentCreateUrl, previousJobCardURLForRepeat, RemoveUcnUrl, RepairTypeList, RepeatRevisitConfigUrl, SendUcnCodeUrl, updateCustomerComplaintURL, upsertPreJobCardAccidentalInsuranceDetailUrl, upsertSACommentURL, USER_PROFILE_DATA, validateAbnormalKMReadingURL, validateDuplicateMobileURL, ValidateOdometerUrl, ValidateServiceContractForTecPackURL, ValidateServiceTypeURL, ValidateTechpackExpiryURL, VoiceUrl } from '../../../api/url';
import { AudioButtonIcon } from '../../../assets/customIcons';
import { DeleteButtonNewIcon, PlusGrayIconNew } from '../../../assets/images';
import { formatDate, getDefaultKey } from '../../../builderPackage/common/commonFunctions';
import { FormDatePicker } from '../../../builderPackage/components/dynamicFormBuilder/components/formDatePicker';
import { FormDateTimePicker } from '../../../builderPackage/components/dynamicFormBuilder/components/formDateTimePicker';
import { FormSearchSelect } from '../../../builderPackage/components/dynamicFormBuilder/components/formSearchSelect';
import { AudioPlayer, InputBox, MuiButton, MuiStack, MuiUseForm } from '../../../components';
import { MuiImagePopUp } from '../../../components/atoms/imageDialogBox';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import { MuiSelectComponent } from '../../../components/atoms/muiSelectComponent';
import ViewAllImagePopUp from '../../../components/atoms/viewAllImagePopUp';
import AudioCapturePopUpComponent from '../../../components/molecules/audioCapturePopUpComoponent';
import CalendarComponent from '../../../components/molecules/calendarComponent';
import AmcContractPopup from '../../../components/templates/amcContractPopup';
import ImageCaptureAndFileupload from '../../../components/templates/captureImageAndFileUpload/imageCaptureAndFileupload';
import OdometerConfirmPopUp from '../../../components/templates/odometerConfirmPopUp';
import { accidentalDetailsFields, APISchema, E_Channel_Name, EContactType, EModuleSection, EParentModuleName, ESectionAttributeValue, ESystemName, insuranceDetailsFields, isModuleConfig, LOCAL_STORAGE_KEYS, Module, PolicyNumberMaxLength, StatusEnum } from '../../../constants';
import { downloadAttachment, setCustomerVoiceSectionDetails, setDocDataUpdated, setSavedTaskDetailsCount, setTasksDetailsIsDisable, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, resetState, setState, updateAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import { calculateTimeDifference, getLocalStorageItem } from '../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import { createJobItemPayload, createUILog, dateFormate, getCustomerVoiceSectionAttributes, getMobileNumber, getSlotDisable, getTime, GoogleAnlyticsErrorLog, transactionEventLog } from '../../../utils/utils';
import { REG } from '../../../utils/validationHelper';
import FutureAdvicePopup from '../../futureAdvise/FutureAdviseDialog';
import OptionAlert from '../../jobCard/repeat/optionsAlert';
import { getInsuranceProviderList, getLossTypeList } from '../../jobCardDetails/services/apiCalls';
import { JobCardKeys } from '../../jobCardDetails/services/entity';
import CustomerComplaintView from '../customerComplaintView/customerComplaintView';
import TechPackPopup from '../searchByType/techPackPopup';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import FFMContractAlert from '../../../components/templates/ffmContractAlert';
import BajajCareAMCAlert from '../../../components/templates/bajajCareAMCAlert';
var initialFValues = {
    reading: "",
    serviceType: "",
    branch: '',
    serviceAdvisor: '',
    Compaign: '',
    insuranceProvider: '',
    // Accidental details fields
    AccidentDate: "",
    IntimationDate: "",
    locationOfAccident: "",
    AccidentReportNumber: "",
    natureOfAccident: "",
    damageDescription: "",
    attachments: "",
    driverName: "",
    // Insurance details fields
    PolicyNumber: "",
    PolicyHolderName: "",
    PolicyExpiryDate: "",
    InsuredName: "",
    CoverageTypeId: "",
    LossTypeId: "",
    IntimatorName: "",
    SurveyorMobileNumber: ""
};
var AccidentalDetailsFieldMappings = {
    'AccidentDateTime': 'AccidentDate',
    'AccidentReportNumber': 'AccidentReportNumber',
    'CoverageType': 'CoverageTypeId',
    'DamageDescription': 'DamageDescription',
    'DriverName': 'DriverName',
    'InsurancePolicyExpiryDate': 'PolicyExpiryDate',
    'InsuranceProviderName': 'InsuranceProviderId',
    'InsuredName': 'InsuredName',
    'IntimationDateTime': 'IntimationDate',
    'LocationOfAccident': 'AccidentLocation',
    'LossType': 'LossTypeId',
    'NatureOfAccident': 'NatureOfAccidentId',
    'PolicyNumber': 'PolicyNumber',
    'PolicyHolderName': 'PolicyHolderName',
    'SurveyorNumber': 'IntimatorNumber',
    'SurveyorName': 'IntimatorName'
};
export var validateDuplicateMobile = function (dispatch, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var _validateDuplicateMob, _validateDuplicateMob2, _validateDuplicateMob3, validateDuplicateMobileRequest, validateDuplicateMobileResponse, isValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                validateDuplicateMobileRequest = {
                    InstallBaseId: payload.InstallBaseId,
                    OrganizationId: payload.OrganizationId,
                    MobileNo: payload.MobileNo,
                    CustomerId: payload.CustomerId,
                    ServiceTypeId: payload.ServiceTypeId
                };
                return [4 /*yield*/, dispatch(getListAPI({
                        key: "validateDuplicateMobileData",
                        url: validateDuplicateMobileURL,
                        request: validateDuplicateMobileRequest
                    }))];
            case 1:
                validateDuplicateMobileResponse = _a.sent();
                isValid = (validateDuplicateMobileResponse === null || validateDuplicateMobileResponse === void 0 || (_validateDuplicateMob = validateDuplicateMobileResponse.payload) === null || _validateDuplicateMob === void 0 || (_validateDuplicateMob = _validateDuplicateMob.value) === null || _validateDuplicateMob === void 0 ? void 0 : _validateDuplicateMob.success) && (validateDuplicateMobileResponse === null || validateDuplicateMobileResponse === void 0 || (_validateDuplicateMob2 = validateDuplicateMobileResponse.payload) === null || _validateDuplicateMob2 === void 0 || (_validateDuplicateMob2 = _validateDuplicateMob2.value) === null || _validateDuplicateMob2 === void 0 ? void 0 : _validateDuplicateMob2.statusCode) === 200;
                return [2 /*return*/, {
                        isValid: isValid,
                        message: validateDuplicateMobileResponse === null || validateDuplicateMobileResponse === void 0 || (_validateDuplicateMob3 = validateDuplicateMobileResponse.payload) === null || _validateDuplicateMob3 === void 0 || (_validateDuplicateMob3 = _validateDuplicateMob3.value) === null || _validateDuplicateMob3 === void 0 ? void 0 : _validateDuplicateMob3.message,
                        response: validateDuplicateMobileResponse
                    }];
        }
    });
}); };
export var UCN_HELPER_TEXT_STATE = /*#__PURE__*/ function (UCN_HELPER_TEXT_STATE) {
    UCN_HELPER_TEXT_STATE["INFO"] = "INFO";
    UCN_HELPER_TEXT_STATE["ERROR"] = "ERROR";
    UCN_HELPER_TEXT_STATE["CODE_SENT"] = "CODE_SENT";
    UCN_HELPER_TEXT_STATE["APPLY_SUCCESS"] = "APPLY_SUCCESS";
    UCN_HELPER_TEXT_STATE["MADATORY"] = "MADATORY";
    return UCN_HELPER_TEXT_STATE;
}({});
var ServiceDetailsComponent = function (props) {
    var _userData$data, _userData$data2, _userData$data3, _documentDetailsGetBy28, _documentDetailsGetBy104, _documentDetailsGetBy105, _documentDetailsGetBy106, _documentDetailsGetBy107, _documentDetailsGetBy108, _Object$keys, _accidentalDetailsCon4, _accidentalDetailsCon5, _accidentalDetailsCon6, _accidentalDetailsCon7, _accidentalDetailsCon8, _accidentalDetailsCon9, _accidentalDetailsCon10, _accidentalDetailsCon11, _accidentalDetailsCon12, _accidentalDetailsCon13, _accidentalDetailsCon14, _accidentalDetailsCon15, _accidentalDetailsCon16, _accidentalDetailsCon17, _accidentalDetailsCon18, _accidentalDetailsCon19, _accidentalDetailsPho, _Object$keys2, _accidentalDetailsCon21, _accidentalDetailsCon22, _accidentalDetailsCon23, _accidentalDetailsCon24, _accidentalDetailsCon25, _accidentalDetailsCon26, _accidentalDetailsCon27, _accidentalDetailsCon28, _accidentalDetailsCon29, _accidentalDetailsCon30, _accidentalDetailsCon31, _accidentalDetailsCon32, _accidentalDetailsCon33, _accidentalDetailsCon34, _accidentalDetailsCon35, _accidentalDetailsCon36, _accidentalDetailsCon37, _accidentalDetailsCon38, _customerVoiceSection11, _customerVoiceSection12, _documentDetailsGetBy109;
    var params = useParams();
    var trackButtonClick = useAnalyticsEventTracker("ServiceDetailsComponent");
    var UCN_MAP_ELEMENT = getLocalStorageItem(LOCAL_STORAGE_KEYS.UCN_MAP);
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var UCN_ALLOWED_REPAIR_TYPES = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_SERVICE_TYPE.split(',') : [];
    var UCN_CODE_TRANSACTION_TYPES = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_TRANSACTION_TYPE.split(',') : [];
    var UCN_CODE_OPTION = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_OPTIONS : 'OPTIONAL';
    var UCN_CODE_SOURCE = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.UCN_CODE_SOURCE : '';
    var IsSendUCNDisabled = UCN_MAP_ELEMENT ? UCN_MAP_ELEMENT.IsSendUCNDisabled === "true" : false;
    var vehicleDetails = props.vehicleDetails, SystemName = props.SystemName, validateDocumentURL = props.validateDocumentURL, errorMessage = props.errorMessage, customerDetails = props.customerDetails, createDocumentURL = props.createDocumentURL, modifyDocumentURL = props.modifyDocumentURL, parentComponent = props.parentComponent, apiRequestPayload = props.apiRequestPayload, module = props.module, parentModuleDocumentId = props.parentModuleDocumentId, onSuccessfullDocumentCreate = props.onSuccessfullDocumentCreate, riderAssociateCustomerId = props.riderAssociateCustomerId, isDisabled = props.isDisabled, createAndEditFlow = props.createAndEditFlow, IsFromParentAPt = props.IsFromParentAPt, VehiclesDetailsList = props.VehiclesDetailsList;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var documentId = useParams().documentId;
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var role = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _a = useState([]), serviceAdvisorList = _a[0], setServiceAdvisorList = _a[1];
    var serviceAdvisors = [{
            advisorName: "".concat(userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.GivenName, " ").concat(userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.FamilyName),
            UserId: userData === null || userData === void 0 || (_userData$data3 = userData.data) === null || _userData$data3 === void 0 ? void 0 : _userData$data3.IdentityId
        }];
    var _b = useState([]), insuranceProviderList = _b[0], setInsuranceProviderList = _b[1];
    var _c = useState([]), coverageTypeList = _c[0], setCoverageTypeList = _c[1];
    var _d = useState([]), lossTypeList = _d[0], setLossTypeList = _d[1];
    var _e = useState(), dateValue = _e[0], setDateValue = _e[1];
    var _f = useState([]), timeSlotData = _f[0], setTimeSlotData = _f[1];
    var _g = useState(""), usageReading = _g[0], setUsageReading = _g[1];
    var _h = useState(null), campaign = _h[0], setCampaign = _h[1];
    var _j = useState({
        error: false,
        errorMessage: ''
    }), usageReadingError = _j[0], setUsageReadingError = _j[1];
    var _k = useState({
        error: false,
        errorMessage: ''
    }), serviceTypeError = _k[0], setServiceTypeError = _k[1];
    var _l = useState(null), OrganizationStateCode = _l[0], setOrganizationStateCode = _l[1];
    var _m = useState(null), CustomerStateCode = _m[0], setCustomerStateCode = _m[1];
    var _o = useState(null), OrganizationStateCodeReferenceId = _o[0], setOrganizationStateCodeReferenceId = _o[1];
    var _p = useState(null), CustomerStateCodeReferenceId = _p[0], setCustomerStateCodeReferenceId = _p[1];
    var _q = useState({
        error: false,
        errorMessage: ''
    }), validateMobileError = _q[0], setValidateMobileError = _q[1];
    var _r = useState(""), serviceType = _r[0], setServiceType = _r[1];
    var serviceTypeRef = useRef(serviceType);
    var _s = useState(""), advisor = _s[0], setAdvisor = _s[1];
    var _t = useState(""), customerComplaint = _t[0], setCustomerComplanit = _t[1];
    var _u = useState(""), scheduledTime = _u[0], setScheduledTime = _u[1];
    var _v = useState(null), selectedTimeSlot = _v[0], setSelectedTimeSlot = _v[1];
    var _w = useState(false), kmReadingValidation = _w[0], setKmReadingValidation = _w[1];
    var _x = useState([]), getCurrentCalendarData = _x[0], setCurrentCalendarData = _x[1];
    var _y = useState([]), getWeekday = _y[0], setWeekday = _y[1];
    var _z = useState(), fullDate = _z[0], setFullDate = _z[1];
    var _0 = useState(), maxSlotValue = _0[0], setMaxSlotValue = _0[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _1 = useState(), StartDocDate = _1[0], setStartDocDate = _1[1];
    var _2 = useState(false), disabledConfirmCustomerComplaint = _2[0], setDisabledConfirmCustomerComplaint = _2[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _3 = useAppSelector(function (state) { return state.crud; }), activeAccidentalConfiguration = _3.activeAccidentalConfiguration, natureOfAccidentList = _3.natureOfAccidentList, documentDetailsGetById = _3.documentDetailsGetById, customerComplaintDataImageAndAudio = _3.customerComplaintDataImageAndAudio, preDocumentFetch = _3.preDocumentFetch, getStoredJobItems = _3.getStoredJobItems, getStoredSAComment = _3.getStoredSAComment, customerDetailsTrnalsteToJob = _3.customerDetailsTrnalsteToJob, savedJobItemClick = _3.savedJobItemClick, getModuleHeaderCount = _3.getModuleHeaderCount, CustomerComplaintList = _3.CustomerComplaintList, AppointmentCreateStartTime = _3.AppointmentCreateStartTime, callGetAlerts = _3.callGetAlerts, customerComplaintInitialvaluesLength = _3.customerComplaintInitialvaluesLength, customerConcernLength = _3.customerConcernLength;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _4 = useSelector(function (state) { return state.crud; }), getCustomerInfo = _4.getCustomerInfo, previousJobCards = _4.previousJobCards, getAlertsByJobCardId = _4.getAlertsByJobCardId;
    var CHANNEL_SETTING_BY_KEY = getLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_SETTING_BY_KEY);
    var _5 = useState({
        error: false,
        errorMessage: ""
    }), odometerReadingError = _5[0], setOdometerErrorReading = _5[1];
    var customerVoiceSectionDetails = useSelector(function (state) { return state.common; }).customerVoiceSectionDetails;
    var CreatedFlow = (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Create' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) === 'Create';
    var UpdateFlow = (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == "Update" || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) === 'Update';
    var _6 = useState({
        branchList: [],
        serviceType: [],
        advisorList: [],
        compaignList: []
    }), filterList = _6[0], setFilterList = _6[1];
    var _7 = useState({
        open: false,
        heading: "",
        description: "",
        popupType: "info",
        declineButton: null,
        acceptButton: null,
        onClose: function () { return setTechPackPopup({
            open: false,
            heading: "",
            description: "",
            popupType: "info",
            declineButton: null,
            acceptButton: null,
            onClose: techPackPopup.onClose
        }); }
    }), techPackPopup = _7[0], setTechPackPopup = _7[1];
    var _8 = useState(false), isSkeleton = _8[0], setIsSkeleton = _8[1];
    var _9 = useState(''), ucnCode = _9[0], setUcnCode = _9[1];
    var _10 = useState(ucnCode ? 'Remove' : IsSendUCNDisabled ? 'Check UCN' : UCN_CODE_SOURCE === 'SMS' ? 'Send' : "Apply"), ucnState = _10[0], setUcnState = _10[1];
    var _11 = useState(UCN_HELPER_TEXT_STATE.INFO), ucnHelperText = _11[0], setUcnHelperText = _11[1];
    var _12 = useState(null), existingUcnDetails = _12[0], setExistingUcnDetails = _12[1];
    var _13 = useState(false), isServiceTypeValidForDocument = _13[0], setIsServiceTypeValidForDocument = _13[1];
    var fromDate = new Date(moment().startOf('day').toString()).toISOString();
    var toDate = new Date(moment().add(30, 'days').startOf('day').toString()).toISOString();
    var _14 = useState([]), alertsList = _14[0], setAlertsList = _14[1];
    var _15 = useState(null), repeatReasonConfig = _15[0], setRepeatReasonConfig = _15[1];
    var _16 = useState(null), previousJobcard = _16[0], setPreviousJobcard = _16[1];
    var _17 = useState(null), amcServiceTypeDetails = _17[0], setAmcServiceTypeDetails = _17[1];
    var _18 = useState(false), openUpload = _18[0], setOpenUpload = _18[1];
    var _19 = useState([]), accidentalDetailsPhotographList = _19[0], setAccidentalDetailsPhotographList = _19[1];
    var _20 = useState([]), accidentalDetailsAudioList = _20[0], setAccidentalDetialsAudioList = _20[1];
    var _21 = useState(false), audioCaptureClick = _21[0], setAudioCaptureClick = _21[1];
    var currentLength = customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.length;
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var ChannelPartnerId = getLocalStorageItem(LOCAL_STORAGE_KEYS.DELAY_JOB_CARD_CONFIGURATION);
    // const [customerVoiceSectionDetails, setCustomerVoiceSectionDetails] = useState<any>(null);
    var validate = function () {
        var fieldValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : values;
        var temp = _objectSpread({}, errors);
    };
    var _22 = MuiUseForm(initialFValues, true, validate), values = _22.values, errors = _22.errors, setErrors = _22.setErrors, setValues = _22.setValues, handleInputChange = _22.handleInputChange;
    var _23 = useState(false), showAlerts = _23[0], setShowAlerts = _23[1];
    var _24 = useState(false), openAmcContractPopup = _24[0], setOpenAmcContractPopup = _24[1];
    var _25 = useState(false), isOdometerChecked = _25[0], setIsOdometerChecked = _25[1];
    var _26 = useState(false), isOpen = _26[0], setIsopen = _26[1];
    var _27 = useState(false), isOdometerVisible = _27[0], setIsOdometerVisible = _27[1];
    var _28 = useState(null), accidentalDetailsConfig = _28[0], setAccidentalDetailsConfig = _28[1];
    var _29 = useState(""), imageURL = _29[0], setImageURL = _29[1];
    var _30 = useState(false), isViewImageDrawerOpen = _30[0], setIsViewImageDrawerOpen = _30[1];
    var _31 = useState(false), viewAllImages = _31[0], setViewAllImages = _31[1];
    var _32 = useState([]), futureAdviceList = _32[0], setFutureAdviceList = _32[1];
    var _33 = useState(false), showFutureAdvicePopup = _33[0], setShowFutureAdvicePopup = _33[1];
    var customerConcern = currentLength || customerConcernLength || customerComplaintInitialvaluesLength || 0;
    useEffect(function () {
        fetchInsuranceProviders();
        fetchLossTypeList();
        fetchAlllistData();
        getRepeatResonConfig();
        getInitialData();
        getNatureOfAccidentList();
        isOdometerEnable();
        if (CreatedFlow) {
            GetServiceAdvisor(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId);
        }
    }, []);
    var fetchFutureAdvice = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy, _res$payload, res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: 'savedFutureAdvice',
                        url: fetchPreviousFutureAdviceByIBURL,
                        request: {
                            "InstallBaseId": (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.InstallBaseId) || (apiRequestPayload === null || apiRequestPayload === void 0 ? void 0 : apiRequestPayload.InstallBaseId)
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    data = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data) || [];
                    setFutureAdviceList(data);
                    if (data.length > 0)
                        setShowFutureAdvicePopup(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var getActiveAccidentalConfiguration = function (serviceType) { return __awaiter(void 0, void 0, void 0, function () {
        var _Response$payload, request, Response, _Response$payload2, _Response$payload3, _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5, accidentalDetails, insuranceDetails, inputData, output_1, newValues, accidentalDetails_1, insuranceDetails_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        ServiceTypeId: serviceType,
                        ChannelId: storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId,
                        // SystemName: 'JobCard',
                        SystemName: parentComponent === ESystemName.ServiceEstimate || parentComponent === ESystemName.Estimate ? ESystemName.Estimate : parentComponent
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: GetActiveAccidentalConfigurationUrl,
                            request: request
                        }))];
                case 1:
                    Response = _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.data) {
                        accidentalDetails = Response === null || Response === void 0 || (_Response$payload2 = Response.payload) === null || _Response$payload2 === void 0 || (_Response$payload2 = _Response$payload2.value) === null || _Response$payload2 === void 0 || (_Response$payload2 = _Response$payload2.data) === null || _Response$payload2 === void 0 ? void 0 : _Response$payload2.AccidentalDetails;
                        insuranceDetails = Response === null || Response === void 0 || (_Response$payload3 = Response.payload) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.value) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.data) === null || _Response$payload3 === void 0 ? void 0 : _Response$payload3.InsurranceDetails;
                        inputData = {
                            AccidentalDetails: accidentalDetails || [],
                            InsurranceDetails: insuranceDetails || []
                        };
                        output_1 = {};
                        Object.entries(inputData).forEach(function (_ref) {
                            var category = _ref[0], fields = _ref[1];
                            fields === null || fields === void 0 || fields.forEach(function (field) {
                                var key = Object.keys(field)[0]; // Extract field name
                                if (key && key.trim()) {
                                    output_1[key] = {
                                        show: field[key],
                                        IsMandatory: field["IsMandatoryFor".concat(key)]
                                    };
                                }
                            });
                        });
                        setAccidentalDetailsConfig(output_1);
                        newValues = _objectSpread({}, values);
                        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy2 = documentDetailsGetById.data) !== null && _documentDetailsGetBy2 !== void 0 && _documentDetailsGetBy2.AccidentalDetails) {
                            accidentalDetails_1 = documentDetailsGetById.data.AccidentalDetails;
                            newValues = _objectSpread(_objectSpread({}, newValues), {}, {
                                NatureOfAccidentId: accidentalDetails_1.NatureOfAccidentId || "",
                                AccidentDate: accidentalDetails_1.AccidentDate || "",
                                AccidentLocation: accidentalDetails_1.AccidentLocation || "",
                                DamageDescription: accidentalDetails_1.DamageDescription || "",
                                AccidentReportNumber: accidentalDetails_1.AccidentReportNumber || "",
                                DriverName: accidentalDetails_1.DriverName || "",
                                IntimationDate: accidentalDetails_1.IntimationDate || ""
                            });
                        }
                        // Set insurance details from document if available
                        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy3 = documentDetailsGetById.data) !== null && _documentDetailsGetBy3 !== void 0 && _documentDetailsGetBy3.InsuranceDetails) {
                            insuranceDetails_1 = documentDetailsGetById.data.InsuranceDetails;
                            newValues = _objectSpread(_objectSpread({}, newValues), {}, {
                                InsuranceProviderId: insuranceDetails_1.InsuranceProviderId || "",
                                CoverageTypeId: insuranceDetails_1.CoverageTypeId || "",
                                LossTypeId: insuranceDetails_1.LossTypeId || "",
                                PolicyNumber: insuranceDetails_1.PolicyNumber || "",
                                PolicyHolderName: insuranceDetails_1.PolicyHolderName || "",
                                PolicyExpiryDate: insuranceDetails_1.PolicyExpiryDate || "",
                                InsuredName: insuranceDetails_1.InsuredName || "",
                                IntimatorName: insuranceDetails_1.IntimatorName || "",
                                IntimatorNumber: insuranceDetails_1.IntimatorNumber || ""
                            });
                        }
                        setValues(newValues);
                        getDownloadImageAccidentallDetails((_documentDetailsGetBy4 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 || (_documentDetailsGetBy5 = _documentDetailsGetBy5.AccidentalDetails) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.ImageAttachments) !== null && _documentDetailsGetBy4 !== void 0 ? _documentDetailsGetBy4 : []);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching Active Accidental Configuration:", error_1);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteAccidentalDetailsAttachment = function (parentId, attachmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var request, DeleteAttchementResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        SystemName: "PreJobCardAccidentalDetail",
                        ParentId: parentId,
                        AttachmentId: attachmentId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteAllAttachmentUrl,
                            request: request
                        }))];
                case 1:
                    DeleteAttchementResponse = _a.sent();
                    return [2 /*return*/, DeleteAttchementResponse];
            }
        });
    }); };
    useEffect(function () {
        serviceTypeRef.current = serviceType;
    }, [serviceType]);
    var getCampaignListAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy6, _documentDetailsGetBy7, _documentDetailsGetBy8, _documentDetailsGetBy9, _res$payload2, _a, key, _b, request, _c, url, state, res;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = params.key, key = _a === void 0 ? 'campaignListData' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? GetCompaignList : _c, state = params.state;
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: key,
                            url: url,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                ProductId: (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.ProductId) || (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductId),
                                ParentOrganizationId: (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.ParentOrganizationId) || (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId),
                                ServiceTypeId: serviceTypeRef.current || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.RepairTypeId) || (values === null || values === void 0 ? void 0 : values.serviceType),
                                DocumentDate: (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.CreatedOn) || new Date().toISOString()
                            })
                        }))];
                case 1:
                    res = _d.sent();
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
            }
        });
    }); };
    var onClickRemovePhotoIcon = function (photoIndex, AttachmentId, parentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp, _DeleteAttchementResp2, DeleteAttchementResponse, updatedAttachmentList, updatedAttachmentList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!AttachmentId) return [3 /*break*/, 2];
                    return [4 /*yield*/, deleteAccidentalDetailsAttachment(parentId, AttachmentId)];
                case 1:
                    DeleteAttchementResponse = _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp === void 0 || (_DeleteAttchementResp = _DeleteAttchementResp.value) === null || _DeleteAttchementResp === void 0 ? void 0 : _DeleteAttchementResp.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.success) {
                        updatedAttachmentList = __spreadArray([], accidentalDetailsPhotographList, true);
                        updatedAttachmentList.splice(photoIndex, 1);
                        setAccidentalDetailsPhotographList(updatedAttachmentList);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    updatedAttachmentList = __spreadArray([], accidentalDetailsPhotographList, true);
                    updatedAttachmentList.splice(photoIndex, 1);
                    setAccidentalDetailsPhotographList(updatedAttachmentList);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickImage = function (url) {
        setImageURL(url);
        setIsViewImageDrawerOpen(true);
    };
    var handleEmptyImage = function (item) {
        // setDisableSaveButton(false)
        setAccidentalDetailsPhotographList([]);
    };
    var handleCancleClick = function (value) {
        setOpenUpload(value);
    };
    var handleConfirmClick = function (data) {
        // setComplaint({ ...complaint, images: data })
        setAccidentalDetailsPhotographList(data);
    };
    var getDownloadImageAccidentallDetails = function (ImageAttachments) { return __awaiter(void 0, void 0, void 0, function () {
        var imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = ImageAttachments === null || ImageAttachments === void 0 ? void 0 : ImageAttachments.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var _documentDetailsGetBy10, base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push({
                                        blobUrl: base64,
                                        file: null,
                                        isAlreadyUploaded: true,
                                        AttachmentId: imageItem.AttachmentId,
                                        ParentId: imageItem.ParentId
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = ImageAttachments === null || ImageAttachments === void 0 ? void 0 : ImageAttachments.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var _documentDetailsGetBy11, base64, error_4;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy11 = documentDetailsGetById.data) === null || _documentDetailsGetBy11 === void 0 ? void 0 : _documentDetailsGetBy11.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        blobUrl: base64,
                                        file: null,
                                        AttachmentId: imageItem.AttachmentId
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_4 = _a.sent();
                                    console.error(error_4);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    // dispatch(showLoader({ isLoaderOpen: false }));
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 5:
                    setAccidentalDetailsPhotographList(imageAttachementURLs);
                    setAccidentalDetialsAudioList(audioAttachementURLs);
                    return [2 /*return*/];
            }
        });
    }); };
    var uploadAccidentalDetailsImageUpload = function (documentId, images, audios) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedImageList, ImageAttachmentsBody, imagesToBeUpload, audioFiles, request, ResponseData, PreJobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_1, uploadPromises, audioAttachmentsWithMediaType2_1, uploadPromises1, imagePayload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedImageList = [];
                    ImageAttachmentsBody = [];
                    imagesToBeUpload = [];
                    if (images && (images === null || images === void 0 ? void 0 : images.length) > 0) {
                        imagesToBeUpload = images.filter(function (item) { return !item.isAlreadyUploaded; });
                        imagesToBeUpload.map(function (imageItem) {
                            if (!imageItem.isAlreadyUploaded) {
                                ImageAttachmentsBody.push({
                                    SystemName: "PreJobCardAccidentalDetail",
                                    MediaType: 1
                                });
                            }
                        });
                    }
                    audioFiles = [];
                    if (audios) {
                        audioFiles = Array.isArray(audios) ? audios : [audios];
                    }
                    if (audios) {
                        audioFiles.map(function (audioItem) {
                            if (audioItem.file)
                                ImageAttachmentsBody.push({
                                    SystemName: "PreJobCardAccidentalDetail",
                                    MediaType: 2
                                });
                        });
                    }
                    if (!(ImageAttachmentsBody.length > 0)) return [3 /*break*/, 4];
                    request = {
                        ParentId: documentId,
                        ImageAttachments: ImageAttachmentsBody
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: createAttachment,
                            request: request
                        }))];
                case 1:
                    ResponseData = _a.sent();
                    PreJobCardDocumentAttachmentIds = [];
                    if (ResponseData.payload.success && ResponseData.payload.data) {
                        PreJobCardDocumentAttachmentIds = ResponseData.payload.data;
                    }
                    imageAttachmentsWithMediaType1_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                    uploadPromises = imagesToBeUpload.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, matchingAttachment, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!imageItem.isAlreadyUploaded) return [3 /*break*/, 3];
                                    formData = new FormData();
                                    formData.append('data', imageItem.file);
                                    matchingAttachment = imageAttachmentsWithMediaType1_1[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingIdAccidentalDetails(matchingAttachment.PreJobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result.success) {
                                        updatedImageList.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                            AttachmentId: result.attachmentId,
                                            PreJobCardDocumentAttachmentId: matchingAttachment.PreJobCardDocumentAttachmentId,
                                            MediaType: 1
                                        }));
                                    }
                                    else {
                                        updatedImageList.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                            MediaType: 1
                                        }));
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 1
                                    console.error("No matching attachment found with MediaType === 1");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 2:
                    _a.sent();
                    audioAttachmentsWithMediaType2_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 2; });
                    uploadPromises1 = audioFiles.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, matchingAttachment, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem.file);
                                    matchingAttachment = audioAttachmentsWithMediaType2_1[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingIdAccidentalDetails(matchingAttachment.PreJobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.success) {
                                        updatedImageList.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                            AttachmentId: result.attachmentId,
                                            PreJobCardDocumentAttachmentId: matchingAttachment.PreJobCardDocumentAttachmentId,
                                            MediaType: 2
                                        }));
                                    }
                                    else {
                                        updatedImageList.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                            MediaType: 2
                                        }));
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 2
                                    console.error("No matching attachment found with MediaType === 2");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    imagePayload = [];
                    if (updatedImageList) {
                        updatedImageList.map(function (imageItem) {
                            if (imageItem.AttachmentId) {
                                imagePayload.push({
                                    "AttachmentId": imageItem.AttachmentId,
                                    "PreJobCardDocumentAttachmentId": imageItem.PreJobCardDocumentAttachmentId,
                                    // "MediaType": imageItem.MediaType,
                                    "SystemName": "JobCardAccidentalDetail"
                                });
                            }
                        });
                    }
                    return [2 /*return*/, imagePayload];
            }
        });
    }); };
    var onDeleteRecording = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp3, _DeleteAttchementResp4, DeleteAttchementResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!accidentalDetailsAudioList[0]) return [3 /*break*/, 6];
                    if (!accidentalDetailsAudioList[0].AttachmentId) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, deleteAccidentalDetailsAttachment(accidentalDetailsAudioList[0].ParentId, accidentalDetailsAudioList[0].AttachmentId)];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    // console.log("deletResponse", DeleteAttchementResponse);
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp3 = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp3 === void 0 || (_DeleteAttchementResp3 = _DeleteAttchementResp3.value) === null || _DeleteAttchementResp3 === void 0 ? void 0 : _DeleteAttchementResp3.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp4 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp4 !== void 0 && (_DeleteAttchementResp4 = _DeleteAttchementResp4.value) !== null && _DeleteAttchementResp4 !== void 0 && _DeleteAttchementResp4.success) {
                        setAccidentalDetialsAudioList([]);
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setAccidentalDetialsAudioList([]);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    setAccidentalDetialsAudioList([]);
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onConfirmClick = function (audio) {
        var _accidentalDetailsAud, _accidentalDetailsAud2;
        setAccidentalDetialsAudioList([{
                blobUrl: audio.audioBlobUrl,
                file: audio.audioFile,
                audioDuration: audio.audioDuration,
                ParentId: accidentalDetailsAudioList === null || accidentalDetailsAudioList === void 0 || (_accidentalDetailsAud = accidentalDetailsAudioList[0]) === null || _accidentalDetailsAud === void 0 ? void 0 : _accidentalDetailsAud.ParentId,
                AttachmentId: accidentalDetailsAudioList === null || accidentalDetailsAudioList === void 0 || (_accidentalDetailsAud2 = accidentalDetailsAudioList[0]) === null || _accidentalDetailsAud2 === void 0 ? void 0 : _accidentalDetailsAud2.AttachmentId
            }]);
    };
    var saveAccidentalDetails = function (documentId) { return __awaiter(void 0, void 0, void 0, function () {
        var accidentalDetailsImageUploadResponse, requestBody, response, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, uploadAccidentalDetailsImageUpload(documentId, accidentalDetailsPhotographList, accidentalDetailsAudioList)];
                case 1:
                    accidentalDetailsImageUploadResponse = _a.sent();
                    requestBody = {
                        SystemName: parentComponent === ESystemName.ServiceEstimate || parentComponent === ESystemName.Estimate ? ESystemName.Estimate : parentComponent,
                        AccidentDate: values.AccidentDate || null,
                        AccidentLocation: values.AccidentLocation || null,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        PreJobCardDocumentId: documentId,
                        NatureOfAccidentId: values.NatureOfAccidentId || null,
                        DamageDescription: values.DamageDescription || null,
                        AccidentReportNumber: values.AccidentReportNumber || null,
                        DriverName: values.DriverName || null,
                        InsuranceProviderId: values.InsuranceProviderId || null,
                        ImageAttachments: accidentalDetailsImageUploadResponse !== null && accidentalDetailsImageUploadResponse !== void 0 ? accidentalDetailsImageUploadResponse : [],
                        PolicyNumber: values.PolicyNumber || null,
                        PolicyExpiryDate: values.PolicyExpiryDate || null,
                        PolicyHolderName: values.PolicyHolderName || null,
                        InsuredName: values.InsuredName || null,
                        CoverageTypeId: values.CoverageTypeId || null,
                        LossTypeId: values.LossTypeId || null,
                        IntimatorName: values.IntimatorName || null,
                        IntimatorNumber: values.IntimatorNumber || null,
                        IntimationDate: values.IntimationDate || null
                    };
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: upsertPreJobCardAccidentalInsuranceDetailUrl,
                            request: requestBody
                        }))];
                case 3:
                    response = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_5 = _a.sent();
                    console.error("Error saving accidental details:", error_5);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getPreviousJobCard = function (InstallBaseId) {
        var _documentDetailsGetBy12, _documentDetailsGetBy13;
        var previousJobcardBody = {
            InstallBaseId: InstallBaseId,
            Status: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy12 = documentDetailsGetById.data) !== null && _documentDetailsGetBy12 !== void 0 && _documentDetailsGetBy12.Key ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy13 = documentDetailsGetById.data) === null || _documentDetailsGetBy13 === void 0 ? void 0 : _documentDetailsGetBy13.Key : null
        };
        dispatch(createAPI({
            key: "previousJobCards",
            url: previousJobCardURLForRepeat,
            request: previousJobcardBody
        })).then(function (result) {
            var previousJcItem = result && result.payload && result.payload.value && result.payload.value.success && result.payload.value.data && Array.isArray(result.payload.value.data) && result.payload.value.data[0] ? result.payload.value.data[0] : null;
            setPreviousJobcard(previousJcItem);
        });
    };
    var getRepeatResonConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, selectedBranch, requestBody, result, _result$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
                    requestBody = {
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'repeatAlertConfiguration',
                            url: RepeatRevisitConfigUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data) {
                        // setRepeatReasonConfig(REPEAT_CONFIG)
                        setRepeatReasonConfig(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    function getSlotFormattedData(slots) {
        // let toDate = moment().add(30, 'days').startOf('day');
        var datePointer = moment().startOf('day');
        var resultArray = [];
        var maxCount = 0;
        while (datePointer.isSameOrBefore(toDate)) {
            var slotItem = slots.find(function (item) { return datePointer.isSame(item.Day); });
            var TotalSlots = slotItem && slotItem.TotalCount ? slotItem.TotalCount : 25;
            maxCount = TotalSlots > maxCount ? Number(TotalSlots) : Number(maxCount);
            resultArray.push({
                WeekdayShort: datePointer.format('ddd'),
                Month: datePointer.month('MM'),
                Date: datePointer.format('DD'),
                Year: datePointer.format('YYYY'),
                AvailableSlots: slotItem && slotItem.AvailableCount ? slotItem.AvailableCount : 0,
                FullDate: datePointer.toISOString(),
                TotalSlots: TotalSlots
            });
            datePointer = datePointer.add(1, 'days');
        }
        setMaxSlotValue(maxCount);
        return resultArray;
    }
    function getSlotStatsByDay() {
        if ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create') {
            var OrganizationId = selectedBranch && selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId ? selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId : "";
            var request = {
                "FromDate": fromDate,
                "ToDate": toDate,
                "OrganizationId": OrganizationId
                // "OrganizationId": "5e75d742-c9a5-429e-b825-a80e21208d36"
            };
            dispatch(createAPI({
                key: "",
                url: getAppointmnetSlotsUrl,
                request: request
            })).then(function (result) {
                var apiResult = result === null || result === void 0 ? void 0 : result.payload;
                if (apiResult.data && apiResult.data.length > 0 && apiResult.success) {
                    var slots = apiResult === null || apiResult === void 0 ? void 0 : apiResult.data;
                    var availableSlots = getSlotFormattedData(slots);
                    setWeekday(availableSlots.map(function (item) { return item.WeekdayShort; }));
                    setCurrentCalendarData(availableSlots);
                }
            }).catch(function (err) {
                console.error("Create :: ", err);
            });
        }
    }
    useEffect(function () {
        getSlotStatsByDay();
    }, []);
    var formatData = function (CustomerVoiceChildSections) {
        var updatedList = [];
        CustomerVoiceChildSections.map(function (item) {
            var newObj = Object.assign({}, item, item === null || item === void 0 ? void 0 : item.Section);
            delete newObj.Section;
            updatedList.push(_objectSpread(_objectSpread({}, newObj), {}, {
                isAccordianOpen: false
            }));
        });
        var obj = {};
        var newArray = [];
        var finalModuleSectionArray = [];
        var res = updatedList.map(function (elem) {
            var newSectionAttribute = elem.SectionAttributes;
            var mergedObj = null;
            newSectionAttribute === null || newSectionAttribute === void 0 || newSectionAttribute.map(function (el) {
                if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                    obj[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                    obj[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                    mergedObj = _objectSpread(_objectSpread({}, el), obj);
                }
            });
            if (mergedObj) {
                newArray.push(mergedObj);
            }
            obj = {};
            delete elem.SectionAttributes;
            elem['SectionAttributes'] = [];
            newArray.forEach(function (value) {
                newSectionAttribute.forEach(function (value1) {
                    if (value.id == value1.id) {
                        elem.SectionAttributes.push(value);
                    }
                });
            });
            finalModuleSectionArray.push(elem);
        });
        return finalModuleSectionArray;
    };
    var getInitialData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _data, data, _data2, _CustomerVoiceSection, CustomerVoiceSection, CustomerVoiceChildSections, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray, customerVoiceFormated;
        return __generator(this, function (_a) {
            try {
                data = [];
                if (parentComponent === EParentModuleName.Appointment) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_APPOINTMENT);
                }
                else if (parentComponent === EParentModuleName.ServiceEstimate) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_ESTIMATE);
                }
                else if (parentComponent === EParentModuleName.Inspection) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_INSPECTION);
                }
                if (((_data = data) === null || _data === void 0 ? void 0 : _data.length) > 0) {
                    CustomerVoiceSection = (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.find(function (item) {
                        var _item$Section;
                        return ((_item$Section = item.Section) === null || _item$Section === void 0 ? void 0 : _item$Section.Key) === EModuleSection.CustomerVoice;
                    });
                    CustomerVoiceChildSections = (_CustomerVoiceSection = CustomerVoiceSection === null || CustomerVoiceSection === void 0 ? void 0 : CustomerVoiceSection.ChildSections) !== null && _CustomerVoiceSection !== void 0 ? _CustomerVoiceSection : [];
                    updatedList_1 = [];
                    CustomerVoiceChildSections.map(function (item) {
                        var newObj = Object.assign({}, item, item.Section);
                        delete newObj.Section;
                        updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                            isAccordianOpen: false
                        }));
                    });
                    obj_1 = {};
                    newArray_1 = [];
                    finalModuleSectionArray_1 = [];
                    res = updatedList_1.map(function (elem) {
                        var newSectionAttribute = elem.SectionAttributes;
                        var mergedObj = null;
                        var newAttribute = newSectionAttribute.map(function (el) {
                            if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                            }
                        });
                        if (mergedObj) {
                            newArray_1.push(mergedObj);
                        }
                        obj_1 = {};
                        delete elem.SectionAttributes;
                        elem['SectionAttributes'] = [];
                        newArray_1.forEach(function (value) {
                            newSectionAttribute.forEach(function (value1) {
                                if (value.id == value1.id) {
                                    elem.SectionAttributes.push(value);
                                }
                            });
                        });
                        finalModuleSectionArray_1.push(elem);
                    });
                    sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                    customerVoiceFormated = formatData([CustomerVoiceSection]);
                    dispatch(setCustomerVoiceSectionDetails(_objectSpread(_objectSpread({}, customerVoiceFormated[0]), {}, {
                        ChildSections: sortedArray
                    })));
                }
            }
            catch (e) {
                console.log("ServiceDetailsComponent :: getInitialData :: Error-", e);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (documentDetailsGetById && documentDetailsGetById.data) {
            var _documentDetailsGetBy14, _documentDetailsGetBy15, _documentDetailsGetBy16, _documentDetailsGetBy17, _documentDetailsGetBy18, _documentDetailsGetBy19, _documentDetailsGetBy20, _previousJobCards$dat, _previousJobCards$dat2, _documentDetailsGetBy23;
            var maxLimit = 999999;
            var odometerReading_1 = (_documentDetailsGetBy14 = (_documentDetailsGetBy15 = documentDetailsGetById.data.ODOMeterReading) === null || _documentDetailsGetBy15 === void 0 ? void 0 : _documentDetailsGetBy15.toString()) !== null && _documentDetailsGetBy14 !== void 0 ? _documentDetailsGetBy14 : "";
            // Validation before setting value
            if (odometerReading_1 && Number(odometerReading_1) > maxLimit) {
                dispatch(showNotification({
                    isOpen: true,
                    message: "You cannot enter the odometer reading value greater than ".concat(maxLimit, " KMs."),
                    type: 'error'
                }));
                setUsageReading(""); // clear field if invalid
            }
            else {
                setUsageReading(odometerReading_1); // safe to set
            }
            setIsOdometerChecked(documentDetailsGetById.data.IsOdometerChange), setServiceType((_documentDetailsGetBy16 = documentDetailsGetById.data.RepairTypeId) !== null && _documentDetailsGetBy16 !== void 0 ? _documentDetailsGetBy16 : "");
            setScheduledTime(documentDetailsGetById.data.SlotStartTime);
            setSelectedTimeSlot(documentDetailsGetById.data.SlotId);
            setCampaign((_documentDetailsGetBy17 = documentDetailsGetById.data.CampaignId) !== null && _documentDetailsGetBy17 !== void 0 ? _documentDetailsGetBy17 : null);
            setOrganizationStateCode(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy18 = documentDetailsGetById.data) === null || _documentDetailsGetBy18 === void 0 ? void 0 : _documentDetailsGetBy18.OrganizationStateCode);
            setCustomerStateCode(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy19 = documentDetailsGetById.data) === null || _documentDetailsGetBy19 === void 0 ? void 0 : _documentDetailsGetBy19.CustomerStateCode);
            GetServiceAdvisor(documentDetailsGetById.data.OrganizationId);
            if (documentDetailsGetById.data.ODOMeterReading) {
                setKmReadingValidation(true);
            }
            getActiveAccidentalConfiguration(documentDetailsGetById.data.RepairTypeId);
            dispatch(getListAPI({
                key: "UCNDetails",
                url: getUCNByDocumentIdUrl,
                request: {
                    ChildId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy20 = documentDetailsGetById.data) === null || _documentDetailsGetBy20 === void 0 ? void 0 : _documentDetailsGetBy20.id
                }
            })).then(function (UCNDetails) {
                var _UCNDetails$payload, _UCNDetails$payload2, _UCNDetails$payload3, _UCNDetails$payload4, _UCNDetails$payload5, _UCNDetails$payload6, _UCNDetails$payload7, _documentDetailsGetBy21;
                var UCNCouponCode = UCNDetails !== null && UCNDetails !== void 0 && (_UCNDetails$payload = UCNDetails.payload) !== null && _UCNDetails$payload !== void 0 && (_UCNDetails$payload = _UCNDetails$payload.value) !== null && _UCNDetails$payload !== void 0 && _UCNDetails$payload.data && UCNDetails !== null && UCNDetails !== void 0 && (_UCNDetails$payload2 = UCNDetails.payload) !== null && _UCNDetails$payload2 !== void 0 && _UCNDetails$payload2.value.data.UCNCouponCode ? UCNDetails === null || UCNDetails === void 0 || (_UCNDetails$payload3 = UCNDetails.payload) === null || _UCNDetails$payload3 === void 0 || (_UCNDetails$payload3 = _UCNDetails$payload3.value) === null || _UCNDetails$payload3 === void 0 || (_UCNDetails$payload3 = _UCNDetails$payload3.data) === null || _UCNDetails$payload3 === void 0 ? void 0 : _UCNDetails$payload3.UCNCouponCode : "";
                var UCNId = UCNDetails !== null && UCNDetails !== void 0 && (_UCNDetails$payload4 = UCNDetails.payload) !== null && _UCNDetails$payload4 !== void 0 && (_UCNDetails$payload4 = _UCNDetails$payload4.value) !== null && _UCNDetails$payload4 !== void 0 && _UCNDetails$payload4.data && UCNDetails !== null && UCNDetails !== void 0 && (_UCNDetails$payload5 = UCNDetails.payload) !== null && _UCNDetails$payload5 !== void 0 && (_UCNDetails$payload5 = _UCNDetails$payload5.value) !== null && _UCNDetails$payload5 !== void 0 && (_UCNDetails$payload5 = _UCNDetails$payload5.data) !== null && _UCNDetails$payload5 !== void 0 && _UCNDetails$payload5.id ? UCNDetails === null || UCNDetails === void 0 || (_UCNDetails$payload6 = UCNDetails.payload) === null || _UCNDetails$payload6 === void 0 || (_UCNDetails$payload6 = _UCNDetails$payload6.value) === null || _UCNDetails$payload6 === void 0 || (_UCNDetails$payload6 = _UCNDetails$payload6.data) === null || _UCNDetails$payload6 === void 0 ? void 0 : _UCNDetails$payload6.id : undefined;
                setExistingUcnDetails({
                    id: UCNId,
                    UCNCouponCode: UCNCouponCode
                });
                setUcnCode(UCNDetails === null || UCNDetails === void 0 || (_UCNDetails$payload7 = UCNDetails.payload) === null || _UCNDetails$payload7 === void 0 || (_UCNDetails$payload7 = _UCNDetails$payload7.value) === null || _UCNDetails$payload7 === void 0 || (_UCNDetails$payload7 = _UCNDetails$payload7.data) === null || _UCNDetails$payload7 === void 0 ? void 0 : _UCNDetails$payload7.UCNCouponCode);
                setUcnState(UCNCouponCode ? 'Remove' : IsSendUCNDisabled ? 'Check UCN' : "Send");
                setIsServiceTypeValidForDocument(documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy21 = documentDetailsGetById.data) !== null && _documentDetailsGetBy21 !== void 0 && _documentDetailsGetBy21.RepairTypeId ? UCN_ALLOWED_REPAIR_TYPES.includes(documentDetailsGetById.data.RepairTypeId) : false);
            }).catch(function (e) {
                console.log("err", e);
            });
            if (previousJobCards && (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat = previousJobCards.data) === null || _previousJobCards$dat === void 0 ? void 0 : _previousJobCards$dat.length) > 0) {
                setPreviousJobcard(previousJobCards === null || previousJobCards === void 0 ? void 0 : previousJobCards.data[0]);
            }
            else if (!previousJobCards || (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat2 = previousJobCards.data) === null || _previousJobCards$dat2 === void 0 ? void 0 : _previousJobCards$dat2.length) < 0) {
                var _documentDetailsGetBy22;
                getPreviousJobCard(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy22 = documentDetailsGetById.data) === null || _documentDetailsGetBy22 === void 0 ? void 0 : _documentDetailsGetBy22.InstallBaseId);
            }
            if (![StatusEnum.Cancelled, StatusEnum.Closed, StatusEnum.Error].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy23 = documentDetailsGetById.data) === null || _documentDetailsGetBy23 === void 0 ? void 0 : _documentDetailsGetBy23.Key) || "")) {
                checkServiceContract(documentDetailsGetById.data.RepairTypeId, documentDetailsGetById.data.ODOMeterReading);
            }
        }
        else {
            var _previousJobCards$dat3;
            if (previousJobCards && (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat3 = previousJobCards.data) === null || _previousJobCards$dat3 === void 0 ? void 0 : _previousJobCards$dat3.length) > 0) {
                setPreviousJobcard(previousJobCards === null || previousJobCards === void 0 ? void 0 : previousJobCards.data[0]);
            }
            else if (vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.InstallBaseId || VehiclesDetailsList !== null && VehiclesDetailsList !== void 0 && VehiclesDetailsList.InstallBaseId) {
                var _documentDetailsGetBy24;
                getPreviousJobCard((vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy24 = documentDetailsGetById.data) === null || _documentDetailsGetBy24 === void 0 ? void 0 : _documentDetailsGetBy24.InstallBaseId));
            }
        }
        return function () {
            dispatch(resetState(['getAlertsByJobCardId']));
        };
    }, [documentDetailsGetById]);
    var checkServiceContract = function (serviceTypeId, usageReadingParam) { return __awaiter(void 0, void 0, void 0, function () {
        var _customerDetails$Mobi, _documentDetailsGetBy25, _customerDetails$Cust, _documentDetailsGetBy26, _validateServiceTypeR, _validateServiceTypeR2, isValid, request, validateServiceTypeResposne, _validateServiceTypeR3, _validateServiceTypeR4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validateDuplicateMobile(dispatch, {
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        MobileNo: (_customerDetails$Mobi = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber) !== null && _customerDetails$Mobi !== void 0 ? _customerDetails$Mobi : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy25 = documentDetailsGetById.data) === null || _documentDetailsGetBy25 === void 0 || (_documentDetailsGetBy25 = _documentDetailsGetBy25.PersonContactPoint) === null || _documentDetailsGetBy25 === void 0 || (_documentDetailsGetBy25 = _documentDetailsGetBy25.find(function (contact) { return contact.ContactType === EContactType.Primary; })) === null || _documentDetailsGetBy25 === void 0 ? void 0 : _documentDetailsGetBy25.MobileNumber,
                        CustomerId: (_customerDetails$Cust = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId) !== null && _customerDetails$Cust !== void 0 ? _customerDetails$Cust : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy26 = documentDetailsGetById.data) === null || _documentDetailsGetBy26 === void 0 ? void 0 : _documentDetailsGetBy26.CustomerId,
                        ServiceTypeId: serviceTypeId
                    })];
                case 1:
                    isValid = (_a.sent()).isValid;
                    if (!isValid)
                        return [2 /*return*/];
                    request = {
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        RepairTypeId: serviceTypeId,
                        Usage: Number(usageReadingParam),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ValidateServiceTypeURL,
                            request: request
                        }))];
                case 2:
                    validateServiceTypeResposne = _a.sent();
                    if (validateServiceTypeResposne !== null && validateServiceTypeResposne !== void 0 && (_validateServiceTypeR = validateServiceTypeResposne.payload) !== null && _validateServiceTypeR !== void 0 && (_validateServiceTypeR = _validateServiceTypeR.value) !== null && _validateServiceTypeR !== void 0 && _validateServiceTypeR.success && (validateServiceTypeResposne === null || validateServiceTypeResposne === void 0 || (_validateServiceTypeR2 = validateServiceTypeResposne.payload) === null || _validateServiceTypeR2 === void 0 || (_validateServiceTypeR2 = _validateServiceTypeR2.value) === null || _validateServiceTypeR2 === void 0 ? void 0 : _validateServiceTypeR2.statusCode) == 200) {
                        setServiceTypeError({
                            error: false,
                            errorMessage: ""
                        });
                        fetchFutureAdvice();
                    }
                    else {
                        setServiceTypeError({
                            error: true,
                            errorMessage: validateServiceTypeResposne !== null && validateServiceTypeResposne !== void 0 && (_validateServiceTypeR3 = validateServiceTypeResposne.payload) !== null && _validateServiceTypeR3 !== void 0 && (_validateServiceTypeR3 = _validateServiceTypeR3.value) !== null && _validateServiceTypeR3 !== void 0 && _validateServiceTypeR3.message ? validateServiceTypeResposne === null || validateServiceTypeResposne === void 0 || (_validateServiceTypeR4 = validateServiceTypeResposne.payload) === null || _validateServiceTypeR4 === void 0 || (_validateServiceTypeR4 = _validateServiceTypeR4.value) === null || _validateServiceTypeR4 === void 0 ? void 0 : _validateServiceTypeR4.message : "service type error"
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _filterList$serviceTy;
        if (documentDetailsGetById && documentDetailsGetById.data && filterList && ((_filterList$serviceTy = filterList.serviceType) === null || _filterList$serviceTy === void 0 ? void 0 : _filterList$serviceTy.length) > 0) {
            var _preDocumentFetch$dat;
            if (IsFromParentAPt || (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat = preDocumentFetch.data) === null || _preDocumentFetch$dat === void 0 ? void 0 : _preDocumentFetch$dat.length) > 0) {
                checkAMCAndOpenPopup();
            }
        }
    }, [documentDetailsGetById, filterList.serviceType]);
    useEffect(function () {
        var _documentDetailsGetBy27, _filterList$compaignL;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy27 = documentDetailsGetById.data) !== null && _documentDetailsGetBy27 !== void 0 && _documentDetailsGetBy27.CampaignId && (filterList === null || filterList === void 0 || (_filterList$compaignL = filterList.compaignList) === null || _filterList$compaignL === void 0 ? void 0 : _filterList$compaignL.length) > 0) {
            setCampaign(documentDetailsGetById.data.CampaignId);
        }
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy28 = documentDetailsGetById.data) === null || _documentDetailsGetBy28 === void 0 ? void 0 : _documentDetailsGetBy28.CampaignId, filterList.compaignList]);
    useEffect(function () {
        var _preDocumentFetch$dat2;
        if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat2 = preDocumentFetch.data) === null || _preDocumentFetch$dat2 === void 0 ? void 0 : _preDocumentFetch$dat2.length) > 0) {
            var _preDocumentFetch$dat3, _preDocumentFetch$dat5, _preDocumentFetch$dat7, _preDocumentFetch$dat9;
            if (preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat3 = preDocumentFetch.data) !== null && _preDocumentFetch$dat3 !== void 0 && (_preDocumentFetch$dat3 = _preDocumentFetch$dat3[0]) !== null && _preDocumentFetch$dat3 !== void 0 && _preDocumentFetch$dat3.OrganizationStateCode) {
                var _preDocumentFetch$dat4;
                setOrganizationStateCode(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat4 = preDocumentFetch.data) === null || _preDocumentFetch$dat4 === void 0 || (_preDocumentFetch$dat4 = _preDocumentFetch$dat4[0]) === null || _preDocumentFetch$dat4 === void 0 ? void 0 : _preDocumentFetch$dat4.OrganizationStateCode);
            }
            if (preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat5 = preDocumentFetch.data) !== null && _preDocumentFetch$dat5 !== void 0 && (_preDocumentFetch$dat5 = _preDocumentFetch$dat5[0]) !== null && _preDocumentFetch$dat5 !== void 0 && _preDocumentFetch$dat5.CustomerStateCode) {
                var _preDocumentFetch$dat6;
                setCustomerStateCode(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat6 = preDocumentFetch.data) === null || _preDocumentFetch$dat6 === void 0 || (_preDocumentFetch$dat6 = _preDocumentFetch$dat6[0]) === null || _preDocumentFetch$dat6 === void 0 ? void 0 : _preDocumentFetch$dat6.CustomerStateCode);
            }
            if (preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat7 = preDocumentFetch.data) !== null && _preDocumentFetch$dat7 !== void 0 && (_preDocumentFetch$dat7 = _preDocumentFetch$dat7[0]) !== null && _preDocumentFetch$dat7 !== void 0 && _preDocumentFetch$dat7.OrganizationStateCodeReferenceId) {
                var _preDocumentFetch$dat8;
                setOrganizationStateCodeReferenceId(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat8 = preDocumentFetch.data) === null || _preDocumentFetch$dat8 === void 0 || (_preDocumentFetch$dat8 = _preDocumentFetch$dat8[0]) === null || _preDocumentFetch$dat8 === void 0 ? void 0 : _preDocumentFetch$dat8.OrganizationStateCodeReferenceId);
            }
            if (preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat9 = preDocumentFetch.data) !== null && _preDocumentFetch$dat9 !== void 0 && (_preDocumentFetch$dat9 = _preDocumentFetch$dat9[0]) !== null && _preDocumentFetch$dat9 !== void 0 && _preDocumentFetch$dat9.CustomerStateCodeReferenceId) {
                var _preDocumentFetch$dat10;
                setCustomerStateCodeReferenceId(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat10 = preDocumentFetch.data) === null || _preDocumentFetch$dat10 === void 0 || (_preDocumentFetch$dat10 = _preDocumentFetch$dat10[0]) === null || _preDocumentFetch$dat10 === void 0 ? void 0 : _preDocumentFetch$dat10.CustomerStateCodeReferenceId);
            }
            if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV) {
                var _a = preDocumentFetch.data[0], VinNo = _a.VinNo, ODOMeterReading = _a.ODOMeterReading, RepairTypeId = _a.RepairTypeId;
                validateTechpackExipry(VinNo, ODOMeterReading, RepairTypeId);
            }
        }
    }, [preDocumentFetch, IsFromParentAPt]);
    var checkAMCAndOpenPopup = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy29, _documentDetailsGetBy30, checkAMCContractAvailable, _documentDetailsGetBy31, _documentDetailsGetBy32;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkAMCContract(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy29 = documentDetailsGetById.data) === null || _documentDetailsGetBy29 === void 0 ? void 0 : _documentDetailsGetBy29.RepairTypeId, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy30 = documentDetailsGetById.data) === null || _documentDetailsGetBy30 === void 0 ? void 0 : _documentDetailsGetBy30.ODOMeterReading)];
                case 1:
                    checkAMCContractAvailable = _a.sent();
                    if (checkAMCContractAvailable) {
                        setOpenAmcContractPopup(true);
                    }
                    else if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV) {
                        checkBajajCareAMC(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy31 = documentDetailsGetById.data) === null || _documentDetailsGetBy31 === void 0 ? void 0 : _documentDetailsGetBy31.RepairTypeId, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy32 = documentDetailsGetById.data) === null || _documentDetailsGetBy32 === void 0 ? void 0 : _documentDetailsGetBy32.ODOMeterReading);
                    }
                    else if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.PB || (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.Triumph) {
                        checkFFMContract(Number(documentDetailsGetById.data.ODOMeterReading));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (documentDetailsGetById && documentDetailsGetById.data) {
            if (repeatReasonConfig !== null && repeatReasonConfig !== void 0 && repeatReasonConfig.Transaction && Array.isArray(repeatReasonConfig === null || repeatReasonConfig === void 0 ? void 0 : repeatReasonConfig.Transaction) && repeatReasonConfig !== null && repeatReasonConfig !== void 0 && repeatReasonConfig.Transaction.includes(SystemName)) {
                if (IsFromParentAPt) {
                    checkRepeatCall(true, Number(documentDetailsGetById.data.ODOMeterReading), true, documentDetailsGetById.data.RepairTypeId);
                }
                else {
                    checkRepeatCall(false, Number(documentDetailsGetById.data.ODOMeterReading), true, documentDetailsGetById.data.RepairTypeId);
                }
            }
        }
    }, [documentDetailsGetById, repeatReasonConfig]);
    var GetServiceAdvisor = function (branchId) { return __awaiter(void 0, void 0, void 0, function () {
        var _serviceAdvisors$, _advisorList$payload, _advisorList$payload2, request, advisorList, _advisorList$payload3, _filteredList$, advisor_1, FinalAdvisorList, filteredList, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    if (!CreatedFlow) return [3 /*break*/, 1];
                    setServiceAdvisorList(serviceAdvisors);
                    setAdvisor((_serviceAdvisors$ = serviceAdvisors[0]) === null || _serviceAdvisors$ === void 0 ? void 0 : _serviceAdvisors$.UserId);
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 2:
                    _a.sent();
                    request = {
                        BranchId: branchId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "advisorList",
                            url: AppointmentServiceAdvisorList,
                            request: request
                        }))];
                case 3:
                    advisorList = _a.sent();
                    if (!((advisorList === null || advisorList === void 0 || (_advisorList$payload = advisorList.payload) === null || _advisorList$payload === void 0 || (_advisorList$payload = _advisorList$payload.value) === null || _advisorList$payload === void 0 ? void 0 : _advisorList$payload.statusCode) == 200 || advisorList !== null && advisorList !== void 0 && (_advisorList$payload2 = advisorList.payload) !== null && _advisorList$payload2 !== void 0 && (_advisorList$payload2 = _advisorList$payload2.value) !== null && _advisorList$payload2 !== void 0 && _advisorList$payload2.success)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 4:
                    _a.sent();
                    advisor_1 = advisorList === null || advisorList === void 0 || (_advisorList$payload3 = advisorList.payload) === null || _advisorList$payload3 === void 0 || (_advisorList$payload3 = _advisorList$payload3.value) === null || _advisorList$payload3 === void 0 ? void 0 : _advisorList$payload3.data;
                    FinalAdvisorList = advisor_1 === null || advisor_1 === void 0 ? void 0 : advisor_1.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        advisorName: item.GivenName && item.FamilyName ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : null
                    }); });
                    filteredList = FinalAdvisorList.filter(function (item, index) {
                        var _documentDetailsGetBy33;
                        return item.UserId == ((_documentDetailsGetBy33 = documentDetailsGetById.data) === null || _documentDetailsGetBy33 === void 0 ? void 0 : _documentDetailsGetBy33.AssignedEmployeeId);
                    });
                    setAdvisor((_filteredList$ = filteredList[0]) === null || _filteredList$ === void 0 ? void 0 : _filteredList$.UserId);
                    setServiceAdvisorList(filteredList);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_6 = _a.sent();
                    console.error("Error fetching vehicle types:", error_6);
                    return [2 /*return*/, []];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getCoverageTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload3, _a, key, _b, request, _c, url, res;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = params.key, key = _a === void 0 ? JobCardKeys.CoverageTypeList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ByCoverageTypeUrl : _c;
                    request.InsuranceProviderId = params;
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: key,
                            url: url,
                            request: request
                        }))];
                case 1:
                    res = _d.sent();
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
            }
        });
    }); };
    var fetchInsuranceProviders = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInsuranceProviderList({})];
                case 1:
                    response = _a.sent();
                    setInsuranceProviderList((response === null || response === void 0 ? void 0 : response.data) || []);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchLossTypeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLossTypeList({})];
                case 1:
                    response = _a.sent();
                    setLossTypeList((response === null || response === void 0 ? void 0 : response.data) || []);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchAlllistData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var repairTypeList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, Promise.all([GetRepairType()
                            // getCompaginList(),
                            // getUcnDetails()
                        ])];
                case 2:
                    repairTypeList = (_a.sent())[0];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    setFilterList(_objectSpread(_objectSpread({}, filterList), {}, {
                        serviceType: repairTypeList
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var GetRepairType = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy34, _repairType$payload, _repairType$payload2, request, _documentDetailsGetBy35, repairType, _repairType$payload3, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        ModuleEntityId: SystemName,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy34 = documentDetailsGetById.data) !== null && _documentDetailsGetBy34 !== void 0 && _documentDetailsGetBy34.ProductId) {
                        request.ProductId = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy35 = documentDetailsGetById.data) === null || _documentDetailsGetBy35 === void 0 ? void 0 : _documentDetailsGetBy35.ProductId;
                    }
                    else {
                        request.ProductId = vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "repairTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        return [2 /*return*/, repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error("Error fetching repair types:", e_1);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getCompaginList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy36, _documentDetailsGetBy37, _result$payload$value, _result$payload4, request, _documentDetailsGetBy38, result, _result$payload5, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        // ProductId: VehiclesDetailsList?.ProductId,
                        ServiceTypeId: serviceType || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy36 = documentDetailsGetById.data) === null || _documentDetailsGetBy36 === void 0 ? void 0 : _documentDetailsGetBy36.RepairTypeId),
                        ModuleEntityId: null //need to change moduleid as system name in future after configure
                    };
                    if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy37 = documentDetailsGetById.data) !== null && _documentDetailsGetBy37 !== void 0 && _documentDetailsGetBy37.ProductId) {
                        request.ProductId = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy38 = documentDetailsGetById.data) === null || _documentDetailsGetBy38 === void 0 ? void 0 : _documentDetailsGetBy38.ProductId;
                    }
                    else {
                        request.ProductId = vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: GetCompaignList,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload$value = result.payload.value) === null || _result$payload$value === void 0 ? void 0 : _result$payload$value.statusCode) === 200 || result !== null && result !== void 0 && (_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && _result$payload4.success) {
                        return [2 /*return*/, result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.value) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_7 = _a.sent();
                    console.error("Error fetching compagin List:", error_7);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getNatureOfAccidentList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, result, _result$payload6, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {};
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'natureOfAccidentList',
                            url: NatureOfAccidentListUrl,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result.payload.statusCode === 200 || result.payload.success) {
                        return [2 /*return*/, (_result$payload6 = result.payload) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.data];
                    }
                    else {
                        console.error("Failed to fetch Nature of Accident List:", result.payload);
                        return [2 /*return*/, []];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_8 = _a.sent();
                    console.error("Error fetching Nature of Accident List:", error_8);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Odometer setting API call
     */
    var isOdometerEnable = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, 5, 7]);
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "isOdometerAllowed",
                            url: odometerStatus,
                            request: {
                                TransactionEntity: SystemName
                            }
                        }))];
                case 3:
                    response = _a.sent();
                    setIsOdometerVisible((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.IsChangeOdometer) === 1 ? true : false);
                    return [3 /*break*/, 7];
                case 4:
                    err_1 = _a.sent();
                    console.log("Error while fetching odometer status", err_1);
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 6:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    /**
     *
     * @param e Enable odometer pop up box
     */
    var handleChange = function (e) {
        setIsOdometerChecked(e.target.checked), setIsopen(true);
    };
    var getMaxOdometerValue = function () {
        return 999999;
    };
    var handleOdometerReading = function (e) {
        var value = e.target.value;
        if (["0"].includes(value.charAt(0))) {
            setUsageReading('');
        }
        else {
            value = value.replace(REG.nonNumericNumber, '');
            setUsageReading(value);
        }
        if (!value) {
            setKmReadingValidation(false);
        }
        dispatch(setDocDataUpdated(true));
        dispatch(resetState(['getAlertsByJobCardId']));
    };
    var serviceTypeValidation = function (usageReadingParam, serviceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var _customerDetails$Mobi2, _documentDetailsGetBy39, _customerDetails$Cust2, _documentDetailsGetBy40, _validateServiceType$, _validateServiceType$2, isServieTypeValid, currentServiceType, isValid, request, validateServiceType, _validateServiceType$3, _validateServiceType$4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isServieTypeValid = false;
                    currentServiceType = serviceTypeId ? serviceTypeId : serviceType;
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, validateDuplicateMobile(dispatch, {
                            InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            MobileNo: (_customerDetails$Mobi2 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber) !== null && _customerDetails$Mobi2 !== void 0 ? _customerDetails$Mobi2 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy39 = documentDetailsGetById.data) === null || _documentDetailsGetBy39 === void 0 || (_documentDetailsGetBy39 = _documentDetailsGetBy39.PersonContactPoint) === null || _documentDetailsGetBy39 === void 0 || (_documentDetailsGetBy39 = _documentDetailsGetBy39.find(function (contact) { return contact.ContactType === EContactType.Primary; })) === null || _documentDetailsGetBy39 === void 0 ? void 0 : _documentDetailsGetBy39.MobileNumber,
                            CustomerId: (_customerDetails$Cust2 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId) !== null && _customerDetails$Cust2 !== void 0 ? _customerDetails$Cust2 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy40 = documentDetailsGetById.data) === null || _documentDetailsGetBy40 === void 0 ? void 0 : _documentDetailsGetBy40.CustomerId,
                            ServiceTypeId: currentServiceType
                        })];
                case 1:
                    isValid = (_a.sent()).isValid;
                    if (!!isValid) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 2:
                    _a.sent();
                    setServiceType('');
                    setUsageReading('');
                    setAccidentalDetailsConfig(null);
                    dispatch(setDocDataUpdated(true));
                    return [2 /*return*/, isServieTypeValid];
                case 3:
                    request = {
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        RepairTypeId: currentServiceType,
                        Usage: Number(usageReadingParam),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ValidateServiceTypeURL,
                            request: request
                        }))];
                case 4:
                    validateServiceType = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    if (validateServiceType !== null && validateServiceType !== void 0 && (_validateServiceType$ = validateServiceType.payload) !== null && _validateServiceType$ !== void 0 && (_validateServiceType$ = _validateServiceType$.value) !== null && _validateServiceType$ !== void 0 && _validateServiceType$.success && (validateServiceType === null || validateServiceType === void 0 || (_validateServiceType$2 = validateServiceType.payload) === null || _validateServiceType$2 === void 0 || (_validateServiceType$2 = _validateServiceType$2.value) === null || _validateServiceType$2 === void 0 ? void 0 : _validateServiceType$2.statusCode) == 200) {
                        fetchFutureAdvice();
                        isServieTypeValid = true;
                        setIsServiceTypeValidForDocument(serviceType ? UCN_ALLOWED_REPAIR_TYPES.includes(serviceType) : false);
                        setServiceType(serviceType);
                        setServiceTypeError({
                            error: false,
                            errorMessage: ""
                        });
                    }
                    else {
                        setServiceType('');
                        setUsageReading("");
                        setServiceTypeError({
                            error: true,
                            errorMessage: validateServiceType !== null && validateServiceType !== void 0 && (_validateServiceType$3 = validateServiceType.payload) !== null && _validateServiceType$3 !== void 0 && (_validateServiceType$3 = _validateServiceType$3.value) !== null && _validateServiceType$3 !== void 0 && _validateServiceType$3.message ? validateServiceType === null || validateServiceType === void 0 || (_validateServiceType$4 = validateServiceType.payload) === null || _validateServiceType$4 === void 0 || (_validateServiceType$4 = _validateServiceType$4.value) === null || _validateServiceType$4 === void 0 ? void 0 : _validateServiceType$4.message : "service type error"
                        });
                        setAccidentalDetailsConfig(null);
                    }
                    dispatch(setDocDataUpdated(true));
                    return [2 /*return*/, isServieTypeValid];
            }
        });
    }); };
    var validateTecPackIsExistsOrNot = function (usageReadingParam, serviceContractId) { return __awaiter(void 0, void 0, void 0, function () {
        var _validateServiceTypeR5, requestBody, validateServiceTypeRes, _validateServiceTypeR6, _validateServiceTypeR8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        ServiceContractId: serviceContractId,
                        Usage: usageReadingParam
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ValidateServiceContractForTecPackURL,
                            request: requestBody
                        }))];
                case 1:
                    validateServiceTypeRes = _a.sent();
                    if (validateServiceTypeRes !== null && validateServiceTypeRes !== void 0 && (_validateServiceTypeR5 = validateServiceTypeRes.payload) !== null && _validateServiceTypeR5 !== void 0 && (_validateServiceTypeR5 = _validateServiceTypeR5.value) !== null && _validateServiceTypeR5 !== void 0 && _validateServiceTypeR5.success) {
                        if (validateServiceTypeRes !== null && validateServiceTypeRes !== void 0 && (_validateServiceTypeR6 = validateServiceTypeRes.payload) !== null && _validateServiceTypeR6 !== void 0 && (_validateServiceTypeR6 = _validateServiceTypeR6.value) !== null && _validateServiceTypeR6 !== void 0 && _validateServiceTypeR6.IsTecPack) {
                            setTechPackPopup(_objectSpread(_objectSpread({}, techPackPopup), {}, {
                                open: true,
                                heading: "Tech Pack subscription is available!",
                                description: "Tech Pack service contract exists. Do you want to proceed with selecting the service type as Tech Pack?",
                                popupType: "info",
                                declineButton: {
                                    text: "No",
                                    onClick: techPackPopup.onClose,
                                    type: "outlined",
                                    fullWidth: IS_MOBILE ? true : false
                                },
                                acceptButton: {
                                    text: "Yes",
                                    onClick: function () {
                                        var _validateServiceTypeR7;
                                        var techPackServiceTypeID = (validateServiceTypeRes === null || validateServiceTypeRes === void 0 || (_validateServiceTypeR7 = validateServiceTypeRes.payload) === null || _validateServiceTypeR7 === void 0 || (_validateServiceTypeR7 = _validateServiceTypeR7.value) === null || _validateServiceTypeR7 === void 0 || (_validateServiceTypeR7 = _validateServiceTypeR7.data) === null || _validateServiceTypeR7 === void 0 ? void 0 : _validateServiceTypeR7.ServiceContractId) || '';
                                        setServiceType(techPackServiceTypeID);
                                        techPackPopup.onClose();
                                    },
                                    type: "contained",
                                    fullWidth: IS_MOBILE ? true : false
                                }
                            }));
                        }
                        setServiceTypeError({
                            error: false,
                            errorMessage: ""
                        });
                    }
                    else {
                        setServiceType('');
                        setUsageReading('');
                        setServiceTypeError({
                            error: true,
                            errorMessage: (validateServiceTypeRes === null || validateServiceTypeRes === void 0 || (_validateServiceTypeR8 = validateServiceTypeRes.payload) === null || _validateServiceTypeR8 === void 0 || (_validateServiceTypeR8 = _validateServiceTypeR8.value) === null || _validateServiceTypeR8 === void 0 ? void 0 : _validateServiceTypeR8.message) || "service type error"
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var validateTechpackExipry = function (VinNo, odometerReading, repairTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var _validateResult$paylo, _validateResult$paylo2, validateRequest, validateResult, effectiveToDate, currentDate, diffTime, diffDays, _validateResult$paylo3, _validateResult$paylo4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    validateRequest = {
                        VinNo: VinNo
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "validateTechpackExpiry",
                            url: ValidateTechpackExpiryURL,
                            request: validateRequest
                        }))];
                case 2:
                    validateResult = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    effectiveToDate = new Date(validateResult === null || validateResult === void 0 || (_validateResult$paylo = validateResult.payload) === null || _validateResult$paylo === void 0 || (_validateResult$paylo = _validateResult$paylo.value) === null || _validateResult$paylo === void 0 ? void 0 : _validateResult$paylo.EffectiveTo);
                    currentDate = new Date();
                    diffTime = effectiveToDate.getTime() - currentDate.getTime();
                    diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    if (validateResult !== null && validateResult !== void 0 && (_validateResult$paylo2 = validateResult.payload) !== null && _validateResult$paylo2 !== void 0 && (_validateResult$paylo2 = _validateResult$paylo2.value) !== null && _validateResult$paylo2 !== void 0 && _validateResult$paylo2.success) {
                        if (!(validateResult !== null && validateResult !== void 0 && (_validateResult$paylo3 = validateResult.payload) !== null && _validateResult$paylo3 !== void 0 && (_validateResult$paylo3 = _validateResult$paylo3.value) !== null && _validateResult$paylo3 !== void 0 && _validateResult$paylo3.IsExpired) && validateResult !== null && validateResult !== void 0 && (_validateResult$paylo4 = validateResult.payload) !== null && _validateResult$paylo4 !== void 0 && (_validateResult$paylo4 = _validateResult$paylo4.value) !== null && _validateResult$paylo4 !== void 0 && _validateResult$paylo4.ShowPopUp) {
                            setTechPackPopup(_objectSpread(_objectSpread({}, techPackPopup), {}, {
                                open: true,
                                heading: "Tech Pack subscription about to expire!",
                                description: /*#__PURE__*/ React.createElement(React.Fragment, null, "\"Tech Pack subscription is about to expire on ", /*#__PURE__*/ React.createElement("span", {
                                    style: {
                                        color: '#000'
                                    }
                                }, formatDate(effectiveToDate)), ". Kindly renew the Tech Pack to continue enjoying the benefits"),
                                popupType: "warning",
                                declineButton: null,
                                acceptButton: {
                                    text: "Ok",
                                    onClick: function () {
                                        techPackPopup.onClose();
                                        validateTecPackIsExistsOrNot(odometerReading, repairTypeId);
                                    },
                                    type: "contained",
                                    fullWidth: true
                                },
                                onClose: function () {
                                    techPackPopup.onClose();
                                    validateTecPackIsExistsOrNot(odometerReading, repairTypeId);
                                }
                            }));
                        }
                        else {
                            validateTecPackIsExistsOrNot(odometerReading, repairTypeId);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var setAlertsListFunction = function (data, showAlerts) {
        setAlertsList(data);
        if ((data === null || data === void 0 ? void 0 : data.length) > 0 && showAlerts) {
            setShowAlerts(true);
            dispatch(showNotification({
                isOpen: true,
                message: "Selected vehicle is revisited",
                type: "warning"
            }));
        }
    };
    var checkRepeatCall = function (showAlerts, CurrentODOMeterReading, isGetAlerts, serviceTypeId, createdDocumentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy41, _documentDetailsGetBy42, repeatBody, checkRepeatResponse, _getAlertsByJobCardId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(repeatReasonConfig !== null && repeatReasonConfig !== void 0 && repeatReasonConfig.Transaction && Array.isArray(repeatReasonConfig === null || repeatReasonConfig === void 0 ? void 0 : repeatReasonConfig.Transaction) && repeatReasonConfig !== null && repeatReasonConfig !== void 0 && repeatReasonConfig.Transaction.includes(SystemName))) return [3 /*break*/, 2];
                    repeatBody = {
                        "InstallBaseId": vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId,
                        "CurrentODOMeterReading": CurrentODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": serviceTypeId,
                        "ParentId": createdDocumentId ? createdDocumentId : IsFromParentAPt ? null : documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy41 = documentDetailsGetById.data) !== null && _documentDetailsGetBy41 !== void 0 && _documentDetailsGetBy41.id ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy42 = documentDetailsGetById.data) === null || _documentDetailsGetBy42 === void 0 ? void 0 : _documentDetailsGetBy42.id : null,
                        "CurrentComplaints": [],
                        "CurrentParts": [],
                        "CurrentLabours": []
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 1:
                    checkRepeatResponse = _a.sent();
                    // const checkRevisitResponse = await dispatch(createAPI({ url: CheckRevisitUrl, request: repeatBody }));
                    if (isGetAlerts) {
                        if (Object.keys(getAlertsByJobCardId).length == 0) {
                            getDocumentAlerts(showAlerts);
                        }
                        else {
                            setAlertsListFunction(getAlertsByJobCardId === null || getAlertsByJobCardId === void 0 || (_getAlertsByJobCardId = getAlertsByJobCardId.data) === null || _getAlertsByJobCardId === void 0 ? void 0 : _getAlertsByJobCardId.Alerts, showAlerts);
                        }
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var ValidateMobileNumber = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            //   const requestBody = {
            //     "InstallBaseId": vehicleDetails?.InstallBaseId,
            //     "MobileNo": customerDetails.MobileNumber,
            //     "CustomerId": customerDetails?.CustomerId,
            //     "RepairTypeId": serviceType,
            //     "OrganizationId": selectedBranch?.OrganizationId
            //   }
            //   const validateMobileRes: any = await dispatch(getListAPI({ key: "", url: validateMobileNoURL, request: requestBody }))
            //   if (validateMobileRes.payload.value.success) {
            //     setValidateMobileError({
            //       error: false,
            //       errorMessage: ""
            //     })
            //     return true
            //   } else {
            //     setValidateMobileError({
            //       error: true,
            //       errorMessage: validateMobileRes?.payload?.value?.message
            //     })
            //     return false
            //   }
            //Commenting implementation as it will be provide PBI instead of bug 223381
            return [2 /*return*/, true];
        });
    }); };
    var odometerReading = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var validateRes, isServiceTypeValid, isKmReadingValid, _preDocumentFetch$dat11, _preDocumentFetch$dat12, _result$payload7, _result$payload8, requestBody, result, _result$payload9, _result$payload10, _result$payload11, _result$payload12, _result$payload13, _result$payload14, _result$payload15, request, validateOdometerReading, validateAbnormalReading, _ref2, _validateOdometerRead, _validateOdometerRead2, _validateAbnormalRead, _documentDetailsGetBy43, _documentDetailsGetBy44, _documentDetailsGetBy45, _response$payload2, _response$payload3, _response$payload6, _response$payload7, requestBodyForValidationOfReading, response, _response$payload4, _response$payload5, _response$payload8, _response$payload9, checkAMCContractAvailable, bajajCareAMCContractAvailable, _e$target;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // let element = document?.getElementById("serviceType-input")
                // element?.focus()
                return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    // let element = document?.getElementById("serviceType-input")
                    // element?.focus()
                    _a.sent();
                    return [4 /*yield*/, ValidateMobileNumber()];
                case 2:
                    validateRes = _a.sent();
                    if (!validateRes) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        return [2 /*return*/];
                    }
                    setUsageReading(e.target.value);
                    if (!e.target.value) return [3 /*break*/, 18];
                    isServiceTypeValid = false;
                    isKmReadingValid = false;
                    if (!CreatedFlow) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 3:
                    _a.sent();
                    requestBody = {
                        InstallBaseId: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        KMReading: Number(e.target.value),
                        ParentId: (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat11 = preDocumentFetch.data) === null || _preDocumentFetch$dat11 === void 0 ? void 0 : _preDocumentFetch$dat11.length) > 0 ? preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat12 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat12 === void 0 ? void 0 : _preDocumentFetch$dat12.PreJobCardDocumentId : null
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: validateDocumentURL,
                            request: requestBody
                        }))];
                case 5:
                    result = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 6:
                    _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload7 = result.payload) !== null && _result$payload7 !== void 0 && (_result$payload7 = _result$payload7.value) !== null && _result$payload7 !== void 0 && _result$payload7.success && (result === null || result === void 0 || (_result$payload8 = result.payload) === null || _result$payload8 === void 0 || (_result$payload8 = _result$payload8.value) === null || _result$payload8 === void 0 ? void 0 : _result$payload8.statusCode) == 200) {
                        createUILog({
                            "Body": _objectSpread(_objectSpread({}, requestBody), {}, {
                                "URL": validateDocumentURL,
                                "ParentId": documentId
                            }),
                            "Response": result === null || result === void 0 || (_result$payload9 = result.payload) === null || _result$payload9 === void 0 ? void 0 : _result$payload9.value
                        });
                        isKmReadingValid = true;
                        setKmReadingValidation(true);
                        setUsageReadingError({
                            error: false,
                            errorMessage: ""
                        });
                        setOrganizationStateCode(result === null || result === void 0 || (_result$payload10 = result.payload) === null || _result$payload10 === void 0 || (_result$payload10 = _result$payload10.value.data) === null || _result$payload10 === void 0 ? void 0 : _result$payload10.OrganizationStateCode);
                        setCustomerStateCode(result === null || result === void 0 || (_result$payload11 = result.payload) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.value.data) === null || _result$payload11 === void 0 ? void 0 : _result$payload11.CustomerStateCode);
                        setOrganizationStateCodeReferenceId(result === null || result === void 0 || (_result$payload12 = result.payload) === null || _result$payload12 === void 0 || (_result$payload12 = _result$payload12.value.data) === null || _result$payload12 === void 0 ? void 0 : _result$payload12.OrganizationStateCodeReferenceId);
                        setCustomerStateCodeReferenceId(result === null || result === void 0 || (_result$payload13 = result.payload) === null || _result$payload13 === void 0 || (_result$payload13 = _result$payload13.value.data) === null || _result$payload13 === void 0 ? void 0 : _result$payload13.CustomerStateCodeReferenceId);
                    }
                    else {
                        isKmReadingValid = false;
                        setKmReadingValidation(false);
                        setUsageReadingError({
                            error: true,
                            errorMessage: result !== null && result !== void 0 && (_result$payload14 = result.payload) !== null && _result$payload14 !== void 0 && (_result$payload14 = _result$payload14.value) !== null && _result$payload14 !== void 0 && _result$payload14.message ? result === null || result === void 0 || (_result$payload15 = result.payload) === null || _result$payload15 === void 0 || (_result$payload15 = _result$payload15.value) === null || _result$payload15 === void 0 ? void 0 : _result$payload15.message : "odometer reading error"
                        });
                    }
                    _a.label = 7;
                case 7:
                    if (!UpdateFlow) return [3 /*break*/, 10];
                    request = {
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
                        KMReading: Number(e.target.value),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        SystemName: SystemName
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: CheckKMUrl,
                            request: request
                        }))];
                case 8:
                    validateOdometerReading = _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: validateAbnormalKMReadingURL,
                            request: request
                        }))];
                case 9:
                    validateAbnormalReading = _a.sent();
                    if (validateOdometerReading.payload.value.success && validateOdometerReading.payload.value.statusCode == 200 && validateAbnormalReading.payload.value.success && validateAbnormalReading.payload.value.statusCode == 200) {
                        isKmReadingValid = true;
                        setKmReadingValidation(true);
                        setUsageReadingError({
                            error: false,
                            errorMessage: ""
                        });
                    }
                    else {
                        isKmReadingValid = false;
                        setKmReadingValidation(false);
                        setUsageReadingError({
                            error: true,
                            errorMessage: (_ref2 = (_validateOdometerRead = validateOdometerReading === null || validateOdometerReading === void 0 || (_validateOdometerRead2 = validateOdometerReading.payload) === null || _validateOdometerRead2 === void 0 || (_validateOdometerRead2 = _validateOdometerRead2.value) === null || _validateOdometerRead2 === void 0 ? void 0 : _validateOdometerRead2.message) !== null && _validateOdometerRead !== void 0 ? _validateOdometerRead : validateAbnormalReading === null || validateAbnormalReading === void 0 || (_validateAbnormalRead = validateAbnormalReading.payload) === null || _validateAbnormalRead === void 0 || (_validateAbnormalRead = _validateAbnormalRead.value) === null || _validateAbnormalRead === void 0 ? void 0 : _validateAbnormalRead.message) !== null && _ref2 !== void 0 ? _ref2 : "odometer reading error"
                        });
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    _a.label = 10;
                case 10:
                    if (!(serviceType && isKmReadingValid)) return [3 /*break*/, 18];
                    requestBodyForValidationOfReading = {
                        ChannelId: storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId,
                        ChannelPartnerId: ChannelPartnerId === null || ChannelPartnerId === void 0 ? void 0 : ChannelPartnerId.ChannelPartnerId,
                        ProductId: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy43 = documentDetailsGetById.data) !== null && _documentDetailsGetBy43 !== void 0 && _documentDetailsGetBy43.ProductId ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy44 = documentDetailsGetById.data) === null || _documentDetailsGetBy44 === void 0 ? void 0 : _documentDetailsGetBy44.ProductId : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductId,
                        TransactionEntityId: SystemName,
                        RegistrationNo: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.RegistrationNo,
                        OdometerReading: Number(e.target.value),
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy45 = documentDetailsGetById.data) === null || _documentDetailsGetBy45 === void 0 ? void 0 : _documentDetailsGetBy45.InstallBaseId)
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'AbnormalOdometerCheck',
                            url: ValidateOdometerUrl,
                            request: requestBodyForValidationOfReading
                        }))];
                case 11:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 400 && (response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.IsValidationBlocked) == 1) {
                        setUsageReadingError({
                            error: true,
                            errorMessage: response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.message
                        });
                        dispatch(showNotification({
                            isOpen: true,
                            message: response === null || response === void 0 || (_response$payload5 = response.payload) === null || _response$payload5 === void 0 || (_response$payload5 = _response$payload5.value) === null || _response$payload5 === void 0 ? void 0 : _response$payload5.message,
                            type: "error"
                        }));
                    }
                    else if ((response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 || (_response$payload6 = _response$payload6.value) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.statusCode) == 400 && (response === null || response === void 0 || (_response$payload7 = response.payload) === null || _response$payload7 === void 0 || (_response$payload7 = _response$payload7.value) === null || _response$payload7 === void 0 ? void 0 : _response$payload7.IsValidationBlocked) == 0) {
                        setUsageReadingError({
                            error: false,
                            errorMessage: response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.message
                        });
                        dispatch(showNotification({
                            isOpen: true,
                            message: response === null || response === void 0 || (_response$payload9 = response.payload) === null || _response$payload9 === void 0 || (_response$payload9 = _response$payload9.value) === null || _response$payload9 === void 0 ? void 0 : _response$payload9.message,
                            type: "warning"
                        }));
                    }
                    return [4 /*yield*/, checkAMCContract(serviceType, e.target.value)];
                case 12:
                    checkAMCContractAvailable = _a.sent();
                    if (!checkAMCContractAvailable) return [3 /*break*/, 13];
                    setOpenAmcContractPopup(true);
                    return [3 /*break*/, 17];
                case 13:
                    bajajCareAMCContractAvailable = false;
                    if (!((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV)) return [3 /*break*/, 15];
                    return [4 /*yield*/, checkBajajCareAMC(serviceType, Number(e.target.value))];
                case 14:
                    bajajCareAMCContractAvailable = _a.sent();
                    _a.label = 15;
                case 15:
                    if (!!bajajCareAMCContractAvailable) return [3 /*break*/, 17];
                    return [4 /*yield*/, serviceTypeValidation(e.target.value)];
                case 16:
                    isServiceTypeValid = _a.sent();
                    if (isServiceTypeValid && (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV) {
                        validateTecPackIsExistsOrNot(e.target.value, serviceType);
                    }
                    _a.label = 17;
                case 17:
                    if (isServiceTypeValid && isKmReadingValid) {
                        checkRepeatCall(true, e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value, true, serviceType);
                        if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.PB || (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.Triumph) {
                            checkFFMContract(Number(e.target.value));
                        }
                    }
                    _a.label = 18;
                case 18: return [2 /*return*/];
            }
        });
    }); };
    var handleServiceType = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target, _event$target2, _event$target3, _event$target4;
        return __generator(this, function (_a) {
            dispatch(resetState(['campaignListData', getDefaultKey('campaignListData')]));
            if (event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value) {
                serviceTypeRef.current = event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value;
                setServiceType(event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value);
                setUsageReading("");
                setCampaign(null);
                setKmReadingValidation(false);
                setIsServiceTypeValidForDocument(false);
                setUcnCode("");
                setUcnHelperText(UCN_HELPER_TEXT_STATE.INFO);
                setUcnState(IsSendUCNDisabled ? 'Check UCN' : UCN_CODE_SOURCE === 'SMS' ? 'Send' : "Apply");
                setExistingUcnDetails(null);
                setServiceTypeError({
                    error: false,
                    errorMessage: ""
                });
                // validateTecPackIsExistsOrNot(event?.target?.value)
                getActiveAccidentalConfiguration(event === null || event === void 0 || (_event$target4 = event.target) === null || _event$target4 === void 0 ? void 0 : _event$target4.value);
            }
            return [2 /*return*/];
        });
    }); };
    var handleInputBox = function (event) {
        setCustomerComplanit(event.target.value);
        dispatch(setDocDataUpdated(true));
    };
    var onCalendarDateClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload16, request, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSkeleton(true);
                    setDateValue(e);
                    setSelectedTimeSlot("");
                    setTimeSlotData([]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        Date: new Date(e).toISOString() // date format issue
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "getSlotDetails",
                            url: getSlotAPI,
                            request: request
                        }))];
                case 2:
                    result = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    setTimeSlotData(result === null || result === void 0 || (_result$payload16 = result.payload) === null || _result$payload16 === void 0 || (_result$payload16 = _result$payload16.value) === null || _result$payload16 === void 0 ? void 0 : _result$payload16.data);
                    setIsSkeleton(false);
                    dispatch(setDocDataUpdated(true));
                    return [2 /*return*/];
            }
        });
    }); };
    var onTimeSlotSelectedClick = function (item) {
        setSelectedTimeSlot(item);
        dispatch(setDocDataUpdated(true));
    };
    var validateAccidentalDetails = function () {
        if (accidentalDetailsConfig) {
            var _accidentalDetailsCon, _accidentalDetailsCon2;
            // Map accidentalDetailsConfig field names to values state keys
            var mandatoryFields = Object.entries(accidentalDetailsConfig).filter(function (_ref3) {
                var field = _ref3[0], config = _ref3[1];
                return config.IsMandatory && config.show;
            }).map(function (_ref4) {
                var field = _ref4[0];
                return AccidentalDetailsFieldMappings[field];
            }).filter(Boolean);
            // console.log("mandatoryFields", mandatoryFields)
            // Print empty mandatory fields
            var emptyMandatoryFields = mandatoryFields.filter(function (field) { return !values[field]; });
            var hasEmptyMandatoryFields = mandatoryFields.some(function (field) { return !values[field]; });
            // console.log("hasEmptyMandatoryFields", hasEmptyMandatoryFields)
            if (accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon = accidentalDetailsConfig.Attachments) !== null && _accidentalDetailsCon !== void 0 && _accidentalDetailsCon.IsMandatory && accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon2 = accidentalDetailsConfig.Attachments) !== null && _accidentalDetailsCon2 !== void 0 && _accidentalDetailsCon2.show) {
                if ((accidentalDetailsPhotographList === null || accidentalDetailsPhotographList === void 0 ? void 0 : accidentalDetailsPhotographList.length) === 0 && (accidentalDetailsAudioList === null || accidentalDetailsAudioList === void 0 ? void 0 : accidentalDetailsAudioList.length) === 0) {
                    return true;
                }
            }
            if (hasEmptyMandatoryFields) {
                return true;
            }
            return false;
        }
        return false;
    };
    var createDocumentDisabled = function () {
        if (validateMobileError.error) {
            return true;
        }
        if (serviceTypeError !== null && serviceTypeError !== void 0 && serviceTypeError.error) {
            return true;
        }
        if (validateAccidentalDetails()) {
            return true;
        }
        if (parentComponent === EParentModuleName.Appointment && (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create') {
            if (kmReadingValidation && serviceType && selectedTimeSlot) {
                var _customerVoiceSection, _customerVoiceSection2;
                if ((customerVoiceSectionDetails === null || customerVoiceSectionDetails === void 0 || (_customerVoiceSection = customerVoiceSectionDetails.SectionAttributes) === null || _customerVoiceSection === void 0 ? void 0 : _customerVoiceSection.length) > 0 && customerVoiceSectionDetails !== null && customerVoiceSectionDetails !== void 0 && (_customerVoiceSection2 = customerVoiceSectionDetails.SectionAttributes[0]) !== null && _customerVoiceSection2 !== void 0 && _customerVoiceSection2.MANDATORY) {
                    if (customerComplaint) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                return false;
            }
            else {
                return true;
            }
        }
        else if (parentComponent === EParentModuleName.ServiceEstimate && (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Create') {
            if (kmReadingValidation && serviceType && !(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.audioStart)) {
                var _customerVoiceSection3, _customerVoiceSection4;
                if ((customerVoiceSectionDetails === null || customerVoiceSectionDetails === void 0 || (_customerVoiceSection3 = customerVoiceSectionDetails.SectionAttributes) === null || _customerVoiceSection3 === void 0 ? void 0 : _customerVoiceSection3.length) > 0 && customerVoiceSectionDetails !== null && customerVoiceSectionDetails !== void 0 && (_customerVoiceSection4 = customerVoiceSectionDetails.SectionAttributes[0]) !== null && _customerVoiceSection4 !== void 0 && _customerVoiceSection4.MANDATORY) {
                    var _preDocumentFetch$dat13;
                    if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat13 = preDocumentFetch.data) === null || _preDocumentFetch$dat13 === void 0 ? void 0 : _preDocumentFetch$dat13.length) > 0 || customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                return false;
            }
            else {
                return true;
            }
        }
        else if (parentComponent === EParentModuleName.Inspection && (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) === 'Create') {
            if (!isDisabled && kmReadingValidation && serviceType && !serviceTypeError.error) {
                var _customerVoiceSection5, _customerVoiceSection6;
                if ((customerVoiceSectionDetails === null || customerVoiceSectionDetails === void 0 || (_customerVoiceSection5 = customerVoiceSectionDetails.SectionAttributes) === null || _customerVoiceSection5 === void 0 ? void 0 : _customerVoiceSection5.length) > 0 && customerVoiceSectionDetails !== null && customerVoiceSectionDetails !== void 0 && (_customerVoiceSection6 = customerVoiceSectionDetails.SectionAttributes[0]) !== null && _customerVoiceSection6 !== void 0 && _customerVoiceSection6.MANDATORY) {
                    var _preDocumentFetch$dat14;
                    if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat14 = preDocumentFetch.data) === null || _preDocumentFetch$dat14 === void 0 ? void 0 : _preDocumentFetch$dat14.length) > 0 || customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                return false;
            }
            else {
                return true;
            }
        }
    };
    var handleModifyDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _profileData$data, _profileData$data2, _profileData$data3, _profileData$data4, _profileData$data5, _profileData$data6, _profileData$data7, _profileData$data8, _profileData$data9, _profileData$data10, _profileData$data11, _profileData$data12, _profileData$data13, _profileData$data14, _profileData$data15, _profileData$data16, _profileData$data17, _profileData$data18, _profileData$data19, _profileData$data20, _profileData$data21, _profileData$data22, _profileData$data23, _profileData$data24, _documentDetailsGetBy46, _response$payload10, documentModifyRequest, _userData$data4, response, _ref5, _documentDetailsGetBy47, _documentDetailsGetBy48, _futureAdviceList$0$C, _futureAdviceList$, _ref6, _documentDetailsGetBy49, _documentDetailsGetBy50, _ref7, _documentDetailsGetBy51, _documentDetailsGetBy52, _ref8, _documentDetailsGetBy53, _documentDetailsGetBy54, _ref9, _documentDetailsGetBy55, _documentDetailsGetBy56, _response$payload17, _documentDetailsGetBy57, _ref10, _documentDetailsGetBy58, _documentDetailsGetBy59, _profileData$data25, _profileData$data26, _profileData$data27, _profileData$data28, _profileData$data29, _profileData$data30, _profileData$data31, _profileData$data32, _response$payload11, _response$payload12, _profileData$data33, _profileData$data34, _profileData$data35, _profileData$data36, _profileData$data37, _profileData$data38, _profileData$data39, _profileData$data40, _response$payload13, _response$payload14, _profileData$data41, _profileData$data42, _profileData$data43, _profileData$data44, _profileData$data45, _profileData$data46, _profileData$data47, _profileData$data48, _response$payload15, _response$payload16, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isDisabled) return [3 /*break*/, 1];
                    if (parentComponent === EParentModuleName.Appointment) {
                        transactionEventLog("".concat(parentComponent + "_Next_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data = profileData.data) === null || _profileData$data === void 0 ? void 0 : _profileData$data.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data2 = profileData.data) === null || _profileData$data2 === void 0 ? void 0 : _profileData$data2.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data3 = profileData.data) === null || _profileData$data3 === void 0 ? void 0 : _profileData$data3.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data4 = profileData.data) === null || _profileData$data4 === void 0 ? void 0 : _profileData$data4.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data5 = profileData.data) === null || _profileData$data5 === void 0 ? void 0 : _profileData$data5.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data6 = profileData.data) === null || _profileData$data6 === void 0 ? void 0 : _profileData$data6.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data7 = profileData.data) === null || _profileData$data7 === void 0 ? void 0 : _profileData$data7.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data8 = profileData.data) === null || _profileData$data8 === void 0 ? void 0 : _profileData$data8.IdentityId),
                            'mode': 'Edit',
                            'documentId': documentId,
                            'navigateTo': 'Appointment Task Details Page'
                        }, profileData);
                        navigate("/appoinment-tasksDetails/".concat(parentModuleDocumentId));
                    }
                    else if (parentComponent === EParentModuleName.ServiceEstimate) {
                        transactionEventLog("".concat(parentComponent + "_Next_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data9 = profileData.data) === null || _profileData$data9 === void 0 ? void 0 : _profileData$data9.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data10 = profileData.data) === null || _profileData$data10 === void 0 ? void 0 : _profileData$data10.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data11 = profileData.data) === null || _profileData$data11 === void 0 ? void 0 : _profileData$data11.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data12 = profileData.data) === null || _profileData$data12 === void 0 ? void 0 : _profileData$data12.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data13 = profileData.data) === null || _profileData$data13 === void 0 ? void 0 : _profileData$data13.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data14 = profileData.data) === null || _profileData$data14 === void 0 ? void 0 : _profileData$data14.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data15 = profileData.data) === null || _profileData$data15 === void 0 ? void 0 : _profileData$data15.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data16 = profileData.data) === null || _profileData$data16 === void 0 ? void 0 : _profileData$data16.IdentityId),
                            'mode': 'Edit',
                            'documentId': documentId,
                            'navigateTo': 'ServiceEstimate Task Details Page'
                        }, profileData);
                        navigate("/serviceEstimate-tasksDetails/".concat(parentModuleDocumentId));
                    }
                    else if (parentComponent === EParentModuleName.Inspection) {
                        transactionEventLog("".concat(parentComponent + "_Next_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data17 = profileData.data) === null || _profileData$data17 === void 0 ? void 0 : _profileData$data17.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data18 = profileData.data) === null || _profileData$data18 === void 0 ? void 0 : _profileData$data18.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data19 = profileData.data) === null || _profileData$data19 === void 0 ? void 0 : _profileData$data19.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data20 = profileData.data) === null || _profileData$data20 === void 0 ? void 0 : _profileData$data20.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data21 = profileData.data) === null || _profileData$data21 === void 0 ? void 0 : _profileData$data21.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data22 = profileData.data) === null || _profileData$data22 === void 0 ? void 0 : _profileData$data22.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data23 = profileData.data) === null || _profileData$data23 === void 0 ? void 0 : _profileData$data23.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data24 = profileData.data) === null || _profileData$data24 === void 0 ? void 0 : _profileData$data24.IdentityId),
                            'mode': 'Edit',
                            'documentId': documentId,
                            'navigateTo': 'Inspection Task Details Page'
                        }, profileData);
                        navigate("/inspection-tasksDetails/".concat(parentModuleDocumentId));
                    }
                    return [3 /*break*/, 25];
                case 1:
                    if (parentComponent !== EParentModuleName.Appointment) {
                        saveAccidentalDetails(documentId !== null && documentId !== void 0 ? documentId : "");
                    }
                    documentModifyRequest = {
                        AssignedEmployeeId: serviceAdvisors[0].UserId ? serviceAdvisors[0].UserId : null,
                        RepairTypeId: serviceType,
                        ODOMeterReading: Number(usageReading),
                        IsOdometerChange: isOdometerChecked,
                        CampaignId: campaign !== null && campaign !== void 0 ? campaign : null
                    };
                    if (parentComponent === EParentModuleName.Appointment) {
                        documentModifyRequest.CustomerVoice = {
                            CustomerComplaint: customerComplaint,
                            TakenBy: userData === null || userData === void 0 || (_userData$data4 = userData.data) === null || _userData$data4 === void 0 ? void 0 : _userData$data4.IdentityId
                        };
                    }
                    if (parentComponent === EParentModuleName.ServiceEstimate || parentComponent === EParentModuleName.Inspection) {
                        if (existingUcnDetails && existingUcnDetails.id) {
                            documentModifyRequest.UCNId = existingUcnDetails.id;
                        }
                        if (riderAssociateCustomerId) {
                            documentModifyRequest.AssociateCustomerId = riderAssociateCustomerId;
                        }
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: '',
                            url: modifyDocumentURL,
                            request: documentModifyRequest
                        }))];
                case 3:
                    response = _a.sent();
                    if (!((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy46 = documentDetailsGetById.data) === null || _documentDetailsGetBy46 === void 0 ? void 0 : _documentDetailsGetBy46.RepairTypeId) !== serviceType && parentComponent !== EParentModuleName.Appointment)) return [3 /*break*/, 5];
                    return [4 /*yield*/, autoFillLabourAndPart(documentId !== null && documentId !== void 0 ? documentId : "", serviceType)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    if (!(parentComponent === EParentModuleName.Appointment && Module == isModuleConfig.Product)) return [3 /*break*/, 8];
                    if (!(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)) return [3 /*break*/, 7];
                    return [4 /*yield*/, addCustomerComplaints("AppointmentId", parentModuleDocumentId !== null && parentModuleDocumentId !== void 0 ? parentModuleDocumentId : "", APISchema.Appointment)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8:
                    if (!(parentComponent === EParentModuleName.Appointment && Module == isModuleConfig.Bajaj)) return [3 /*break*/, 10];
                    if (!(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)) return [3 /*break*/, 10];
                    return [4 /*yield*/, updateCustomerComplaint()];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10:
                    if (!(parentComponent === EParentModuleName.Inspection && Module == isModuleConfig.Product)) return [3 /*break*/, 13];
                    if (!(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)) return [3 /*break*/, 12];
                    return [4 /*yield*/, addCustomerComplaints("InspectionId", documentId !== null && documentId !== void 0 ? documentId : "", APISchema.Inspection)];
                case 11:
                    _a.sent();
                    _a.label = 12;
                case 12: return [3 /*break*/, 15];
                case 13:
                    if (!(parentComponent === EParentModuleName.Inspection && Module == isModuleConfig.Bajaj)) return [3 /*break*/, 15];
                    if (!(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)) return [3 /*break*/, 15];
                    return [4 /*yield*/, updateCustomerComplaint()];
                case 14:
                    _a.sent();
                    _a.label = 15;
                case 15:
                    if (!(parentComponent === EParentModuleName.ServiceEstimate && Module == isModuleConfig.Product)) return [3 /*break*/, 18];
                    if (!(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)) return [3 /*break*/, 17];
                    return [4 /*yield*/, addCustomerComplaints("EstimateId", documentId !== null && documentId !== void 0 ? documentId : "", APISchema.Estimate)];
                case 16:
                    _a.sent();
                    _a.label = 17;
                case 17: return [3 /*break*/, 20];
                case 18:
                    if (!(parentComponent === EParentModuleName.ServiceEstimate && Module == isModuleConfig.Bajaj)) return [3 /*break*/, 20];
                    if (!(customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription)) return [3 /*break*/, 20];
                    return [4 /*yield*/, updateCustomerComplaint()];
                case 19:
                    _a.sent();
                    _a.label = 20;
                case 20: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 21:
                    _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload10 = response.payload) !== null && _response$payload10 !== void 0 && _response$payload10.success)) return [3 /*break*/, 23];
                    dispatch(resetState(["getStoredSAComment", "customerComplaintDataImageAndAudio", "customerDetailsTrnalsteToJob", "ModuleDetailsGetById"]));
                    if (parentComponent === EParentModuleName.Appointment) {
                        transactionEventLog("Update" + " ".concat(parentComponent + "_Next_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data25 = profileData.data) === null || _profileData$data25 === void 0 ? void 0 : _profileData$data25.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data26 = profileData.data) === null || _profileData$data26 === void 0 ? void 0 : _profileData$data26.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data27 = profileData.data) === null || _profileData$data27 === void 0 ? void 0 : _profileData$data27.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data28 = profileData.data) === null || _profileData$data28 === void 0 ? void 0 : _profileData$data28.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data29 = profileData.data) === null || _profileData$data29 === void 0 ? void 0 : _profileData$data29.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data30 = profileData.data) === null || _profileData$data30 === void 0 ? void 0 : _profileData$data30.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data31 = profileData.data) === null || _profileData$data31 === void 0 ? void 0 : _profileData$data31.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data32 = profileData.data) === null || _profileData$data32 === void 0 ? void 0 : _profileData$data32.IdentityId),
                            'mode': 'Edit',
                            'documentId': response === null || response === void 0 || (_response$payload11 = response.payload) === null || _response$payload11 === void 0 || (_response$payload11 = _response$payload11.data) === null || _response$payload11 === void 0 ? void 0 : _response$payload11.AppointmentId,
                            'navigateTo': 'Appoinment Task Details Page'
                        }, profileData);
                        navigate("/appoinment-tasksDetails/".concat(response === null || response === void 0 || (_response$payload12 = response.payload) === null || _response$payload12 === void 0 || (_response$payload12 = _response$payload12.data) === null || _response$payload12 === void 0 ? void 0 : _response$payload12.AppointmentId));
                    }
                    else if (parentComponent === EParentModuleName.ServiceEstimate) {
                        transactionEventLog("Update" + " ".concat(parentComponent + "_Next_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data33 = profileData.data) === null || _profileData$data33 === void 0 ? void 0 : _profileData$data33.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data34 = profileData.data) === null || _profileData$data34 === void 0 ? void 0 : _profileData$data34.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data35 = profileData.data) === null || _profileData$data35 === void 0 ? void 0 : _profileData$data35.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data36 = profileData.data) === null || _profileData$data36 === void 0 ? void 0 : _profileData$data36.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data37 = profileData.data) === null || _profileData$data37 === void 0 ? void 0 : _profileData$data37.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data38 = profileData.data) === null || _profileData$data38 === void 0 ? void 0 : _profileData$data38.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data39 = profileData.data) === null || _profileData$data39 === void 0 ? void 0 : _profileData$data39.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data40 = profileData.data) === null || _profileData$data40 === void 0 ? void 0 : _profileData$data40.IdentityId),
                            'mode': 'Edit',
                            'documentId': response === null || response === void 0 || (_response$payload13 = response.payload) === null || _response$payload13 === void 0 || (_response$payload13 = _response$payload13.data) === null || _response$payload13 === void 0 ? void 0 : _response$payload13.EstimateId,
                            'navigateTo': 'ServiceEstimate Task Details Page'
                        }, profileData);
                        navigate("/serviceEstimate-tasksDetails/".concat(response === null || response === void 0 || (_response$payload14 = response.payload) === null || _response$payload14 === void 0 || (_response$payload14 = _response$payload14.data) === null || _response$payload14 === void 0 ? void 0 : _response$payload14.EstimateId));
                    }
                    else if (parentComponent === EParentModuleName.Inspection) {
                        transactionEventLog("Update" + " ".concat(parentComponent + "_Next_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data41 = profileData.data) === null || _profileData$data41 === void 0 ? void 0 : _profileData$data41.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data42 = profileData.data) === null || _profileData$data42 === void 0 ? void 0 : _profileData$data42.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data43 = profileData.data) === null || _profileData$data43 === void 0 ? void 0 : _profileData$data43.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data44 = profileData.data) === null || _profileData$data44 === void 0 ? void 0 : _profileData$data44.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data45 = profileData.data) === null || _profileData$data45 === void 0 ? void 0 : _profileData$data45.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data46 = profileData.data) === null || _profileData$data46 === void 0 ? void 0 : _profileData$data46.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data47 = profileData.data) === null || _profileData$data47 === void 0 ? void 0 : _profileData$data47.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data48 = profileData.data) === null || _profileData$data48 === void 0 ? void 0 : _profileData$data48.IdentityId),
                            'mode': 'Edit',
                            'documentId': response === null || response === void 0 || (_response$payload15 = response.payload) === null || _response$payload15 === void 0 || (_response$payload15 = _response$payload15.data) === null || _response$payload15 === void 0 ? void 0 : _response$payload15.InspectionId,
                            'navigateTo': 'Inspection Task Details Page'
                        }, profileData);
                        navigate("/inspection-tasksDetails/".concat(response === null || response === void 0 || (_response$payload16 = response.payload) === null || _response$payload16 === void 0 || (_response$payload16 = _response$payload16.data) === null || _response$payload16 === void 0 ? void 0 : _response$payload16.InspectionId));
                    }
                    dispatch(resetState(["getStoredSAComment"]));
                    payload = {
                        FutureAdviseList: futureAdviceList.map(function (s) {
                            var _s$SuggestionContent, _s$CustomerResponseId, _s$FutureAdviceTypeId, _s$DueDate, _s$StatusId, _s$ChildId, _s$StatusName;
                            return {
                                FutureAdviceId: s.FutureAdviceId || s.id || null,
                                SuggestionContent: (_s$SuggestionContent = s.SuggestionContent) !== null && _s$SuggestionContent !== void 0 ? _s$SuggestionContent : null,
                                CustomerResponseId: (_s$CustomerResponseId = s.CustomerResponseId) !== null && _s$CustomerResponseId !== void 0 ? _s$CustomerResponseId : null,
                                FutureAdviceTypeId: (_s$FutureAdviceTypeId = s.FutureAdviceTypeId) !== null && _s$FutureAdviceTypeId !== void 0 ? _s$FutureAdviceTypeId : null,
                                DueDate: (_s$DueDate = s.DueDate) !== null && _s$DueDate !== void 0 ? _s$DueDate : null,
                                StatusId: (_s$StatusId = s.StatusId) !== null && _s$StatusId !== void 0 ? _s$StatusId : null,
                                PreviousJobCardId: (_s$ChildId = s === null || s === void 0 ? void 0 : s.ChildId) !== null && _s$ChildId !== void 0 ? _s$ChildId : null,
                                StatusName: (_s$StatusName = s.StatusName) !== null && _s$StatusName !== void 0 ? _s$StatusName : null,
                                IsGlobal: true
                            };
                        }),
                        InstallBaseId: (_ref5 = (_documentDetailsGetBy47 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy48 = documentDetailsGetById.data) === null || _documentDetailsGetBy48 === void 0 ? void 0 : _documentDetailsGetBy48.InstallBaseId) !== null && _documentDetailsGetBy47 !== void 0 ? _documentDetailsGetBy47 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) !== null && _ref5 !== void 0 ? _ref5 : null,
                        PreviousJobCardId: (_futureAdviceList$0$C = futureAdviceList === null || futureAdviceList === void 0 || (_futureAdviceList$ = futureAdviceList[0]) === null || _futureAdviceList$ === void 0 ? void 0 : _futureAdviceList$.ChildId) !== null && _futureAdviceList$0$C !== void 0 ? _futureAdviceList$0$C : null,
                        ParentOrganizationId: (_ref6 = (_documentDetailsGetBy49 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy50 = documentDetailsGetById.data) === null || _documentDetailsGetBy50 === void 0 ? void 0 : _documentDetailsGetBy50.ParentOrganizationId) !== null && _documentDetailsGetBy49 !== void 0 ? _documentDetailsGetBy49 : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId) !== null && _ref6 !== void 0 ? _ref6 : null,
                        OrganizationId: (_ref7 = (_documentDetailsGetBy51 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy52 = documentDetailsGetById.data) === null || _documentDetailsGetBy52 === void 0 ? void 0 : _documentDetailsGetBy52.OrganizationId) !== null && _documentDetailsGetBy51 !== void 0 ? _documentDetailsGetBy51 : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId) !== null && _ref7 !== void 0 ? _ref7 : null,
                        RegistrationNo: (_ref8 = (_documentDetailsGetBy53 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy54 = documentDetailsGetById.data) === null || _documentDetailsGetBy54 === void 0 ? void 0 : _documentDetailsGetBy54.RegistrationNo) !== null && _documentDetailsGetBy53 !== void 0 ? _documentDetailsGetBy53 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.RegistrationNo) !== null && _ref8 !== void 0 ? _ref8 : null,
                        VinNo: (_ref9 = (_documentDetailsGetBy55 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy56 = documentDetailsGetById.data) === null || _documentDetailsGetBy56 === void 0 ? void 0 : _documentDetailsGetBy56.VinNo) !== null && _documentDetailsGetBy55 !== void 0 ? _documentDetailsGetBy55 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) !== null && _ref9 !== void 0 ? _ref9 : null,
                        DocumentId: (response === null || response === void 0 || (_response$payload17 = response.payload) === null || _response$payload17 === void 0 || (_response$payload17 = _response$payload17.data) === null || _response$payload17 === void 0 ? void 0 : _response$payload17.PreJobCardDocumentId) || documentId || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy57 = documentDetailsGetById.data) === null || _documentDetailsGetBy57 === void 0 ? void 0 : _documentDetailsGetBy57.id) || null,
                        DocumentType: (_ref10 = (_documentDetailsGetBy58 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy59 = documentDetailsGetById.data) === null || _documentDetailsGetBy59 === void 0 ? void 0 : _documentDetailsGetBy59.DocumentType) !== null && _documentDetailsGetBy58 !== void 0 ? _documentDetailsGetBy58 : parentComponent === EParentModuleName.ServiceEstimate ? "Estimate" : parentComponent) !== null && _ref10 !== void 0 ? _ref10 : null
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'upsertFutureAdvises',
                            url: futureAdviceClonePreviousJCURL,
                            request: payload
                        }))];
                case 22:
                    _a.sent();
                    dispatch(setDocDataUpdated(false));
                    return [3 /*break*/, 25];
                case 23: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 24:
                    _a.sent();
                    _a.label = 25;
                case 25: return [2 /*return*/];
            }
        });
    }); };
    var autoFillLabourAndPart = function (PreJobCardDocumentId, RepairTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy60, _documentDetailsGetBy61, autoFillLabourBody, autoFillPartBody, autoFillLabourResponse, autoFillPartResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    autoFillLabourBody = {
                        RepairTypeId: RepairTypeId,
                        PreJobCardDocumentId: PreJobCardDocumentId
                    };
                    autoFillPartBody = _objectSpread(_objectSpread({}, autoFillLabourBody), {}, {
                        ProductId: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy60 = documentDetailsGetById.data) !== null && _documentDetailsGetBy60 !== void 0 && _documentDetailsGetBy60.ProductId ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy61 = documentDetailsGetById.data) === null || _documentDetailsGetBy61 === void 0 ? void 0 : _documentDetailsGetBy61.ProductId : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductId
                    });
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: autoFillServiceTypeLabourtUrl,
                            request: autoFillLabourBody
                        }))];
                case 1:
                    autoFillLabourResponse = _a.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: autoFillServiceTypePartUrl,
                            request: autoFillPartBody
                        }))];
                case 2:
                    autoFillPartResponse = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCreateDocument = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _getCustomerInfo$data, _documentDetailsGetBy62, _preDocumentFetch$dat15, _preDocumentFetch$dat16, _jobItemsArray, _preDocumentFetch$dat17, _preDocumentFetch$dat18, _getCustomerInfo$data2, _getCustomerInfo$data3, _getCustomerInfo$data4, _response$payload18, _response$payload19, uuidCreate, customerVoiceAttachment, jobItemsArray, attachmentIdArray, test, PersonContactPoint, documentCreateRequest, _userData$data5, date, _customerComplaintDat, _userData$data6, _customerVoiceAttachm, _customerComplaintDat2, _userData$data7, _customerVoiceAttachm2, response, _ref11, _documentDetailsGetBy63, _documentDetailsGetBy64, _futureAdviceList$0$C2, _futureAdviceList$2, _ref12, _documentDetailsGetBy65, _documentDetailsGetBy66, _ref13, _documentDetailsGetBy67, _documentDetailsGetBy68, _ref14, _documentDetailsGetBy69, _documentDetailsGetBy70, _ref15, _documentDetailsGetBy71, _documentDetailsGetBy72, _response$payload20, _documentDetailsGetBy73, _ref16, _documentDetailsGetBy74, _documentDetailsGetBy75, _response$payload21, payload, _response$payload22, _response$payload23, findserviceType, _profileData$data49, _profileData$data50, _profileData$data51, _profileData$data52, _profileData$data53, _profileData$data54, _profileData$data55, _profileData$data56, _profileData$data57, result, _response$payload24, _response$payload25, _response$payload26, _response$payload27, _preDocumentFetch$dat19, _profileData$data58, _profileData$data59, _profileData$data60, _profileData$data61, _profileData$data62, _profileData$data63, _profileData$data64, _profileData$data65, _response$payload28, _response$payload29, _preDocumentFetch$dat20, _preDocumentFetch$dat21, _response$payload30, _response$payload31, _response$payload32, _response$payload33, _preDocumentFetch$dat22, _profileData$data66, _profileData$data67, _profileData$data68, _profileData$data69, _profileData$data70, _profileData$data71, _profileData$data72, _profileData$data73, _response$payload34, _response$payload35, _preDocumentFetch$dat23;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    uuidCreate = uuidv4();
                    customerVoiceAttachment = [];
                    jobItemsArray = [];
                    if (!(parentComponent !== EParentModuleName.Appointment)) return [3 /*break*/, 2];
                    return [4 /*yield*/, createAttachmentId(uuidCreate, customerComplaintDataImageAndAudio)];
                case 1:
                    attachmentIdArray = _a.sent();
                    customerVoiceAttachment = attachmentIdArray === null || attachmentIdArray === void 0 ? void 0 : attachmentIdArray.map(function (item) {
                        return {
                            ParentId: uuidCreate,
                            AttachmentDocumentId: item.AttachmentId
                        };
                    });
                    _a.label = 2;
                case 2:
                    if (!(getStoredJobItems && getStoredJobItems.length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, createJobItemPayload(getStoredJobItems)];
                case 3:
                    jobItemsArray = _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    if (!(customerDetailsTrnalsteToJob !== null && customerDetailsTrnalsteToJob !== void 0 && customerDetailsTrnalsteToJob.data && customerDetailsTrnalsteToJob.data.length > 0)) return [3 /*break*/, 6];
                    return [4 /*yield*/, createJobItemPayload(customerDetailsTrnalsteToJob.data)];
                case 5:
                    jobItemsArray = _a.sent();
                    _a.label = 6;
                case 6:
                    test = new Date();
                    PersonContactPoint = getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data = getCustomerInfo.data) === null || _getCustomerInfo$data === void 0 || (_getCustomerInfo$data = _getCustomerInfo$data.PersonContactPoint) === null || _getCustomerInfo$data === void 0 ? void 0 : _getCustomerInfo$data.find(function (i, index) { return (i === null || i === void 0 ? void 0 : i.ContactType) === "Primary"; });
                    documentCreateRequest = {
                        CustomerId: customerDetails !== null && customerDetails !== void 0 && customerDetails.CustomerId ? customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId : null,
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy62 = documentDetailsGetById.data) === null || _documentDetailsGetBy62 === void 0 ? void 0 : _documentDetailsGetBy62.InstallBaseId),
                        RepairTypeId: serviceType,
                        OrganizationId: selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId ? selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId : null,
                        ParentOrganizationId: selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.ParentOrganizationId ? selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId : null,
                        AssignedEmployeeId: serviceAdvisors[0].UserId ? serviceAdvisors[0].UserId : null,
                        SlotId: selectedTimeSlot !== null && selectedTimeSlot !== void 0 && selectedTimeSlot.SlotId ? selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.SlotId : null,
                        StartTime: selectedTimeSlot !== null && selectedTimeSlot !== void 0 && selectedTimeSlot.StartTime ? selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.StartTime : null,
                        Date: dateValue ? dateValue.toISOString() : null,
                        CampaignId: campaign !== null && campaign !== void 0 ? campaign : null,
                        ODOMeterReading: Number(usageReading),
                        IsOdometerChange: isOdometerChecked,
                        OptInPickAndDrop: false,
                        AssignedDate: new Date().toISOString(),
                        Remark: "",
                        //need to take from customer complaint box field
                        ParentId: (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat15 = preDocumentFetch.data) === null || _preDocumentFetch$dat15 === void 0 ? void 0 : _preDocumentFetch$dat15.length) > 0 ? preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat16 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat16 === void 0 ? void 0 : _preDocumentFetch$dat16.PreJobCardDocumentId : null,
                        JobItems: (_jobItemsArray = jobItemsArray) !== null && _jobItemsArray !== void 0 ? _jobItemsArray : [],
                        SourcePreJobCardDocumentId: (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat17 = preDocumentFetch.data) === null || _preDocumentFetch$dat17 === void 0 ? void 0 : _preDocumentFetch$dat17.length) > 0 ? preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat18 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat18 === void 0 ? void 0 : _preDocumentFetch$dat18.PreJobCardDocumentId : null,
                        ProductCode: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.SKUCode,
                        ProductId: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductId,
                        VinNo: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo,
                        RegistrationNo: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.RegistrationNo,
                        ProductName: vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductName,
                        PersonId: customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.PersonId,
                        PersonContactPointId: PersonContactPoint === null || PersonContactPoint === void 0 ? void 0 : PersonContactPoint.id,
                        OrganizationStateCode: OrganizationStateCode,
                        CustomerStateCode: CustomerStateCode,
                        OrganizationStateCodeReferenceId: OrganizationStateCodeReferenceId,
                        CustomerStateCodeReferenceId: CustomerStateCodeReferenceId,
                        AddressId: getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data2 = getCustomerInfo.data) !== null && _getCustomerInfo$data2 !== void 0 && _getCustomerInfo$data2.Address && (getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data3 = getCustomerInfo.data) === null || _getCustomerInfo$data3 === void 0 || (_getCustomerInfo$data3 = _getCustomerInfo$data3.Address) === null || _getCustomerInfo$data3 === void 0 ? void 0 : _getCustomerInfo$data3.length) > 0 ? getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data4 = getCustomerInfo.data) === null || _getCustomerInfo$data4 === void 0 || (_getCustomerInfo$data4 = _getCustomerInfo$data4.Address[0]) === null || _getCustomerInfo$data4 === void 0 ? void 0 : _getCustomerInfo$data4.AddressId : null
                    };
                    if (riderAssociateCustomerId) {
                        documentCreateRequest.AssociateCustomerId = riderAssociateCustomerId;
                    }
                    if (parentComponent === EParentModuleName.Appointment) {
                        date = new Date(dateValue);
                        documentCreateRequest.ScheduledDate = date.toISOString();
                        documentCreateRequest.CustomerVoice = {
                            CustomerComplaint: customerComplaint,
                            TakenBy: userData === null || userData === void 0 || (_userData$data5 = userData.data) === null || _userData$data5 === void 0 ? void 0 : _userData$data5.IdentityId
                        };
                    }
                    else if (parentComponent === EParentModuleName.ServiceEstimate || parentComponent === EParentModuleName.Inspection) {
                        documentCreateRequest.CustomerComplaint = (_customerComplaintDat = customerComplaintDataImageAndAudio === null || customerComplaintDataImageAndAudio === void 0 ? void 0 : customerComplaintDataImageAndAudio.discription) !== null && _customerComplaintDat !== void 0 ? _customerComplaintDat : null;
                        documentCreateRequest.TakenBy = userData === null || userData === void 0 || (_userData$data6 = userData.data) === null || _userData$data6 === void 0 ? void 0 : _userData$data6.IdentityId;
                        documentCreateRequest.CustomerVoiceImageAttachments = (_customerVoiceAttachm = customerVoiceAttachment) !== null && _customerVoiceAttachm !== void 0 ? _customerVoiceAttachm : [];
                        if (existingUcnDetails && existingUcnDetails.id) {
                            documentCreateRequest.UCNId = existingUcnDetails.id;
                        }
                    }
                    if (parentComponent === EParentModuleName.Inspection) {
                        documentCreateRequest.CustomerComplaint = (_customerComplaintDat2 = customerComplaintDataImageAndAudio === null || customerComplaintDataImageAndAudio === void 0 ? void 0 : customerComplaintDataImageAndAudio.discription) !== null && _customerComplaintDat2 !== void 0 ? _customerComplaintDat2 : null;
                        documentCreateRequest.TakenBy = userData === null || userData === void 0 || (_userData$data7 = userData.data) === null || _userData$data7 === void 0 ? void 0 : _userData$data7.IdentityId;
                        documentCreateRequest.CustomerVoiceImageAttachments = (_customerVoiceAttachm2 = customerVoiceAttachment) !== null && _customerVoiceAttachm2 !== void 0 ? _customerVoiceAttachm2 : [];
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 7:
                    _a.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: createDocumentURL,
                            request: documentCreateRequest
                        }))];
                case 8:
                    response = _a.sent();
                    if (!((response === null || response === void 0 || (_response$payload18 = response.payload) === null || _response$payload18 === void 0 ? void 0 : _response$payload18.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload19 = response.payload) !== null && _response$payload19 !== void 0 && _response$payload19.success)) return [3 /*break*/, 16];
                    payload = {
                        FutureAdviseList: futureAdviceList.map(function (s) {
                            var _s$SuggestionContent2, _s$CustomerResponseId2, _s$FutureAdviceTypeId2, _s$DueDate2, _s$StatusId2, _s$ChildId2, _s$StatusName2;
                            return {
                                FutureAdviceId: s.FutureAdviceId || s.id || null,
                                SuggestionContent: (_s$SuggestionContent2 = s.SuggestionContent) !== null && _s$SuggestionContent2 !== void 0 ? _s$SuggestionContent2 : null,
                                CustomerResponseId: (_s$CustomerResponseId2 = s.CustomerResponseId) !== null && _s$CustomerResponseId2 !== void 0 ? _s$CustomerResponseId2 : null,
                                FutureAdviceTypeId: (_s$FutureAdviceTypeId2 = s.FutureAdviceTypeId) !== null && _s$FutureAdviceTypeId2 !== void 0 ? _s$FutureAdviceTypeId2 : null,
                                DueDate: (_s$DueDate2 = s.DueDate) !== null && _s$DueDate2 !== void 0 ? _s$DueDate2 : null,
                                StatusId: (_s$StatusId2 = s.StatusId) !== null && _s$StatusId2 !== void 0 ? _s$StatusId2 : null,
                                PreviousJobCardId: (_s$ChildId2 = s === null || s === void 0 ? void 0 : s.ChildId) !== null && _s$ChildId2 !== void 0 ? _s$ChildId2 : null,
                                StatusName: (_s$StatusName2 = s.StatusName) !== null && _s$StatusName2 !== void 0 ? _s$StatusName2 : null,
                                IsGlobal: true
                            };
                        }),
                        InstallBaseId: (_ref11 = (_documentDetailsGetBy63 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy64 = documentDetailsGetById.data) === null || _documentDetailsGetBy64 === void 0 ? void 0 : _documentDetailsGetBy64.InstallBaseId) !== null && _documentDetailsGetBy63 !== void 0 ? _documentDetailsGetBy63 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) !== null && _ref11 !== void 0 ? _ref11 : null,
                        PreviousJobCardId: (_futureAdviceList$0$C2 = futureAdviceList === null || futureAdviceList === void 0 || (_futureAdviceList$2 = futureAdviceList[0]) === null || _futureAdviceList$2 === void 0 ? void 0 : _futureAdviceList$2.ChildId) !== null && _futureAdviceList$0$C2 !== void 0 ? _futureAdviceList$0$C2 : null,
                        ParentOrganizationId: (_ref12 = (_documentDetailsGetBy65 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy66 = documentDetailsGetById.data) === null || _documentDetailsGetBy66 === void 0 ? void 0 : _documentDetailsGetBy66.ParentOrganizationId) !== null && _documentDetailsGetBy65 !== void 0 ? _documentDetailsGetBy65 : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId) !== null && _ref12 !== void 0 ? _ref12 : null,
                        OrganizationId: (_ref13 = (_documentDetailsGetBy67 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy68 = documentDetailsGetById.data) === null || _documentDetailsGetBy68 === void 0 ? void 0 : _documentDetailsGetBy68.OrganizationId) !== null && _documentDetailsGetBy67 !== void 0 ? _documentDetailsGetBy67 : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId) !== null && _ref13 !== void 0 ? _ref13 : null,
                        RegistrationNo: (_ref14 = (_documentDetailsGetBy69 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy70 = documentDetailsGetById.data) === null || _documentDetailsGetBy70 === void 0 ? void 0 : _documentDetailsGetBy70.RegistrationNo) !== null && _documentDetailsGetBy69 !== void 0 ? _documentDetailsGetBy69 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.RegistrationNo) !== null && _ref14 !== void 0 ? _ref14 : null,
                        VinNo: (_ref15 = (_documentDetailsGetBy71 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy72 = documentDetailsGetById.data) === null || _documentDetailsGetBy72 === void 0 ? void 0 : _documentDetailsGetBy72.VinNo) !== null && _documentDetailsGetBy71 !== void 0 ? _documentDetailsGetBy71 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) !== null && _ref15 !== void 0 ? _ref15 : null,
                        DocumentId: (response === null || response === void 0 || (_response$payload20 = response.payload) === null || _response$payload20 === void 0 || (_response$payload20 = _response$payload20.data) === null || _response$payload20 === void 0 ? void 0 : _response$payload20.PreJobCardDocumentId) || documentId || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy73 = documentDetailsGetById.data) === null || _documentDetailsGetBy73 === void 0 ? void 0 : _documentDetailsGetBy73.id) || null,
                        DocumentType: (_ref16 = (_documentDetailsGetBy74 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy75 = documentDetailsGetById.data) === null || _documentDetailsGetBy75 === void 0 ? void 0 : _documentDetailsGetBy75.DocumentType) !== null && _documentDetailsGetBy74 !== void 0 ? _documentDetailsGetBy74 : parentComponent === EParentModuleName.ServiceEstimate ? "Estimate" : parentComponent) !== null && _ref16 !== void 0 ? _ref16 : null
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'upsertFutureAdvises',
                            url: futureAdviceClonePreviousJCURL,
                            request: payload
                        }))];
                case 9:
                    _a.sent();
                    checkRepeatCall(true, Number(usageReading), false, serviceType, response === null || response === void 0 || (_response$payload21 = response.payload) === null || _response$payload21 === void 0 || (_response$payload21 = _response$payload21.data) === null || _response$payload21 === void 0 ? void 0 : _response$payload21.PreJobCardDocumentId);
                    if (parentComponent !== EParentModuleName.Appointment) {
                        saveAccidentalDetails(response === null || response === void 0 || (_response$payload22 = response.payload) === null || _response$payload22 === void 0 || (_response$payload22 = _response$payload22.data) === null || _response$payload22 === void 0 ? void 0 : _response$payload22.PreJobCardDocumentId);
                    }
                    if (onSuccessfullDocumentCreate) {
                        findserviceType = filterList === null || filterList === void 0 ? void 0 : filterList.serviceType.find(function (item) { return item.id == serviceType; });
                        onSuccessfullDocumentCreate(_objectSpread(_objectSpread({}, response === null || response === void 0 || (_response$payload23 = response.payload) === null || _response$payload23 === void 0 ? void 0 : _response$payload23.data), {}, {
                            SlotStartTime: selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.StartTime,
                            RepairTypeName: findserviceType === null || findserviceType === void 0 ? void 0 : findserviceType.Name
                        }));
                    }
                    if (parentComponent === EParentModuleName.Appointment) {
                        result = calculateTimeDifference(AppointmentCreateStartTime === null || AppointmentCreateStartTime === void 0 ? void 0 : AppointmentCreateStartTime.date, new Date());
                        transactionEventLog('Appointment_Schedule_Click', {
                            'id': profileData === null || profileData === void 0 || (_profileData$data49 = profileData.data) === null || _profileData$data49 === void 0 ? void 0 : _profileData$data49.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data50 = profileData.data) === null || _profileData$data50 === void 0 ? void 0 : _profileData$data50.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data51 = profileData.data) === null || _profileData$data51 === void 0 ? void 0 : _profileData$data51.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data52 = profileData.data) === null || _profileData$data52 === void 0 ? void 0 : _profileData$data52.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data53 = profileData.data) === null || _profileData$data53 === void 0 ? void 0 : _profileData$data53.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data54 = profileData.data) === null || _profileData$data54 === void 0 ? void 0 : _profileData$data54.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data55 = profileData.data) === null || _profileData$data55 === void 0 ? void 0 : _profileData$data55.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data56 = profileData.data) === null || _profileData$data56 === void 0 ? void 0 : _profileData$data56.IdentityId),
                            'mode': 'Add',
                            'createAppointmentDuration': "".concat(result === null || result === void 0 ? void 0 : result.hours, "h ").concat(result === null || result === void 0 ? void 0 : result.minutes, "m ").concat(result === null || result === void 0 ? void 0 : result.seconds, "s ").concat(result === null || result === void 0 ? void 0 : result.milliseconds, "ms") + ": ".concat(profileData === null || profileData === void 0 || (_profileData$data57 = profileData.data) === null || _profileData$data57 === void 0 ? void 0 : _profileData$data57.IdentityId)
                        }, profileData);
                        dispatch(setState({
                            key: "createAppointmentDuration",
                            value: {}
                        }));
                    }
                    if (!(parentComponent === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 13];
                    return [4 /*yield*/, autoFillLabourAndPart(response === null || response === void 0 || (_response$payload24 = response.payload) === null || _response$payload24 === void 0 || (_response$payload24 = _response$payload24.data) === null || _response$payload24 === void 0 ? void 0 : _response$payload24.EstimateId, response === null || response === void 0 || (_response$payload25 = response.payload) === null || _response$payload25 === void 0 || (_response$payload25 = _response$payload25.data) === null || _response$payload25 === void 0 ? void 0 : _response$payload25.RepairTypeId)];
                case 10:
                    _a.sent();
                    return [4 /*yield*/, createAttachmentIdForSAComment(response === null || response === void 0 || (_response$payload26 = response.payload) === null || _response$payload26 === void 0 || (_response$payload26 = _response$payload26.data) === null || _response$payload26 === void 0 || (_response$payload26 = _response$payload26.CustomerVoice) === null || _response$payload26 === void 0 ? void 0 : _response$payload26.CustomerVoiceId, {
                            "EstimateId": response === null || response === void 0 || (_response$payload27 = response.payload) === null || _response$payload27 === void 0 || (_response$payload27 = _response$payload27.data) === null || _response$payload27 === void 0 ? void 0 : _response$payload27.EstimateId
                        }, APISchema.Estimate)];
                case 11:
                    _a.sent();
                    if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat19 = preDocumentFetch.data) === null || _preDocumentFetch$dat19 === void 0 ? void 0 : _preDocumentFetch$dat19.length) > 0) {
                        if ((preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentName) == "Inspection") {
                            handleConvertedInspection(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat20 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat20 === void 0 ? void 0 : _preDocumentFetch$dat20.PreJobCardDocumentId);
                        }
                        if ((preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentName) == "Appointment") {
                            handleInwardDocument(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat21 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat21 === void 0 ? void 0 : _preDocumentFetch$dat21.PreJobCardDocumentId);
                        }
                    }
                    dispatch(resetState(["getStoredSAComment", "getStoredJobItems", "customerComplaintDataImageAndAudio", "customerDetailsTrnalsteToJob", "savedJobItemCreateFlow"]));
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 12:
                    _a.sent();
                    transactionEventLog("".concat(parentComponent + "_Next_Click"), {
                        'id': profileData === null || profileData === void 0 || (_profileData$data58 = profileData.data) === null || _profileData$data58 === void 0 ? void 0 : _profileData$data58.IdentityId,
                        // Transaction ID.
                        'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data59 = profileData.data) === null || _profileData$data59 === void 0 ? void 0 : _profileData$data59.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data60 = profileData.data) === null || _profileData$data60 === void 0 ? void 0 : _profileData$data60.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data61 = profileData.data) === null || _profileData$data61 === void 0 ? void 0 : _profileData$data61.IdentityId),
                        'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data62 = profileData.data) === null || _profileData$data62 === void 0 ? void 0 : _profileData$data62.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data63 = profileData.data) === null || _profileData$data63 === void 0 ? void 0 : _profileData$data63.IdentityId),
                        'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data64 = profileData.data) === null || _profileData$data64 === void 0 ? void 0 : _profileData$data64.IdentityId),
                        'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data65 = profileData.data) === null || _profileData$data65 === void 0 ? void 0 : _profileData$data65.IdentityId),
                        'mode': 'Edit',
                        'documentId': response === null || response === void 0 || (_response$payload28 = response.payload) === null || _response$payload28 === void 0 || (_response$payload28 = _response$payload28.data) === null || _response$payload28 === void 0 ? void 0 : _response$payload28.EstimateId,
                        'navigateTo': 'ServiceEstimate Task Details Page'
                    }, profileData);
                    navigate("/serviceEstimate-tasksDetails/".concat(response === null || response === void 0 || (_response$payload29 = response.payload) === null || _response$payload29 === void 0 || (_response$payload29 = _response$payload29.data) === null || _response$payload29 === void 0 ? void 0 : _response$payload29.EstimateId));
                    _a.label = 13;
                case 13:
                    if (!(parentComponent === EParentModuleName.Inspection)) return [3 /*break*/, 16];
                    return [4 /*yield*/, autoFillLabourAndPart(response === null || response === void 0 || (_response$payload30 = response.payload) === null || _response$payload30 === void 0 || (_response$payload30 = _response$payload30.data) === null || _response$payload30 === void 0 ? void 0 : _response$payload30.InspectionId, response === null || response === void 0 || (_response$payload31 = response.payload) === null || _response$payload31 === void 0 || (_response$payload31 = _response$payload31.data) === null || _response$payload31 === void 0 ? void 0 : _response$payload31.RepairTypeId)];
                case 14:
                    _a.sent();
                    return [4 /*yield*/, createAttachmentIdForSAComment(response === null || response === void 0 || (_response$payload32 = response.payload) === null || _response$payload32 === void 0 || (_response$payload32 = _response$payload32.data) === null || _response$payload32 === void 0 || (_response$payload32 = _response$payload32.CustomerVoice) === null || _response$payload32 === void 0 ? void 0 : _response$payload32.CustomerVoiceId, {
                            "InspectionId": response === null || response === void 0 || (_response$payload33 = response.payload) === null || _response$payload33 === void 0 || (_response$payload33 = _response$payload33.data) === null || _response$payload33 === void 0 ? void 0 : _response$payload33.InspectionId
                        }, APISchema.Inspection)];
                case 15:
                    _a.sent();
                    if (IsFromParentAPt) {
                        handleInwardDocument(documentId);
                    }
                    if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat22 = preDocumentFetch.data) === null || _preDocumentFetch$dat22 === void 0 ? void 0 : _preDocumentFetch$dat22.length) > 0) {
                        handleInwardDocument(preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat23 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat23 === void 0 ? void 0 : _preDocumentFetch$dat23.PreJobCardDocumentId);
                    }
                    dispatch(resetState(["getStoredSAComment", "getStoredJobItems", "customerDetailsTrnalsteToJob", "savedJobItemCreateFlow"]));
                    transactionEventLog("".concat(parentComponent + "_Next_Click"), {
                        'id': profileData === null || profileData === void 0 || (_profileData$data66 = profileData.data) === null || _profileData$data66 === void 0 ? void 0 : _profileData$data66.IdentityId,
                        // Transaction ID.
                        'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data67 = profileData.data) === null || _profileData$data67 === void 0 ? void 0 : _profileData$data67.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data68 = profileData.data) === null || _profileData$data68 === void 0 ? void 0 : _profileData$data68.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data69 = profileData.data) === null || _profileData$data69 === void 0 ? void 0 : _profileData$data69.IdentityId),
                        'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data70 = profileData.data) === null || _profileData$data70 === void 0 ? void 0 : _profileData$data70.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data71 = profileData.data) === null || _profileData$data71 === void 0 ? void 0 : _profileData$data71.IdentityId),
                        'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data72 = profileData.data) === null || _profileData$data72 === void 0 ? void 0 : _profileData$data72.IdentityId),
                        'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data73 = profileData.data) === null || _profileData$data73 === void 0 ? void 0 : _profileData$data73.IdentityId),
                        'mode': 'Edit',
                        'documentId': response === null || response === void 0 || (_response$payload34 = response.payload) === null || _response$payload34 === void 0 || (_response$payload34 = _response$payload34.data) === null || _response$payload34 === void 0 ? void 0 : _response$payload34.InspectionId,
                        'navigateTo': 'Inspection Task Details Page'
                    }, profileData);
                    navigate("/inspection-tasksDetails/".concat(response === null || response === void 0 || (_response$payload35 = response.payload) === null || _response$payload35 === void 0 || (_response$payload35 = _response$payload35.data) === null || _response$payload35 === void 0 ? void 0 : _response$payload35.InspectionId));
                    _a.label = 16;
                case 16: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 17:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleInwardDocument = function (id) {
        dispatch(updateAPI({
            key: 'inwardAppointment',
            url: inwardAppointmentAPI(id !== null && id !== void 0 ? id : '')
        }));
    };
    var handleConvertedInspection = function (id) {
        dispatch(updateAPI({
            key: 'convertedInspection',
            url: convertedInspectionAPI(id !== null && id !== void 0 ? id : '')
        }));
    };
    var addCustomerComplaints = function (payloadkey, id, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _userData$data8, _ResponseResult$paylo, request, ResponseResult, _ResponseResult$paylo2, _ResponseResult$paylo3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _b.sent();
                    request = (_a = {},
                        _a[payloadkey] = id,
                        _a.CustomerComplaint = customerComplaintDataImageAndAudio.discription,
                        // need to take from redux
                        _a.TakenBy = userData === null || userData === void 0 || (_userData$data8 = userData.data) === null || _userData$data8 === void 0 ? void 0 : _userData$data8.IdentityId,
                        _a);
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'SaveCustomerComplaints',
                            url: VoiceUrl(params),
                            request: request
                        }))];
                case 2:
                    ResponseResult = _b.sent();
                    if (!(ResponseResult !== null && ResponseResult !== void 0 && (_ResponseResult$paylo = ResponseResult.payload) !== null && _ResponseResult$paylo !== void 0 && (_ResponseResult$paylo = _ResponseResult$paylo.value) !== null && _ResponseResult$paylo !== void 0 && _ResponseResult$paylo.success || (ResponseResult === null || ResponseResult === void 0 ? void 0 : ResponseResult.payload.value.statusCode) === 201)) return [3 /*break*/, 6];
                    // await dispatch(getByIdAPI({ key: "appointmentCount", url: AppointmentJobCountUrl(requestID ?? '') }));
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    // await dispatch(getByIdAPI({ key: "appointmentCount", url: AppointmentJobCountUrl(requestID ?? '') }));
                    _b.sent();
                    return [4 /*yield*/, createAttachmentId(ResponseResult === null || ResponseResult === void 0 || (_ResponseResult$paylo2 = ResponseResult.payload) === null || _ResponseResult$paylo2 === void 0 || (_ResponseResult$paylo2 = _ResponseResult$paylo2.value) === null || _ResponseResult$paylo2 === void 0 || (_ResponseResult$paylo2 = _ResponseResult$paylo2.data) === null || _ResponseResult$paylo2 === void 0 ? void 0 : _ResponseResult$paylo2.CustomerVoiceId, customerComplaintDataImageAndAudio)];
                case 4:
                    _b.sent();
                    return [4 /*yield*/, createAttachmentIdForSAComment(ResponseResult === null || ResponseResult === void 0 || (_ResponseResult$paylo3 = ResponseResult.payload) === null || _ResponseResult$paylo3 === void 0 || (_ResponseResult$paylo3 = _ResponseResult$paylo3.value) === null || _ResponseResult$paylo3 === void 0 || (_ResponseResult$paylo3 = _ResponseResult$paylo3.data) === null || _ResponseResult$paylo3 === void 0 ? void 0 : _ResponseResult$paylo3.CustomerVoiceId, apiRequestPayload, params)];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var updateCustomerComplaint = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ResponseResult$paylo4, request, ResponseResult, _ResponseResult$paylo5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    request = {
                        PreJobCardDocumentId: parentModuleDocumentId,
                        CustomerComplaint: customerComplaintDataImageAndAudio.discription // need to take from redux
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: 'updateCustomerComplaint',
                            url: updateCustomerComplaintURL,
                            request: request
                        }))];
                case 2:
                    ResponseResult = _a.sent();
                    if (!(ResponseResult !== null && ResponseResult !== void 0 && (_ResponseResult$paylo4 = ResponseResult.payload) !== null && _ResponseResult$paylo4 !== void 0 && (_ResponseResult$paylo4 = _ResponseResult$paylo4.value) !== null && _ResponseResult$paylo4 !== void 0 && _ResponseResult$paylo4.success || (ResponseResult === null || ResponseResult === void 0 ? void 0 : ResponseResult.payload.value.statusCode) === 201)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    createAttachmentId(ResponseResult === null || ResponseResult === void 0 || (_ResponseResult$paylo5 = ResponseResult.payload) === null || _ResponseResult$paylo5 === void 0 || (_ResponseResult$paylo5 = _ResponseResult$paylo5.value) === null || _ResponseResult$paylo5 === void 0 || (_ResponseResult$paylo5 = _ResponseResult$paylo5.data) === null || _ResponseResult$paylo5 === void 0 ? void 0 : _ResponseResult$paylo5.CustomerVoiceId, customerComplaintDataImageAndAudio);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var uploadAttachmentUsingIdSAComment = function (data, complaintId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UploadImage("".concat(Config.baseURL, "resource/CustomerVoice/").concat(complaintId), data, 'BlankSystemName', dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var createAttachmentIdForSAComment = function (documentId, apiRequest, schemaName) { return __awaiter(void 0, void 0, void 0, function () {
        var _getStoredSAComment$a, ImageAttachmentsBody_1, audioFiles, upsertData_1, _getStoredSAComment$i, _audioFiles$filter, uploadPromises, uploadPromises1, requestBody, SAResult, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 8]);
                    ImageAttachmentsBody_1 = [];
                    if ((getStoredSAComment === null || getStoredSAComment === void 0 ? void 0 : getStoredSAComment.imageList.length) > 0) {
                        getStoredSAComment === null || getStoredSAComment === void 0 || getStoredSAComment.imageList.map(function (imageItem) {
                            if (!imageItem.isAlreadyUploaded) {
                                ImageAttachmentsBody_1.push({
                                    SystemName: "CustomerVoiceWiseComment",
                                    MediaType: 1
                                });
                            }
                        });
                    }
                    audioFiles = getStoredSAComment !== null && getStoredSAComment !== void 0 && (_getStoredSAComment$a = getStoredSAComment.audio) !== null && _getStoredSAComment$a !== void 0 && _getStoredSAComment$a.audioBlobUrl ? [getStoredSAComment === null || getStoredSAComment === void 0 ? void 0 : getStoredSAComment.audio] : [];
                    if (audioFiles.length > 0) {
                        audioFiles.map(function (audioFile) {
                            ImageAttachmentsBody_1.push({
                                SystemName: "CustomerVoiceWiseComment",
                                MediaType: 2
                            });
                        });
                    }
                    upsertData_1 = [];
                    if (!(ImageAttachmentsBody_1.length > 0)) return [3 /*break*/, 3];
                    uploadPromises = getStoredSAComment === null || getStoredSAComment === void 0 || (_getStoredSAComment$i = getStoredSAComment.imageList.filter(function (f) { return !f.isAlreadyUploaded; })) === null || _getStoredSAComment$i === void 0 ? void 0 : _getStoredSAComment$i.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', imageItem === null || imageItem === void 0 ? void 0 : imageItem.file);
                                    return [4 /*yield*/, uploadAttachmentUsingIdSAComment(formData, documentId)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.statusCode && result !== null && result !== void 0 && result.statusCode) {
                                        upsertData_1.push({
                                            AttachmentId: result === null || result === void 0 ? void 0 : result.attachmentId,
                                            SystemName: "CustomerVoiceWiseComment",
                                            MediaType: 1
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 1:
                    _a.sent();
                    uploadPromises1 = audioFiles === null || audioFiles === void 0 || (_audioFiles$filter = audioFiles.filter(function (f) { return !f.isAlreadyUploaded; })) === null || _audioFiles$filter === void 0 ? void 0 : _audioFiles$filter.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem === null || audioItem === void 0 ? void 0 : audioItem.audioFile);
                                    return [4 /*yield*/, uploadAttachmentUsingIdSAComment(formData, documentId)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.statusCode && result !== null && result !== void 0 && result.statusCode) {
                                        upsertData_1.push({
                                            AttachmentId: result === null || result === void 0 ? void 0 : result.attachmentId,
                                            SystemName: "CustomerVoiceWiseComment",
                                            MediaType: 2
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    requestBody = _objectSpread(_objectSpread({}, apiRequest), {}, {
                        SAComments: [{
                                ParentId: documentId,
                                Comments: getStoredSAComment === null || getStoredSAComment === void 0 ? void 0 : getStoredSAComment.description,
                                ImageAttachments: upsertData_1
                            }]
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: upsertSACommentURL(schemaName),
                            request: requestBody
                        }))];
                case 4:
                    SAResult = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6:
                    e_2 = _a.sent();
                    console.log(e_2);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var uploadAttachmentUsingIdCustomerVoice = function (PreJobCardDocumentAttachmentId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UploadImage(getPreJobCardDocumentAttachmentUploadUrl(PreJobCardDocumentAttachmentId), data, 'CustomerVoice', dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var uploadAttachmentUsingIdAccidentalDetails = function (PreJobCardDocumentAttachmentId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UploadImage(getPreJobCardDocumentAttachmentUploadUrl(PreJobCardDocumentAttachmentId), data, 'PreJobCardAccidentalDetail', dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var createAttachmentId = function (custId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var _data$images, _data$audio, ImageAttachmentsBody_2, imagesArrayWithoutAttachmentID_1, AttachementIDs_1, audioFiles, request, ResponseData, PreJobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_2, uploadPromises, audioAttachmentsWithMediaType2_2, uploadPromises1, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 8, , 10]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    ImageAttachmentsBody_2 = [];
                    imagesArrayWithoutAttachmentID_1 = [];
                    AttachementIDs_1 = [];
                    if ((data === null || data === void 0 || (_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.length) > 0) {
                        data.images.map(function (imageItem) {
                            if (!imageItem.AttachmentId) {
                                ImageAttachmentsBody_2.push({
                                    SystemName: "CustomerVoice",
                                    MediaType: 1
                                });
                                imagesArrayWithoutAttachmentID_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                    blobUrl: imageItem.blobUrl,
                                    file: imageItem.file
                                }));
                            }
                        });
                    }
                    audioFiles = [];
                    if (data !== null && data !== void 0 && (_data$audio = data.audio) !== null && _data$audio !== void 0 && _data$audio.audioFile) {
                        audioFiles = Array.isArray(data.audio.audioFile) ? data.audio.audioFile : [data.audio.audioFile];
                        audioFiles.map(function (audioFile) {
                            if (!audioFile.AttachmentId) {
                                ImageAttachmentsBody_2.push({
                                    SystemName: "CustomerVoice",
                                    MediaType: 2
                                });
                            }
                        });
                    }
                    if (!(ImageAttachmentsBody_2.length > 0)) return [3 /*break*/, 7];
                    request = {
                        ParentId: custId,
                        ImageAttachments: ImageAttachmentsBody_2
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: precheckAttachmentCreateUrl,
                            request: request
                        }))];
                case 2:
                    ResponseData = _a.sent();
                    PreJobCardDocumentAttachmentIds = [];
                    if (ResponseData.payload.success && ResponseData.payload.data) {
                        PreJobCardDocumentAttachmentIds = ResponseData.payload.data;
                    }
                    imageAttachmentsWithMediaType1_2 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                    uploadPromises = imagesArrayWithoutAttachmentID_1 === null || imagesArrayWithoutAttachmentID_1 === void 0 ? void 0 : imagesArrayWithoutAttachmentID_1.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, matchingAttachment, result, AttachmentId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!imageItem.AttachmentId) return [3 /*break*/, 3];
                                    formData = new FormData();
                                    formData.append('data', imageItem.file);
                                    matchingAttachment = imageAttachmentsWithMediaType1_2[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingIdCustomerVoice(matchingAttachment.PreJobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    AttachmentId = matchingAttachment.PreJobCardDocumentAttachmentId;
                                    AttachementIDs_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                        AttachmentId: AttachmentId
                                    }));
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 1
                                    console.error("No matching attachment found with MediaType === 1");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    if (!(data !== null && data !== void 0 && data.images)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    audioAttachmentsWithMediaType2_2 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 2; });
                    uploadPromises1 = audioFiles.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, matchingAttachment, result, AttachmentId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem);
                                    matchingAttachment = audioAttachmentsWithMediaType2_2[index];
                                    if (!matchingAttachment) return [3 /*break*/, 3];
                                    if (!!matchingAttachment.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingIdCustomerVoice(matchingAttachment.PreJobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    AttachmentId = matchingAttachment.PreJobCardDocumentAttachmentId;
                                    AttachementIDs_1.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                        AttachmentId: AttachmentId
                                    }));
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    // Handle the case where there is no matching attachment with MediaType === 2
                                    console.error("No matching attachment found with MediaType === 2");
                                    _a.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 6:
                    _a.sent();
                    return [2 /*return*/, AttachementIDs_1];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_3 = _a.sent();
                    console.log(e_3);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 9:
                    _a.sent();
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    //   const serviceTypeChange=async()=>{
    //     let req:any={Type:"PreJobCard",PreJobCardDocumentId:parentModuleDocumentId, ...selectedServiceType, }
    //     const result = await dispatch(getListAPI({ key: 'ResetServiceTypeData', url: ResetServiceTypeURL, request: req }));
    // }
    var getJobItems = function (preJobCardId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload17, _result$payload18, requestBody, result, _result$payload19, savedCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        PreJobCardDocumentId: preJobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'customerDetailsTrnalsteToJob',
                            url: getSavedJobItemsUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload17 = result.payload) !== null && _result$payload17 !== void 0 && (_result$payload17 = _result$payload17.value) !== null && _result$payload17 !== void 0 && _result$payload17.success && result !== null && result !== void 0 && (_result$payload18 = result.payload) !== null && _result$payload18 !== void 0 && (_result$payload18 = _result$payload18.value) !== null && _result$payload18 !== void 0 && _result$payload18.data) {
                        savedCount = result === null || result === void 0 || (_result$payload19 = result.payload) === null || _result$payload19 === void 0 || (_result$payload19 = _result$payload19.value) === null || _result$payload19 === void 0 ? void 0 : _result$payload19.data;
                        return [2 /*return*/, (savedCount === null || savedCount === void 0 ? void 0 : savedCount.length) || 0];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var OnClickNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ref17, _documentDetailsGetBy76, _documentDetailsGetBy77, _futureAdviceList$0$C3, _futureAdviceList$3, _ref18, _documentDetailsGetBy78, _documentDetailsGetBy79, _ref19, _documentDetailsGetBy80, _documentDetailsGetBy81, _ref20, _documentDetailsGetBy82, _documentDetailsGetBy83, _ref21, _documentDetailsGetBy84, _documentDetailsGetBy85, _ref22, _documentDetailsGetBy86, _ref23, _documentDetailsGetBy87, _documentDetailsGetBy88, _getCustomerVoiceSect, payload, hasFormErrors, moduleKey, _getCustomerVoiceSect2, jobItemsCount, result, _customerDetailsTrnal, _getCustomerVoiceSect3, _getCustomerVoiceSect4, profileData_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        FutureAdviseList: futureAdviceList.map(function (s) {
                            var _s$SuggestionContent3, _s$CustomerResponseId3, _s$FutureAdviceTypeId3, _s$DueDate3, _s$StatusId3, _s$ChildId3, _s$StatusName3;
                            return {
                                FutureAdviceId: s.FutureAdviceId || s.id || null,
                                SuggestionContent: (_s$SuggestionContent3 = s.SuggestionContent) !== null && _s$SuggestionContent3 !== void 0 ? _s$SuggestionContent3 : null,
                                CustomerResponseId: (_s$CustomerResponseId3 = s.CustomerResponseId) !== null && _s$CustomerResponseId3 !== void 0 ? _s$CustomerResponseId3 : null,
                                FutureAdviceTypeId: (_s$FutureAdviceTypeId3 = s.FutureAdviceTypeId) !== null && _s$FutureAdviceTypeId3 !== void 0 ? _s$FutureAdviceTypeId3 : null,
                                DueDate: (_s$DueDate3 = s.DueDate) !== null && _s$DueDate3 !== void 0 ? _s$DueDate3 : null,
                                StatusId: (_s$StatusId3 = s.StatusId) !== null && _s$StatusId3 !== void 0 ? _s$StatusId3 : null,
                                PreviousJobCardId: (_s$ChildId3 = s === null || s === void 0 ? void 0 : s.ChildId) !== null && _s$ChildId3 !== void 0 ? _s$ChildId3 : null,
                                StatusName: (_s$StatusName3 = s.StatusName) !== null && _s$StatusName3 !== void 0 ? _s$StatusName3 : null,
                                IsGlobal: true
                            };
                        }),
                        InstallBaseId: (_ref17 = (_documentDetailsGetBy76 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy77 = documentDetailsGetById.data) === null || _documentDetailsGetBy77 === void 0 ? void 0 : _documentDetailsGetBy77.InstallBaseId) !== null && _documentDetailsGetBy76 !== void 0 ? _documentDetailsGetBy76 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) !== null && _ref17 !== void 0 ? _ref17 : null,
                        PreviousJobCardId: (_futureAdviceList$0$C3 = futureAdviceList === null || futureAdviceList === void 0 || (_futureAdviceList$3 = futureAdviceList[0]) === null || _futureAdviceList$3 === void 0 ? void 0 : _futureAdviceList$3.ChildId) !== null && _futureAdviceList$0$C3 !== void 0 ? _futureAdviceList$0$C3 : null,
                        ParentOrganizationId: (_ref18 = (_documentDetailsGetBy78 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy79 = documentDetailsGetById.data) === null || _documentDetailsGetBy79 === void 0 ? void 0 : _documentDetailsGetBy79.ParentOrganizationId) !== null && _documentDetailsGetBy78 !== void 0 ? _documentDetailsGetBy78 : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId) !== null && _ref18 !== void 0 ? _ref18 : null,
                        OrganizationId: (_ref19 = (_documentDetailsGetBy80 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy81 = documentDetailsGetById.data) === null || _documentDetailsGetBy81 === void 0 ? void 0 : _documentDetailsGetBy81.OrganizationId) !== null && _documentDetailsGetBy80 !== void 0 ? _documentDetailsGetBy80 : selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId) !== null && _ref19 !== void 0 ? _ref19 : null,
                        RegistrationNo: (_ref20 = (_documentDetailsGetBy82 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy83 = documentDetailsGetById.data) === null || _documentDetailsGetBy83 === void 0 ? void 0 : _documentDetailsGetBy83.RegistrationNo) !== null && _documentDetailsGetBy82 !== void 0 ? _documentDetailsGetBy82 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.RegistrationNo) !== null && _ref20 !== void 0 ? _ref20 : null,
                        VinNo: (_ref21 = (_documentDetailsGetBy84 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy85 = documentDetailsGetById.data) === null || _documentDetailsGetBy85 === void 0 ? void 0 : _documentDetailsGetBy85.VinNo) !== null && _documentDetailsGetBy84 !== void 0 ? _documentDetailsGetBy84 : vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) !== null && _ref21 !== void 0 ? _ref21 : null,
                        DocumentId: (_ref22 = documentId !== null && documentId !== void 0 ? documentId : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy86 = documentDetailsGetById.data) === null || _documentDetailsGetBy86 === void 0 ? void 0 : _documentDetailsGetBy86.id) !== null && _ref22 !== void 0 ? _ref22 : null,
                        DocumentType: (_ref23 = (_documentDetailsGetBy87 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy88 = documentDetailsGetById.data) === null || _documentDetailsGetBy88 === void 0 ? void 0 : _documentDetailsGetBy88.DocumentType) !== null && _documentDetailsGetBy87 !== void 0 ? _documentDetailsGetBy87 : parentComponent === EParentModuleName.ServiceEstimate ? "Estimate" : parentComponent) !== null && _ref23 !== void 0 ? _ref23 : null
                    };
                    /*
                          await dispatch(createAPI({
                              key: 'syncCustomerUpdate', url: syncCustomerUpdateURL, request: {
                                  CustomerId: customerDetails?.CustomerId ?? documentDetailsGetById?.data?.CustomerId,
                                  VinNo: vehicleDetails?.VinNo || VehiclesDetailsList?.VinNo,
                              }
                          }))
                    */
                    trackButtonClick("ButtonClickEvent", "Next_Click", undefined);
                    if (validateAccidentalDetails()) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please fill all mandatory accidental details fields.",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    hasFormErrors = Object.values(errors).some(function (error) { return error === true || typeof error === 'string' && error.length > 0; });
                    if (hasFormErrors) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please fix all form validation errors before proceeding.",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    moduleKey = "";
                    if (createAndEditFlow !== null && createAndEditFlow !== void 0 && createAndEditFlow.isAppointment) {
                        if ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Update') {
                            moduleKey = 'Appointment_Update_NextClick';
                        }
                        else {
                            moduleKey = 'Appointment_Create_NextClick';
                        }
                    }
                    if (createAndEditFlow !== null && createAndEditFlow !== void 0 && createAndEditFlow.isEstimate) {
                        if ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Update') {
                            moduleKey = 'Estimate_Update_NextClick';
                        }
                        else {
                            moduleKey = 'Estimate_Create_NextClick';
                        }
                    }
                    if (createAndEditFlow !== null && createAndEditFlow !== void 0 && createAndEditFlow.isInspection) {
                        if ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == "Update") {
                            moduleKey = 'Jobcard_Update_NextClick';
                        }
                        else {
                            moduleKey = 'Jobcard_Create_NextClick';
                        }
                    }
                    if (UCN_CODE_OPTION === 'MANDATORY' && !ucnCode) {
                        setUcnHelperText(UCN_HELPER_TEXT_STATE.MADATORY);
                        return [2 /*return*/];
                    }
                    if (!((_getCustomerVoiceSect = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) !== null && _getCustomerVoiceSect !== void 0 && (_getCustomerVoiceSect = _getCustomerVoiceSect.JOB_ITEMS_SECTION_ATTRIBUTES) !== null && _getCustomerVoiceSect !== void 0 && _getCustomerVoiceSect.MANDATORY)) return [3 /*break*/, 5];
                    if (!((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) !== 'Create')) return [3 /*break*/, 5];
                    jobItemsCount = 0;
                    if (!savedJobItemClick) return [3 /*break*/, 1];
                    jobItemsCount = (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.jobItems) || 0;
                    return [3 /*break*/, 4];
                case 1:
                    if (!!(customerDetailsTrnalsteToJob !== null && customerDetailsTrnalsteToJob !== void 0 && customerDetailsTrnalsteToJob.data)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getJobItems(parentModuleDocumentId)];
                case 2:
                    result = _a.sent();
                    jobItemsCount = result || 0;
                    return [3 /*break*/, 4];
                case 3:
                    jobItemsCount = (customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 || (_customerDetailsTrnal = customerDetailsTrnalsteToJob.data) === null || _customerDetailsTrnal === void 0 ? void 0 : _customerDetailsTrnal.length) || 0;
                    _a.label = 4;
                case 4:
                    if (jobItemsCount < ((_getCustomerVoiceSect2 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) === null || _getCustomerVoiceSect2 === void 0 || (_getCustomerVoiceSect2 = _getCustomerVoiceSect2.JOB_ITEMS_SECTION_ATTRIBUTES) === null || _getCustomerVoiceSect2 === void 0 ? void 0 : _getCustomerVoiceSect2.Count)) {
                        profileData_1 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData_1, 'ClientSide', "Please select atleast ".concat((_getCustomerVoiceSect3 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) === null || _getCustomerVoiceSect3 === void 0 || (_getCustomerVoiceSect3 = _getCustomerVoiceSect3.JOB_ITEMS_SECTION_ATTRIBUTES) === null || _getCustomerVoiceSect3 === void 0 ? void 0 : _getCustomerVoiceSect3.Count, " job items"));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please select atleast ".concat((_getCustomerVoiceSect4 = getCustomerVoiceSectionAttributes(customerVoiceSectionDetails)) === null || _getCustomerVoiceSect4 === void 0 || (_getCustomerVoiceSect4 = _getCustomerVoiceSect4.JOB_ITEMS_SECTION_ATTRIBUTES) === null || _getCustomerVoiceSect4 === void 0 ? void 0 : _getCustomerVoiceSect4.Count, " job items"),
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    _a.label = 5;
                case 5:
                    dispatch(setUpdatedModuleSectionByChannel([]));
                    dispatch(setSavedTaskDetailsCount({
                        periodicMaintenanceCount: 0,
                        standardJobsCount: 0,
                        preCheckCount: 0,
                        roadTestCount: 0,
                        additionalJobsCount: 0,
                        advisorSuggestionsCount: 0,
                        futureAdviseCount: 0
                    }));
                    dispatch(setTasksDetailsIsDisable(false));
                    if (UpdateFlow) {
                        handleModifyDocument();
                    }
                    if (IsFromParentAPt && createAndEditFlow.isInspection == "Create") {
                        handleCreateDocument();
                        // handleInwardDocument();
                    }
                    else if (CreatedFlow) {
                        handleCreateDocument();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSubmitText = function () {
        if ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create') {
            return "Schedule";
        }
        if ((role === null || role === void 0 ? void 0 : role.Name) === "FinalInspector") {
            return t("Start final inspection");
        }
        return t('Next');
    };
    var nextButtonDissabled = function () {
        if (validateAccidentalDetails()) {
            return true;
        }
        if (kmReadingValidation && serviceType && !serviceTypeError.error) {
            if (!isDisabled) {
                if (Module == isModuleConfig.Bajaj) {
                    var _customerVoiceSection7, _customerVoiceSection8;
                    if ((customerVoiceSectionDetails === null || customerVoiceSectionDetails === void 0 || (_customerVoiceSection7 = customerVoiceSectionDetails.SectionAttributes) === null || _customerVoiceSection7 === void 0 ? void 0 : _customerVoiceSection7.length) > 0 && customerVoiceSectionDetails !== null && customerVoiceSectionDetails !== void 0 && (_customerVoiceSection8 = customerVoiceSectionDetails.SectionAttributes[0]) !== null && _customerVoiceSection8 !== void 0 && _customerVoiceSection8.MANDATORY) {
                        var _preDocumentFetch$dat24;
                        if ((preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat24 = preDocumentFetch.data) === null || _preDocumentFetch$dat24 === void 0 ? void 0 : _preDocumentFetch$dat24.length) > 0 || customerComplaintDataImageAndAudio !== null && customerComplaintDataImageAndAudio !== void 0 && customerComplaintDataImageAndAudio.discription) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                }
                else {
                    var _customerVoiceSection9, _customerVoiceSection10;
                    if ((customerVoiceSectionDetails === null || customerVoiceSectionDetails === void 0 || (_customerVoiceSection9 = customerVoiceSectionDetails.SectionAttributes) === null || _customerVoiceSection9 === void 0 ? void 0 : _customerVoiceSection9.length) > 0 && customerVoiceSectionDetails !== null && customerVoiceSectionDetails !== void 0 && (_customerVoiceSection10 = customerVoiceSectionDetails.SectionAttributes[0]) !== null && _customerVoiceSection10 !== void 0 && _customerVoiceSection10.MANDATORY) {
                        var _CustomerComplaintLis;
                        if ((CustomerComplaintList === null || CustomerComplaintList === void 0 || (_CustomerComplaintLis = CustomerComplaintList.data) === null || _CustomerComplaintLis === void 0 || (_CustomerComplaintLis = _CustomerComplaintLis.CustomerVoice) === null || _CustomerComplaintLis === void 0 ? void 0 : _CustomerComplaintLis.length) > 0) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                }
                return false;
            }
            return false;
        }
        else {
            return true;
        }
    };
    var onClickOfSlotBar = function (item) {
        setFullDate(item.FullDate);
        onCalendarDateClick(new Date(item.FullDate));
    };
    var onArrowDateChange = function (string) {
        if (fullDate) {
            var day = new Date(fullDate);
            if (moment(fullDate).isSameOrBefore(toDate)) {
                if (string === 'next' && !moment(fullDate).isSame(toDate)) {
                    var nextDay = new Date(day);
                    nextDay.setDate(day.getDate() + 1);
                    onCalendarDateClick(new Date(nextDay));
                    // nextDay = dateFormate(nextDay, true)
                    setFullDate(nextDay);
                }
                else if (string === 'prev') {
                    var prevDay = new Date(day);
                    prevDay.setDate(day.getDate() - 1);
                    // prevDay = dateFormate(prevDay, true)
                    onCalendarDateClick(new Date(prevDay));
                    setFullDate(prevDay);
                }
            }
            else {
                setFullDate(toDate);
            }
        }
    };
    var isUcnFieldDisabled = function () {
        var result = true;
        var allowedDocumentStatuses = [StatusEnum.Open, StatusEnum.Completed, StatusEnum.Converted, StatusEnum.ReadyForWork];
        if (serviceType && UCN_ALLOWED_REPAIR_TYPES.includes(serviceType) && isServiceTypeValidForDocument && (CreatedFlow || allowedDocumentStatuses.includes(documentDetailsGetById.data.Key)) && !isDisabled
            // && (!isUcnAppliedSuccess)
            && ucnState !== 'Remove') {
            result = false;
        }
        return result;
    };
    var isUcnButtonDisbaled = function () {
        var _documentDetailsGetBy89;
        var result = true;
        var allowedDocumentStatuses = [StatusEnum.Open, StatusEnum.Completed, StatusEnum.Converted, StatusEnum.ReadyForWork];
        if (serviceType && UCN_ALLOWED_REPAIR_TYPES.includes(serviceType) && isServiceTypeValidForDocument && (CreatedFlow || allowedDocumentStatuses.includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy89 = documentDetailsGetById.data) === null || _documentDetailsGetBy89 === void 0 ? void 0 : _documentDetailsGetBy89.Key))) {
            result = false;
        }
        return result;
    };
    var handleUcnButtonClick = function () {
        if (ucnState === 'Apply' && ucnCode == "") {
            var profileData_2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
            GoogleAnlyticsErrorLog(profileData_2, 'ClientSide', 'Please enter UCN.');
            dispatch(showNotification({
                isOpen: true,
                message: "Please enter UCN.",
                type: "error"
            }));
            return;
        }
        if (ucnState === 'Apply') {
            var ServiceTypeName = filterList.serviceType.find(function (item) { return item.id === serviceType || item.Name === serviceType; });
            var request = {
                "InstallBaseId": vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId,
                "ServiceTypeId": ServiceTypeName && ServiceTypeName.id ? ServiceTypeName.id : "",
                "SystemName": SystemName,
                "ChildId": CreatedFlow ? undefined : documentId,
                "UCNCouponCode": ucnCode
            };
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            dispatch(createAPI({
                key: 'UCN',
                url: ApllyUCN,
                request: request
            })).then(function (response) {
                var _response$payload36, _response$payload37, _response$payload38;
                if ((response === null || response === void 0 || (_response$payload36 = response.payload) === null || _response$payload36 === void 0 || (_response$payload36 = _response$payload36.value) === null || _response$payload36 === void 0 ? void 0 : _response$payload36.statusCode) == 200 || (response === null || response === void 0 || (_response$payload37 = response.payload) === null || _response$payload37 === void 0 || (_response$payload37 = _response$payload37.value) === null || _response$payload37 === void 0 ? void 0 : _response$payload37.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload38 = response.payload) !== null && _response$payload38 !== void 0 && (_response$payload38 = _response$payload38.value) !== null && _response$payload38 !== void 0 && _response$payload38.success) {
                    var _response$payload39;
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.APPLY_SUCCESS);
                    setUcnState('Remove');
                    // setUsUcnAppliedSuccess(true);
                    setExistingUcnDetails(response === null || response === void 0 || (_response$payload39 = response.payload) === null || _response$payload39 === void 0 || (_response$payload39 = _response$payload39.value) === null || _response$payload39 === void 0 ? void 0 : _response$payload39.data);
                }
                else {
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.ERROR);
                }
            }).catch(function () {
                setUcnHelperText(UCN_HELPER_TEXT_STATE.ERROR);
            }).finally(function () {
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
            });
        }
        if (ucnState === 'Send' || ucnState === 'Resend' || ucnState === 'Check UCN') {
            var _getMobileNumber, _documentDetailsGetBy90, _getMobileNumber2, _documentDetailsGetBy91;
            var chasisNumber = documentDetailsGetById && documentDetailsGetById.data && documentDetailsGetById.data && documentDetailsGetById.data.VinNo ? documentDetailsGetById.data.VinNo : "";
            var mobileNumber = documentDetailsGetById && documentDetailsGetById.data && documentDetailsGetById.data.PersonContactPoint && (_getMobileNumber = getMobileNumber(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy90 = documentDetailsGetById.data) === null || _documentDetailsGetBy90 === void 0 ? void 0 : _documentDetailsGetBy90.PersonContactPoint, "Primary")) !== null && _getMobileNumber !== void 0 && _getMobileNumber.MobileNumber ? (_getMobileNumber2 = getMobileNumber(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy91 = documentDetailsGetById.data) === null || _documentDetailsGetBy91 === void 0 ? void 0 : _documentDetailsGetBy91.PersonContactPoint, "Primary")) === null || _getMobileNumber2 === void 0 ? void 0 : _getMobileNumber2.MobileNumber : "";
            if (!chasisNumber) {
                chasisNumber = vehicleDetails && vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.VinNo ? vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo : null;
            }
            if (!mobileNumber) {
                mobileNumber = customerDetails && customerDetails.MobileNumber ? customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber : null;
            }
            var ServiceTypeName = filterList.serviceType.find(function (item) { return item.id === serviceType || item.Name === serviceType; });
            var request = {
                "InstallBaseId": vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId,
                "ServiceTypeId": ServiceTypeName && ServiceTypeName.id ? ServiceTypeName.id : "",
                "MobileNumber": mobileNumber,
                "ServiceTypeName": ServiceTypeName && ServiceTypeName.Name ? ServiceTypeName.Name : '',
                "ChassisNo": chasisNumber
            };
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            var errorOccurred_1 = false;
            dispatch(createAPI({
                url: SendUcnCodeUrl,
                request: request
            })).then(function (response) {
                var _response$payload40, _response$payload41, _response$payload42;
                if ((response === null || response === void 0 || (_response$payload40 = response.payload) === null || _response$payload40 === void 0 ? void 0 : _response$payload40.statusCode) == 200 || (response === null || response === void 0 || (_response$payload41 = response.payload) === null || _response$payload41 === void 0 ? void 0 : _response$payload41.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload42 = response.payload) !== null && _response$payload42 !== void 0 && _response$payload42.success) {
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.CODE_SENT);
                }
                else {
                    errorOccurred_1 = true;
                }
            }).finally(function () {
                if (!errorOccurred_1) {
                    setUcnState(function (prevState) {
                        if (prevState === 'Send' || prevState === 'Check UCN') {
                            prevState = 'Resend';
                        }
                        return prevState;
                    });
                }
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
            });
        }
        if (ucnState === 'Remove') {
            var request = {
                "ChildId": documentId,
                "UCNId": existingUcnDetails && existingUcnDetails.id ? existingUcnDetails.id : "",
                "SystemName": SystemName,
                "UCNNo": ""
            };
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            dispatch(createAPI({
                url: RemoveUcnUrl,
                request: request
            })).then(function (response) {
                var _response$payload43, _response$payload44, _response$payload45;
                if ((response === null || response === void 0 || (_response$payload43 = response.payload) === null || _response$payload43 === void 0 ? void 0 : _response$payload43.statusCode) == 200 || (response === null || response === void 0 || (_response$payload44 = response.payload) === null || _response$payload44 === void 0 ? void 0 : _response$payload44.statusCode) == 201 || response !== null && response !== void 0 && (_response$payload45 = response.payload) !== null && _response$payload45 !== void 0 && _response$payload45.success) {
                    setUcnCode('');
                    setUcnState(IsSendUCNDisabled ? 'Apply' : UCN_CODE_SOURCE === 'SMS' ? 'Send' : "Apply");
                    setUcnHelperText(UCN_HELPER_TEXT_STATE.INFO);
                    setExistingUcnDetails(null);
                }
            }).finally(function () {
                dispatch(showLoader({
                    isLoaderOpen: false
                }));
            });
        }
    };
    var getUcnHelperText = function () {
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.ERROR) {
            return /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#F5222D'
            }, "Invalid UCN.");
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.MADATORY) {
            return /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#F5222D'
            }, "UCN code is mandatory.");
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.CODE_SENT) {
            var mobileNumber = documentDetailsGetById && documentDetailsGetById.data && documentDetailsGetById.data.PersonContactPoint && getMobileNumber(documentDetailsGetById.data.PersonContactPoint, EContactType.Primary) ? getMobileNumber(documentDetailsGetById.data.PersonContactPoint, EContactType.Primary) : "";
            if (!mobileNumber) {
                mobileNumber = customerDetails && customerDetails.MobileNumber ? customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber : null;
            }
            return /*#__PURE__*/ React.createElement(React.Fragment, null, Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#8593A3'
            }, "UCN Sent") : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#8593A3'
            }, "UCN has sent on"), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#3697FF'
            }, "".concat(mobileNumber, "*")), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#8593A3'
            }, "number")));
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.APPLY_SUCCESS) {
            return Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#389E0D'
            }, "UCN Verified") : /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#389E0D'
            }, "UCN has successfully applied.");
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.INFO && ucnState === "Apply") {
            return /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#8593A3'
            });
        }
        if (ucnHelperText === UCN_HELPER_TEXT_STATE.INFO && ucnState === "Remove") {
            return /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                color: '#8593A3'
            });
        }
        return /*#__PURE__*/ React.createElement(Typography, {
            variant: "h5",
            color: '#8593A3'
        }, IsSendUCNDisabled ? 'Click to enter UCN' : "Click on send to get UCN");
    };
    var getDocumentAlerts = function (showAlerts) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy92, _documentDetailsGetBy93, _documentDetailsGetBy94, _result$payload20, _result$payload21, _result$payload22, result, _result$payload23, _result$payload24;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setState({
                        key: "callGetAlerts",
                        value: callGetAlerts + 1
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'getAlertsByJobCardId',
                            url: getAlertsByJobCardIdURL,
                            request: {
                                InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy92 = documentDetailsGetById.data) === null || _documentDetailsGetBy92 === void 0 ? void 0 : _documentDetailsGetBy92.InstallBaseId),
                                SystemName: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy93 = documentDetailsGetById.data) !== null && _documentDetailsGetBy93 !== void 0 && _documentDetailsGetBy93.Key ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy94 = documentDetailsGetById.data) === null || _documentDetailsGetBy94 === void 0 ? void 0 : _documentDetailsGetBy94.Key : null
                            }
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload20 = result.payload) !== null && _result$payload20 !== void 0 && (_result$payload20 = _result$payload20.value) !== null && _result$payload20 !== void 0 && _result$payload20.success && result !== null && result !== void 0 && (_result$payload21 = result.payload) !== null && _result$payload21 !== void 0 && (_result$payload21 = _result$payload21.value) !== null && _result$payload21 !== void 0 && _result$payload21.data && result !== null && result !== void 0 && (_result$payload22 = result.payload) !== null && _result$payload22 !== void 0 && (_result$payload22 = _result$payload22.value) !== null && _result$payload22 !== void 0 && (_result$payload22 = _result$payload22.data) !== null && _result$payload22 !== void 0 && _result$payload22.Alerts) {
                        setAlertsList(result === null || result === void 0 || (_result$payload23 = result.payload) === null || _result$payload23 === void 0 || (_result$payload23 = _result$payload23.value) === null || _result$payload23 === void 0 || (_result$payload23 = _result$payload23.data) === null || _result$payload23 === void 0 ? void 0 : _result$payload23.Alerts);
                        setAlertsListFunction(result === null || result === void 0 || (_result$payload24 = result.payload) === null || _result$payload24 === void 0 || (_result$payload24 = _result$payload24.value) === null || _result$payload24 === void 0 || (_result$payload24 = _result$payload24.data) === null || _result$payload24 === void 0 ? void 0 : _result$payload24.Alerts, showAlerts);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchByCoverageType = function (coverageTypeId) { return __awaiter(void 0, void 0, void 0, function () {
        var request, result, _result$payload25, error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        InsuranceProviderId: coverageTypeId,
                        take: 20,
                        skip: 0
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'coverageTypeList',
                            url: ByCoverageTypeUrl,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result.payload.statusCode === 200 || result.payload.success) {
                        return [2 /*return*/, (_result$payload25 = result.payload) === null || _result$payload25 === void 0 ? void 0 : _result$payload25.data];
                    }
                    else {
                        console.error("Failed to fetch by coverage type:", result.payload);
                        return [2 /*return*/, []];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_9 = _a.sent();
                    console.error("Error fetching by coverage type:", error_9);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleDateChange = function (newDate) {
        if (!newDate) {
            console.error("Invalid date");
            return;
        }
        setStartDocDate(dayjs(newDate));
    };
    var handleOnClickYesAmcContract = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _customerDetails$Mobi3, _documentDetailsGetBy95, _customerDetails$Cust3, _documentDetailsGetBy96, _validateServiceType$5, _validateServiceType$6, isValid, request, validateServiceType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(amcServiceTypeDetails !== null && amcServiceTypeDetails !== void 0 && amcServiceTypeDetails.id)) return [3 /*break*/, 6];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, validateDuplicateMobile(dispatch, {
                            InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            MobileNo: (_customerDetails$Mobi3 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber) !== null && _customerDetails$Mobi3 !== void 0 ? _customerDetails$Mobi3 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy95 = documentDetailsGetById.data) === null || _documentDetailsGetBy95 === void 0 || (_documentDetailsGetBy95 = _documentDetailsGetBy95.PersonContactPoint) === null || _documentDetailsGetBy95 === void 0 || (_documentDetailsGetBy95 = _documentDetailsGetBy95.find(function (contact) { return contact.ContactType === EContactType.Primary; })) === null || _documentDetailsGetBy95 === void 0 ? void 0 : _documentDetailsGetBy95.MobileNumber,
                            CustomerId: (_customerDetails$Cust3 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId) !== null && _customerDetails$Cust3 !== void 0 ? _customerDetails$Cust3 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy96 = documentDetailsGetById.data) === null || _documentDetailsGetBy96 === void 0 ? void 0 : _documentDetailsGetBy96.CustomerId,
                            ServiceTypeId: amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.id
                        })];
                case 1:
                    isValid = (_a.sent()).isValid;
                    if (!!isValid) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 2:
                    _a.sent();
                    setServiceType('');
                    setUsageReading('');
                    setAccidentalDetailsConfig(null);
                    setOpenAmcContractPopup(false);
                    return [2 /*return*/];
                case 3:
                    request = {
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        RepairTypeId: amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.id,
                        Usage: Number(usageReading),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ValidateServiceTypeURL,
                            request: request
                        }))];
                case 4:
                    validateServiceType = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    if (validateServiceType !== null && validateServiceType !== void 0 && (_validateServiceType$5 = validateServiceType.payload) !== null && _validateServiceType$5 !== void 0 && (_validateServiceType$5 = _validateServiceType$5.value) !== null && _validateServiceType$5 !== void 0 && _validateServiceType$5.success && (validateServiceType === null || validateServiceType === void 0 || (_validateServiceType$6 = validateServiceType.payload) === null || _validateServiceType$6 === void 0 || (_validateServiceType$6 = _validateServiceType$6.value) === null || _validateServiceType$6 === void 0 ? void 0 : _validateServiceType$6.statusCode) == 200) {
                        setIsServiceTypeValidForDocument(amcServiceTypeDetails !== null && amcServiceTypeDetails !== void 0 && amcServiceTypeDetails.id ? UCN_ALLOWED_REPAIR_TYPES.includes(amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.id) : false);
                        setServiceType(amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.id);
                        checkRepeatCall(true, usageReading, true, amcServiceTypeDetails === null || amcServiceTypeDetails === void 0 ? void 0 : amcServiceTypeDetails.id);
                        fetchFutureAdvice();
                        if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.PB || (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.Triumph) {
                            checkFFMContract(Number(usageReading));
                        }
                    }
                    else {
                        setServiceType('');
                        setUsageReading("");
                        setAccidentalDetailsConfig(null);
                    }
                    return [3 /*break*/, 7];
                case 6:
                    console.error("ASSURED AMC NOT FOUND");
                    _a.label = 7;
                case 7:
                    setOpenAmcContractPopup(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickNoAmcContract = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bajajCareAMCContractAvailable, _customerDetails$Mobi4, _documentDetailsGetBy97, _customerDetails$Cust4, _documentDetailsGetBy98, _validateServiceType$7, _validateServiceType$8, isValid, request, validateServiceType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    bajajCareAMCContractAvailable = false;
                    if (!((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.CV)) return [3 /*break*/, 2];
                    return [4 /*yield*/, checkBajajCareAMC(serviceType, Number(usageReading))];
                case 1:
                    bajajCareAMCContractAvailable = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!!bajajCareAMCContractAvailable) return [3 /*break*/, 8];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, validateDuplicateMobile(dispatch, {
                            InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            MobileNo: (_customerDetails$Mobi4 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber) !== null && _customerDetails$Mobi4 !== void 0 ? _customerDetails$Mobi4 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy97 = documentDetailsGetById.data) === null || _documentDetailsGetBy97 === void 0 || (_documentDetailsGetBy97 = _documentDetailsGetBy97.PersonContactPoint) === null || _documentDetailsGetBy97 === void 0 || (_documentDetailsGetBy97 = _documentDetailsGetBy97.find(function (contact) { return contact.ContactType === EContactType.Primary; })) === null || _documentDetailsGetBy97 === void 0 ? void 0 : _documentDetailsGetBy97.MobileNumber,
                            CustomerId: (_customerDetails$Cust4 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId) !== null && _customerDetails$Cust4 !== void 0 ? _customerDetails$Cust4 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy98 = documentDetailsGetById.data) === null || _documentDetailsGetBy98 === void 0 ? void 0 : _documentDetailsGetBy98.CustomerId,
                            ServiceTypeId: serviceType
                        })];
                case 3:
                    isValid = (_a.sent()).isValid;
                    if (!!isValid) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 4:
                    _a.sent();
                    setServiceType('');
                    setUsageReading("");
                    setAccidentalDetailsConfig(null);
                    setOpenAmcContractPopup(false);
                    return [2 /*return*/];
                case 5:
                    request = {
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        RepairTypeId: serviceType,
                        Usage: Number(usageReading),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ValidateServiceTypeURL,
                            request: request
                        }))];
                case 6:
                    validateServiceType = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 7:
                    _a.sent();
                    if (validateServiceType !== null && validateServiceType !== void 0 && (_validateServiceType$7 = validateServiceType.payload) !== null && _validateServiceType$7 !== void 0 && (_validateServiceType$7 = _validateServiceType$7.value) !== null && _validateServiceType$7 !== void 0 && _validateServiceType$7.success && (validateServiceType === null || validateServiceType === void 0 || (_validateServiceType$8 = validateServiceType.payload) === null || _validateServiceType$8 === void 0 || (_validateServiceType$8 = _validateServiceType$8.value) === null || _validateServiceType$8 === void 0 ? void 0 : _validateServiceType$8.statusCode) == 200) {
                        setIsServiceTypeValidForDocument(true);
                        setServiceType(serviceType);
                        checkRepeatCall(true, usageReading, true, serviceType);
                        fetchFutureAdvice();
                        if ((storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.PB || (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.Triumph) {
                            checkFFMContract(Number(usageReading));
                        }
                    }
                    else {
                        setServiceType('');
                        setUsageReading("");
                        setAccidentalDetailsConfig(null);
                    }
                    setOpenAmcContractPopup(false);
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var checkAMCContract = function (ServiceTypeId, odometerReading) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy99, _checkAMCContractResp, _checkAMCContractResp2, _checkAMCContractResp3, _checkAMCContractResp4, request, checkAMCContractResponse, _filterList$serviceTy2, AMC_SERVICE_TYPE;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy99 = documentDetailsGetById.data) === null || _documentDetailsGetBy99 === void 0 ? void 0 : _documentDetailsGetBy99.InstallBaseId),
                        ServiceTypeId: ServiceTypeId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: checkAMCContractURL,
                            request: request
                        }))];
                case 1:
                    checkAMCContractResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 2:
                    _a.sent();
                    if (checkAMCContractResponse !== null && checkAMCContractResponse !== void 0 && (_checkAMCContractResp = checkAMCContractResponse.payload) !== null && _checkAMCContractResp !== void 0 && (_checkAMCContractResp = _checkAMCContractResp.value) !== null && _checkAMCContractResp !== void 0 && _checkAMCContractResp.success && (checkAMCContractResponse === null || checkAMCContractResponse === void 0 || (_checkAMCContractResp2 = checkAMCContractResponse.payload) === null || _checkAMCContractResp2 === void 0 || (_checkAMCContractResp2 = _checkAMCContractResp2.value) === null || _checkAMCContractResp2 === void 0 ? void 0 : _checkAMCContractResp2.statusCode) == 200 && checkAMCContractResponse !== null && checkAMCContractResponse !== void 0 && (_checkAMCContractResp3 = checkAMCContractResponse.payload) !== null && _checkAMCContractResp3 !== void 0 && (_checkAMCContractResp3 = _checkAMCContractResp3.value) !== null && _checkAMCContractResp3 !== void 0 && _checkAMCContractResp3.data && (checkAMCContractResponse === null || checkAMCContractResponse === void 0 || (_checkAMCContractResp4 = checkAMCContractResponse.payload) === null || _checkAMCContractResp4 === void 0 || (_checkAMCContractResp4 = _checkAMCContractResp4.value) === null || _checkAMCContractResp4 === void 0 ? void 0 : _checkAMCContractResp4.message) === "AMC_AVAILABLE") {
                        AMC_SERVICE_TYPE = filterList === null || filterList === void 0 || (_filterList$serviceTy2 = filterList.serviceType) === null || _filterList$serviceTy2 === void 0 ? void 0 : _filterList$serviceTy2.find(function (item) {
                            var _checkAMCContractResp5;
                            return item.id === (checkAMCContractResponse === null || checkAMCContractResponse === void 0 || (_checkAMCContractResp5 = checkAMCContractResponse.payload) === null || _checkAMCContractResp5 === void 0 || (_checkAMCContractResp5 = _checkAMCContractResp5.value) === null || _checkAMCContractResp5 === void 0 ? void 0 : _checkAMCContractResp5.data);
                        });
                        if (AMC_SERVICE_TYPE) {
                            setAmcServiceTypeDetails(AMC_SERVICE_TYPE);
                        }
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetBajajCareAMCSelection = function () {
        setServiceType("");
        setUsageReading("");
        setAccidentalDetailsConfig(null);
    };
    var handleBajajCareAMCSelection = function (selectedServiceTypeId, selectedUsage) { return __awaiter(void 0, void 0, void 0, function () {
        var _customerDetails$Mobi5, _documentDetailsGetBy100, _customerDetails$Cust5, _documentDetailsGetBy101, _validateServiceType$9, _validateServiceType$10, isValid, validateRequest, validateServiceType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedServiceTypeId) {
                        resetBajajCareAMCSelection();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, , 5, 7]);
                    return [4 /*yield*/, validateDuplicateMobile(dispatch, {
                            InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            MobileNo: (_customerDetails$Mobi5 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.MobileNumber) !== null && _customerDetails$Mobi5 !== void 0 ? _customerDetails$Mobi5 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy100 = documentDetailsGetById.data) === null || _documentDetailsGetBy100 === void 0 || (_documentDetailsGetBy100 = _documentDetailsGetBy100.PersonContactPoint) === null || _documentDetailsGetBy100 === void 0 || (_documentDetailsGetBy100 = _documentDetailsGetBy100.find(function (contact) { return contact.ContactType === EContactType.Primary; })) === null || _documentDetailsGetBy100 === void 0 ? void 0 : _documentDetailsGetBy100.MobileNumber,
                            CustomerId: (_customerDetails$Cust5 = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId) !== null && _customerDetails$Cust5 !== void 0 ? _customerDetails$Cust5 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy101 = documentDetailsGetById.data) === null || _documentDetailsGetBy101 === void 0 ? void 0 : _documentDetailsGetBy101.CustomerId,
                            ServiceTypeId: selectedServiceTypeId
                        })];
                case 3:
                    isValid = (_a.sent()).isValid;
                    if (!isValid) {
                        resetBajajCareAMCSelection();
                        return [2 /*return*/];
                    }
                    validateRequest = {
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        RepairTypeId: selectedServiceTypeId,
                        Usage: Number(selectedUsage),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ValidateServiceTypeURL,
                            request: validateRequest
                        }))];
                case 4:
                    validateServiceType = _a.sent();
                    if (validateServiceType !== null && validateServiceType !== void 0 && (_validateServiceType$9 = validateServiceType.payload) !== null && _validateServiceType$9 !== void 0 && (_validateServiceType$9 = _validateServiceType$9.value) !== null && _validateServiceType$9 !== void 0 && _validateServiceType$9.success && (validateServiceType === null || validateServiceType === void 0 || (_validateServiceType$10 = validateServiceType.payload) === null || _validateServiceType$10 === void 0 || (_validateServiceType$10 = _validateServiceType$10.value) === null || _validateServiceType$10 === void 0 ? void 0 : _validateServiceType$10.statusCode) == 200) {
                        setIsServiceTypeValidForDocument(selectedServiceTypeId ? UCN_ALLOWED_REPAIR_TYPES.includes(selectedServiceTypeId) : false);
                        setServiceType(selectedServiceTypeId);
                        checkRepeatCall(true, selectedUsage, true, selectedServiceTypeId);
                        fetchFutureAdvice();
                    }
                    else {
                        resetBajajCareAMCSelection();
                    }
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 6:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleBajajCareAMCYes = function (selectedServiceTypeId, selectedUsage) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleBajajCareAMCSelection(selectedServiceTypeId, selectedUsage)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBajajCareAMCNo = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleBajajCareAMCSelection(serviceType, Number(usageReading))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Helper to compute normalized today, start and expiry dates for a contract
    var getContractDates = function (effectiveFrom, effectiveTo) {
        if (!effectiveTo)
            return null;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var expiryDate = new Date(effectiveTo);
        expiryDate.setHours(23, 59, 59, 999);
        var startDate = effectiveFrom ? new Date(effectiveFrom) : null;
        if (startDate)
            startDate.setHours(0, 0, 0, 0);
        return {
            today: today,
            startDate: startDate,
            expiryDate: expiryDate
        };
    };
    var checkBajajCareAMC = function (ServiceTypeId, Usage) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy102, request, _response$payload46, _response$payload47, _response$payload48, _response$payload49, response, _response$payload50, bajajCareAMCContract, amcReminderDetails, amcReminderDays, dates, today, expiryDate, reminderStartDate, slectedServiceTypeIsBajajCareAMC, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy102 = documentDetailsGetById.data) === null || _documentDetailsGetBy102 === void 0 ? void 0 : _documentDetailsGetBy102.InstallBaseId),
                        ServiceContractId: ServiceTypeId,
                        VinNo: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.VinNo),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        Usage: Usage
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 10, 12]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "BajajCareAMC",
                            url: checkBajajCareAMCURL,
                            request: request
                        }))];
                case 2:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (!(response !== null && response !== void 0 && (_response$payload46 = response.payload) !== null && _response$payload46 !== void 0 && (_response$payload46 = _response$payload46.value) !== null && _response$payload46 !== void 0 && _response$payload46.success && (response === null || response === void 0 || (_response$payload47 = response.payload) === null || _response$payload47 === void 0 || (_response$payload47 = _response$payload47.value) === null || _response$payload47 === void 0 ? void 0 : _response$payload47.statusCode) == 200 && response !== null && response !== void 0 && (_response$payload48 = response.payload) !== null && _response$payload48 !== void 0 && (_response$payload48 = _response$payload48.value) !== null && _response$payload48 !== void 0 && _response$payload48.data && (response === null || response === void 0 || (_response$payload49 = response.payload) === null || _response$payload49 === void 0 || (_response$payload49 = _response$payload49.value) === null || _response$payload49 === void 0 || (_response$payload49 = _response$payload49.data) === null || _response$payload49 === void 0 ? void 0 : _response$payload49.length) > 0)) return [3 /*break*/, 9];
                    bajajCareAMCContract = response === null || response === void 0 || (_response$payload50 = response.payload) === null || _response$payload50 === void 0 || (_response$payload50 = _response$payload50.value) === null || _response$payload50 === void 0 || (_response$payload50 = _response$payload50.data) === null || _response$payload50 === void 0 ? void 0 : _response$payload50[0];
                    // require EffectiveTo (expiry) to exist; keep previous behavior for missing dates
                    if (!(bajajCareAMCContract !== null && bajajCareAMCContract !== void 0 && bajajCareAMCContract.EffectiveTo))
                        return [2 /*return*/, false];
                    amcReminderDetails = CHANNEL_SETTING_BY_KEY === null || CHANNEL_SETTING_BY_KEY === void 0 ? void 0 : CHANNEL_SETTING_BY_KEY.find(function (item) { return item.Key === "BAJAJ_AMC_POPUP_DAYS"; });
                    amcReminderDays = Number((amcReminderDetails === null || amcReminderDetails === void 0 ? void 0 : amcReminderDetails.Value) || 0);
                    dates = getContractDates(bajajCareAMCContract === null || bajajCareAMCContract === void 0 ? void 0 : bajajCareAMCContract.EffectiveFrom, bajajCareAMCContract === null || bajajCareAMCContract === void 0 ? void 0 : bajajCareAMCContract.EffectiveTo);
                    if (!dates)
                        return [2 /*return*/, false];
                    today = dates.today, expiryDate = dates.expiryDate;
                    reminderStartDate = new Date(expiryDate);
                    reminderStartDate.setDate(reminderStartDate.getDate() - amcReminderDays);
                    reminderStartDate.setHours(0, 0, 0, 0);
                    slectedServiceTypeIsBajajCareAMC = serviceType === (bajajCareAMCContract === null || bajajCareAMCContract === void 0 ? void 0 : bajajCareAMCContract.ServiceContractId);
                    if (slectedServiceTypeIsBajajCareAMC) {
                        handleBajajCareAMCYes(bajajCareAMCContract === null || bajajCareAMCContract === void 0 ? void 0 : bajajCareAMCContract.ServiceContractId, Number(Usage));
                        return [2 /*return*/, true];
                    }
                    if (!(today >= reminderStartDate && today <= expiryDate)) return [3 /*break*/, 8];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: BajajCareAMCAlert,
                            containerProps: {
                                maxWidth: "xs",
                                onClose: function (event) {
                                    var _event$preventDefault;
                                    event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
                                }
                            },
                            componentProps: {
                                Title: "Bajaj Care AMC",
                                Message: "Bajaj Care AMC for this vehicle is getting expired on ".concat(dayjs(expiryDate).format("DD MMM YYYY"), ". Do you want to continue with Bajaj Care AMC service type?")
                            }
                        }))];
                case 3:
                    res = _a.sent();
                    if (!((res === null || res === void 0 ? void 0 : res.payload) === "Yes")) return [3 /*break*/, 5];
                    return [4 /*yield*/, handleBajajCareAMCYes(bajajCareAMCContract === null || bajajCareAMCContract === void 0 ? void 0 : bajajCareAMCContract.ServiceContractId, Number(Usage))];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    if (!((res === null || res === void 0 ? void 0 : res.payload) === "No")) return [3 /*break*/, 7];
                    return [4 /*yield*/, handleBajajCareAMCNo()];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [2 /*return*/, true];
                case 8: return [2 /*return*/, false];
                case 9: return [2 /*return*/, false];
                case 10: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 11:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var checkFFMContract = function (Usage) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy103, _response$payload51, _response$payload52, _contract, _contract2, request, response, contract, _response$payload53, dates, today, startDate, expiryDate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    request = {
                        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy103 = documentDetailsGetById.data) === null || _documentDetailsGetBy103 === void 0 ? void 0 : _documentDetailsGetBy103.InstallBaseId),
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ServiceTypeId: serviceType,
                        Usage: Usage
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "FFMContract",
                            url: checkFFMContractURL,
                            request: request
                        }))];
                case 2:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    contract = void 0;
                    if (response !== null && response !== void 0 && (_response$payload51 = response.payload) !== null && _response$payload51 !== void 0 && (_response$payload51 = _response$payload51.value) !== null && _response$payload51 !== void 0 && _response$payload51.success && response !== null && response !== void 0 && (_response$payload52 = response.payload) !== null && _response$payload52 !== void 0 && (_response$payload52 = _response$payload52.value) !== null && _response$payload52 !== void 0 && _response$payload52.data) {
                        contract = response === null || response === void 0 || (_response$payload53 = response.payload) === null || _response$payload53 === void 0 || (_response$payload53 = _response$payload53.value) === null || _response$payload53 === void 0 || (_response$payload53 = _response$payload53.data) === null || _response$payload53 === void 0 ? void 0 : _response$payload53[0];
                    }
                    else {
                        return [2 /*return*/];
                    }
                    // Do nothing if EffectiveFrom or EffectiveTo missing
                    if (!((_contract = contract) !== null && _contract !== void 0 && _contract.EffectiveFrom) || !((_contract2 = contract) !== null && _contract2 !== void 0 && _contract2.EffectiveTo))
                        return [2 /*return*/];
                    dates = getContractDates(contract.EffectiveFrom, contract.EffectiveTo);
                    if (!dates)
                        return [2 /*return*/];
                    today = dates.today, startDate = dates.startDate, expiryDate = dates.expiryDate;
                    // Show popup if today's date is between EffectiveFrom and EffectiveTo
                    if (startDate && today >= startDate && today <= expiryDate) {
                        dispatch(showSurface({
                            type: "Dialog",
                            Component: FFMContractAlert,
                            containerProps: {
                                maxWidth: "xs",
                                onClose: function (event) {
                                    var _event$preventDefault2;
                                    event === null || event === void 0 || (_event$preventDefault2 = event.preventDefault) === null || _event$preventDefault2 === void 0 || _event$preventDefault2.call(event);
                                }
                            },
                            componentProps: {
                                Title: "FFM Applicable",
                                Message: "FFM Contract is activated for the selected chassis"
                            }
                        }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleViewAllClick = function (items) {
        setViewAllImages(true);
    };
    // console.log(`accidentalDetails`, accidentalDetails);
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        rowGap: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        mt: 2,
        direction: 'column',
        bgcolor: systemColor.white,
        p: 1.5,
        border: '1px solid ',
        borderColor: 'secondary.200',
        borderRadius: 2,
        spacing: 2,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: lgMode ? 1 : 0,
        rowSpacing: 1
    }, alertsList.length > 0 && showAlerts && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        lg: 12,
        xl: 12,
        pb: 1
    }, /*#__PURE__*/ React.createElement(OptionAlert, {
        NoPadding: true,
        documentStatusKey: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy104 = documentDetailsGetById.data) === null || _documentDetailsGetBy104 === void 0 ? void 0 : _documentDetailsGetBy104.Key,
        isCreateDocumentFlow: (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Create' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == "Create",
        jobCardId: documentId ? documentId : "",
        InstallBaseId: (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.InstallBaseId) || (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.InstallBaseId),
        JobcardNo: "",
        difference: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy105 = documentDetailsGetById.data) !== null && _documentDetailsGetBy105 !== void 0 && _documentDetailsGetBy105.EstimateDeliveryDateTime ? moment().diff(moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy106 = documentDetailsGetById.data) === null || _documentDetailsGetBy106 === void 0 ? void 0 : _documentDetailsGetBy106.EstimateDeliveryDateTime), 'minutes') : 0,
        EstimatedDateTime: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy107 = documentDetailsGetById.data) !== null && _documentDetailsGetBy107 !== void 0 && _documentDetailsGetBy107.EstimateDeliveryDateTime ? moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy108 = documentDetailsGetById.data) === null || _documentDetailsGetBy108 === void 0 ? void 0 : _documentDetailsGetBy108.EstimateDeliveryDateTime).format('DD MMM, YYYY - h:mm A') : "",
        previousJobcard: previousJobcard,
        isDocumentDisabled: isDisabled ? isDisabled : false
    })), /*#__PURE__*/ React.createElement(Grid, {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        id: "Service-details",
        sx: {
            fontWeight: 'strong'
        }
    }, t("Service details"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            }
        },
        fontSize: "sm",
        fontWeight: "strong",
        color: 'secondary.500',
        paddingY: 1.3
    }, t("Service type")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 2,
        caption: t('SERVICE_TYPE_SELECT_PLACEHOLDER'),
        margin: 0,
        fullWidth: true,
        name: "serviceType",
        value: serviceType,
        displayExpr: "Name",
        valueExpr: "id",
        onChange: handleServiceType,
        disabled: isDisabled,
        error: serviceTypeError.error ? serviceTypeError.errorMessage : "",
        options: (filterList === null || filterList === void 0 ? void 0 : filterList.serviceType) || [],
        id: "serviceType"
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "medium",
        color: 'secondary.500',
        sx: {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            }
        }
    }, t("Odometer reading")), isOdometerVisible ? /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            marginLeft: "5px",
            marginTop: "2px"
        },
        fontSize: "sm",
        fontWeight: "medium",
        color: 'secondary.500'
    }, t("Odometer change"), /*#__PURE__*/ React.createElement(Checkbox, {
        id: "odometer-checkbox",
        checked: isOdometerChecked,
        onChange: function (e) { return handleChange(e); }
    })) : /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            visibility: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Checkbox, null))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 1,
        placeholder: t('ODOMETER_READING_PLACEHOLDER'),
        fullWidth: true,
        size: "small",
        value: usageReading,
        name: "reading",
        onChange: handleOdometerReading,
        onBlur: function (e) { return odometerReading(e); },
        disabled: isDisabled,
        error: usageReadingError.error,
        helperText: t(usageReadingError.errorMessage),
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*',
            maxLength: String(getMaxOdometerValue()).length // 5 if PB, else 6 
        },
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#F4F7FA",
                borderRadius: '8px'
            }
        },
        id: "odometerReading",
        onKeyDown: function (event) {
            console.log("event", event.key);
            console.log("event", event.keyCode);
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "medium",
        color: 'secondary.500',
        paddingY: 1.3
    }, t("Service advisor")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 3,
        caption: t('SERVICE_ADVISOR_SELECT_PLACEHOLDER'),
        margin: 0,
        fullWidth: true,
        name: "serviceAdvisor",
        value: advisor,
        displayExpr: "advisorName",
        valueExpr: "UserId",
        onChange: function (e) {
            var _e$target$value;
            setAdvisor((_e$target$value = e.target.value) !== null && _e$target$value !== void 0 ? _e$target$value : '');
            dispatch(setDocDataUpdated(true));
        },
        disabled: true,
        error: errors === null || errors === void 0 ? void 0 : errors.serviceAdvisor,
        options: serviceAdvisorList || [],
        id: "serviceAdvisor"
    })))))), accidentalDetailsConfig && ((_Object$keys = Object.keys(accidentalDetailsConfig)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && !accidentalDetailsFields.every(function (field) {
        var _accidentalDetailsCon3;
        return (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon3 = accidentalDetailsConfig[field]) === null || _accidentalDetailsCon3 === void 0 ? void 0 : _accidentalDetailsCon3.show) === false;
    }) && /*#__PURE__*/ React.createElement(MuiStack, {
        mt: 2,
        direction: "column",
        bgcolor: systemColor.white,
        p: 1.5,
        border: "1px solid #DEE4EB",
        borderRadius: 2,
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: lgMode ? 1 : 0,
        rowSpacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        sx: {
            fontWeight: 600
        }
    }, t("Accident Details"))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon4 = accidentalDetailsConfig.AccidentDateTime) === null || _accidentalDetailsCon4 === void 0 ? void 0 : _accidentalDetailsCon4.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon5 = accidentalDetailsConfig.AccidentDateTime) !== null && _accidentalDetailsCon5 !== void 0 && _accidentalDetailsCon5.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Date & Time of Accident")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormDateTimePicker, {
        disableFuture: true,
        onChange: function (e, time) {
            handleInputChange({
                target: {
                    name: "AccidentDate",
                    value: time
                }
            });
        },
        value: values.AccidentDate ? dayjs(values.AccidentDate) : null,
        name: "AccidentDate",
        placeholder: t("Select Date & Time of Accident"),
        disabled: isDisabled,
        maxDateTime: dayjs()
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon6 = accidentalDetailsConfig.IntimationDateTime) === null || _accidentalDetailsCon6 === void 0 ? void 0 : _accidentalDetailsCon6.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon7 = accidentalDetailsConfig.IntimationDateTime) !== null && _accidentalDetailsCon7 !== void 0 && _accidentalDetailsCon7.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Intimation Date	")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormDateTimePicker, {
        disablePast: true,
        onChange: function (e, time) {
            handleInputChange({
                target: {
                    name: "IntimationDate",
                    value: time
                }
            });
        },
        value: values.IntimationDate ? dayjs(values.IntimationDate) : null,
        name: "IntimationDate",
        placeholder: t("Select Intimation Date"),
        disabled: isDisabled
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon8 = accidentalDetailsConfig.LocationOfAccident) === null || _accidentalDetailsCon8 === void 0 ? void 0 : _accidentalDetailsCon8.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon9 = accidentalDetailsConfig.LocationOfAccident) !== null && _accidentalDetailsCon9 !== void 0 && _accidentalDetailsCon9.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Location of Accident")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 3,
        fullWidth: true,
        name: "AccidentLocation",
        size: "small",
        placeholder: t("Enter location"),
        value: values.AccidentLocation,
        disabled: isDisabled,
        onChange: function (e) {
            var _e$target2;
            handleInputChange(e);
            if (((_e$target2 = e.target) === null || _e$target2 === void 0 || (_e$target2 = _e$target2.value) === null || _e$target2 === void 0 ? void 0 : _e$target2.length) > 100) {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    AccidentLocation: true
                }));
            }
            else {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    AccidentLocation: false
                }));
            }
        },
        error: errors === null || errors === void 0 ? void 0 : errors.AccidentLocation,
        helperText: errors !== null && errors !== void 0 && errors.AccidentLocation ? t("Please enter a valid location (max 100 characters).") : ""
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon10 = accidentalDetailsConfig.NatureOfAccident) === null || _accidentalDetailsCon10 === void 0 ? void 0 : _accidentalDetailsCon10.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon11 = accidentalDetailsConfig.NatureOfAccident) !== null && _accidentalDetailsCon11 !== void 0 && _accidentalDetailsCon11.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Nature of Accident")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 4,
        fullWidth: true,
        name: "NatureOfAccidentId",
        displayExpr: "Name",
        valueExpr: "id",
        value: values.NatureOfAccidentId,
        options: (natureOfAccidentList === null || natureOfAccidentList === void 0 ? void 0 : natureOfAccidentList.data) || [],
        onChange: handleInputChange,
        disabled: isDisabled,
        error: errors === null || errors === void 0 ? void 0 : errors.NatureOfAccidentId,
        caption: t("CAMPAIGN_PLACEHOLDER")
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon12 = accidentalDetailsConfig.AccidentReportNumber) === null || _accidentalDetailsCon12 === void 0 ? void 0 : _accidentalDetailsCon12.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon13 = accidentalDetailsConfig.AccidentReportNumber) !== null && _accidentalDetailsCon13 !== void 0 && _accidentalDetailsCon13.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Accident Report No.")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 6,
        fullWidth: true,
        name: "AccidentReportNumber",
        onChange: handleInputChange,
        size: "small",
        placeholder: t("Enter report no"),
        value: values.AccidentReportNumber,
        disabled: isDisabled
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon14 = accidentalDetailsConfig.DriverName) === null || _accidentalDetailsCon14 === void 0 ? void 0 : _accidentalDetailsCon14.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon15 = accidentalDetailsConfig.DriverName) !== null && _accidentalDetailsCon15 !== void 0 && _accidentalDetailsCon15.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Driver Name")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 8,
        fullWidth: true,
        name: "DriverName",
        onChange: handleInputChange,
        size: "small",
        placeholder: t("Enter driver name"),
        value: values.DriverName,
        disabled: isDisabled,
        inputProps: {
            maxLength: 100
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon16 = accidentalDetailsConfig.DamageDescription) === null || _accidentalDetailsCon16 === void 0 ? void 0 : _accidentalDetailsCon16.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon17 = accidentalDetailsConfig.DamageDescription) !== null && _accidentalDetailsCon17 !== void 0 && _accidentalDetailsCon17.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Damage Description")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 5,
        fullWidth: true,
        name: "DamageDescription",
        multiline: true,
        rows: 6,
        value: values.DamageDescription,
        size: "small",
        placeholder: t("Enter a description..."),
        disabled: isDisabled,
        onChange: function (e) {
            var _e$target3;
            handleInputChange(e);
            if ((e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 || (_e$target3 = _e$target3.value) === null || _e$target3 === void 0 ? void 0 : _e$target3.length) > 100) {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    DamageDescription: true
                }));
            }
            else {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    DamageDescription: false
                }));
            }
        },
        error: errors === null || errors === void 0 ? void 0 : errors.DamageDescription,
        helperText: errors !== null && errors !== void 0 && errors.DamageDescription ? t("Please enter a valid description (max 100 characters).") : ""
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon18 = accidentalDetailsConfig.Attachments) === null || _accidentalDetailsCon18 === void 0 ? void 0 : _accidentalDetailsCon18.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon19 = accidentalDetailsConfig.Attachments) !== null && _accidentalDetailsCon19 !== void 0 && _accidentalDetailsCon19.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Attachments")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
        disabled: isDisabled,
        onClick: function () {
            setOpenUpload(true);
        },
        sx: {
            height: '72px',
            width: '72px',
            border: '1px dashed #DEE4EB',
            borderRadius: '8px',
            bgcolor: '#FFFFFF',
            color: '#6A7682',
            display: 'flex',
            flexDirection: 'column'
        },
        name: "upload",
        startIcon: /*#__PURE__*/ React.createElement("img", {
            src: PlusGrayIconNew,
            alt: "",
            loading: "lazy"
        })
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        display: 'flex',
        alignItems: "center"
    }, accidentalDetailsPhotographList === null || accidentalDetailsPhotographList === void 0 || (_accidentalDetailsPho = accidentalDetailsPhotographList.slice(0, 3)) === null || _accidentalDetailsPho === void 0 ? void 0 : _accidentalDetailsPho.map(function (item, photoIndex) { /*#__PURE__*/ return React.createElement(MuiStack, {
        key: photoIndex
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            display: 'inline-block'
        }
    }, !isDisabled && /*#__PURE__*/ React.createElement(GridCloseIcon, {
        onClick: function () { return onClickRemovePhotoIcon(photoIndex, item.AttachmentId, item.ParentId); },
        sx: {
            position: 'absolute',
            zIndex: 1,
            right: 4,
            top: 4,
            backgroundColor: "white",
            height: '15px',
            width: '15px',
            borderRadius: 50
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: item === null || item === void 0 ? void 0 : item.blobUrl,
        id: "downloadAccidentalDetailsImg" + photoIndex,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: '72px',
            height: '72px',
            borderRadius: '8px',
            position: 'relative'
        },
        onClick: function () { return handleClickImage(item === null || item === void 0 ? void 0 : item.blobUrl); }
    }), accidentalDetailsPhotographList.length > 3 && photoIndex === 2 && /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            position: 'absolute',
            top: '20px',
            left: '20%',
            color: 'primary',
            cursor: 'pointer'
        },
        onClick: function () { return handleViewAllClick(item); }
    }, t("View All")))); }))), /*#__PURE__*/ React.createElement(MuiStack, null, accidentalDetailsAudioList.length > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        style: {
            border: '1px solid #DEE4EB',
            backgroundColor: systemColor.backgroundColor,
            borderRadius: "8px",
            padding: '5px',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(AudioPlayer, {
        src: accidentalDetailsAudioList.length > 0 ? accidentalDetailsAudioList[0].blobUrl : "",
        isSlider: true,
        audioDuration: accidentalDetailsAudioList.length > 0 ? accidentalDetailsAudioList[0].audioDuration : 0
    }), !isDisabled && /*#__PURE__*/ React.createElement(IconButton, {
        sx: {
            // opacity: isDisabled ? 0.5 : 1,
            padding: '0px',
            cursor: 'pointer'
        }
        // disabled={isDisabled}
        ,
        onClick: onDeleteRecording,
        id: "deleteAccidentalDetailsRecording"
    }, /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon,
        alt: "gallery-disable",
        style: {}
    })))), accidentalDetailsAudioList.length === 0 && /*#__PURE__*/ React.createElement(IconButton, {
        sx: {
            opacity: isDisabled ? 0.5 : 'unset'
        },
        disabled: isDisabled,
        onClick: function () { return setAudioCaptureClick(function (pre) { return !pre; }); },
        id: "startAccidentalDetailsRecording"
    }, /*#__PURE__*/ React.createElement(AudioButtonIcon, {
        height: 20,
        width: 20,
        sx: {
            stroke: systemColor.primary
        }
    }))))))))), accidentalDetailsConfig && ((_Object$keys2 = Object.keys(accidentalDetailsConfig)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0 && !insuranceDetailsFields.every(function (field) {
        var _accidentalDetailsCon20;
        return (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon20 = accidentalDetailsConfig[field]) === null || _accidentalDetailsCon20 === void 0 ? void 0 : _accidentalDetailsCon20.show) === false;
    }) && /*#__PURE__*/ React.createElement(MuiStack, {
        mt: 2,
        direction: "column",
        bgcolor: systemColor.white,
        p: 1.5,
        border: "1px solid #DEE4EB",
        borderRadius: 2,
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: lgMode ? 1 : 0,
        rowSpacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        sx: {
            fontWeight: 600
        }
    }, t("Insurance & Policy Details"))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon21 = accidentalDetailsConfig.InsuranceProviderName) === null || _accidentalDetailsCon21 === void 0 ? void 0 : _accidentalDetailsCon21.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon22 = accidentalDetailsConfig.InsuranceProviderName) !== null && _accidentalDetailsCon22 !== void 0 && _accidentalDetailsCon22.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Insurance Provider")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 1,
        caption: 'insurance provider',
        margin: 0,
        fullWidth: true,
        name: "InsuranceProviderId",
        value: values === null || values === void 0 ? void 0 : values.InsuranceProviderId,
        getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.LegalName, " ").concat(option !== null && option !== void 0 && option.BranchCode ? "(".concat(option === null || option === void 0 ? void 0 : option.BranchCode, ")") : ''); },
        valueExpr: "id",
        onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setValues(_objectSpread(_objectSpread({}, values), {}, {
                            InsuranceProviderId: e.target.value,
                            coverageType: null
                        }));
                        if (!!e.target.value) return [3 /*break*/, 1];
                        setCoverageTypeList([]);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, getCoverageTypeList(e.target.value)];
                    case 2:
                        response = _a.sent();
                        if (response !== null && response !== void 0 && response.data) {
                            setCoverageTypeList(response === null || response === void 0 ? void 0 : response.data);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        options: insuranceProviderList,
        disabled: isDisabled,
        error: errors === null || errors === void 0 ? void 0 : errors.InsuranceProviderId,
        id: "insuranceProvider"
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon23 = accidentalDetailsConfig.PolicyNumber) === null || _accidentalDetailsCon23 === void 0 ? void 0 : _accidentalDetailsCon23.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon24 = accidentalDetailsConfig.PolicyNumber) !== null && _accidentalDetailsCon24 !== void 0 && _accidentalDetailsCon24.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Policy Number")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 2,
        fullWidth: true,
        name: "PolicyNumber",
        placeholder: t("Enter policy number"),
        size: "small",
        value: values.PolicyNumber,
        disabled: isDisabled,
        onChange: function (e) {
            handleInputChange(e);
            if (e.target.value.length > PolicyNumberMaxLength) {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    PolicyNumber: true
                }));
            }
            else {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    PolicyNumber: false
                }));
            }
        },
        inputProps: {
            pattern: "^[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?\\s]*$"
        },
        error: errors === null || errors === void 0 ? void 0 : errors.PolicyNumber,
        helperText: errors !== null && errors !== void 0 && errors.PolicyNumber ? t("Please enter a valid insurance policy number (max ".concat(PolicyNumberMaxLength, " characters).")) : ""
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon25 = accidentalDetailsConfig.PolicyHolderName) === null || _accidentalDetailsCon25 === void 0 ? void 0 : _accidentalDetailsCon25.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon26 = accidentalDetailsConfig.PolicyHolderName) !== null && _accidentalDetailsCon26 !== void 0 && _accidentalDetailsCon26.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Policy Holder Name")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 3,
        fullWidth: true,
        name: "PolicyHolderName",
        placeholder: t("Enter policy holder name"),
        size: "small",
        onChange: handleInputChange,
        value: values.PolicyHolderName,
        disabled: isDisabled
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon27 = accidentalDetailsConfig.InsurancePolicyExpiryDate) === null || _accidentalDetailsCon27 === void 0 ? void 0 : _accidentalDetailsCon27.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon28 = accidentalDetailsConfig.InsurancePolicyExpiryDate) !== null && _accidentalDetailsCon28 !== void 0 && _accidentalDetailsCon28.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Policy expiry date")), /*#__PURE__*/ React.createElement(FormDatePicker, {
        onChange: function (e, time) {
            handleInputChange({
                target: {
                    name: "PolicyExpiryDate",
                    value: time
                }
            });
        },
        value: values.PolicyExpiryDate ? dayjs(values.PolicyExpiryDate) : null,
        name: "PolicyExpiryDate",
        placeholder: t("Select policy expiry date"),
        disabled: isDisabled
    }))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon29 = accidentalDetailsConfig.InsuredName) === null || _accidentalDetailsCon29 === void 0 ? void 0 : _accidentalDetailsCon29.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon30 = accidentalDetailsConfig.InsuredName) !== null && _accidentalDetailsCon30 !== void 0 && _accidentalDetailsCon30.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Insured Name")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 5,
        fullWidth: true,
        name: "InsuredName",
        placeholder: t("Enter insured name"),
        size: "small",
        onChange: handleInputChange,
        value: values.InsuredName,
        disabled: isDisabled
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon31 = accidentalDetailsConfig.CoverageType) === null || _accidentalDetailsCon31 === void 0 ? void 0 : _accidentalDetailsCon31.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon32 = accidentalDetailsConfig.CoverageType) !== null && _accidentalDetailsCon32 !== void 0 && _accidentalDetailsCon32.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Coverage Type")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 1,
        caption: 'coverage type',
        margin: 0,
        fullWidth: true,
        name: "CoverageTypeId",
        value: values === null || values === void 0 ? void 0 : values.CoverageTypeId,
        displayExpr: "CoverageTypeName",
        valueExpr: "CoverageTypeId",
        onChange: handleInputChange,
        options: coverageTypeList,
        disabled: !(values !== null && values !== void 0 && values.InsuranceProviderId) || isDisabled,
        error: errors === null || errors === void 0 ? void 0 : errors.CoverageTypeId,
        id: "coverageType"
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon33 = accidentalDetailsConfig.LossType) === null || _accidentalDetailsCon33 === void 0 ? void 0 : _accidentalDetailsCon33.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon34 = accidentalDetailsConfig.LossType) !== null && _accidentalDetailsCon34 !== void 0 && _accidentalDetailsCon34.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Loss Type")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 7,
        fullWidth: true,
        name: "LossTypeId",
        placeholder: t("Select loss type"),
        size: "small",
        onChange: handleInputChange,
        options: lossTypeList,
        valueExpr: "id",
        displayExpr: "DisplayName",
        value: values === null || values === void 0 ? void 0 : values.LossTypeId,
        caption: t("loss type"),
        disabled: isDisabled
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon35 = accidentalDetailsConfig.SurveyorName) === null || _accidentalDetailsCon35 === void 0 ? void 0 : _accidentalDetailsCon35.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon36 = accidentalDetailsConfig.SurveyorName) !== null && _accidentalDetailsCon36 !== void 0 && _accidentalDetailsCon36.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Surveyor Name")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        disabled: isDisabled,
        tabIndex: 8,
        fullWidth: true,
        name: "IntimatorName",
        placeholder: t("Enter surveyor name"),
        size: "small",
        onChange: function (e) {
            handleInputChange(e);
            var value = e.target.value;
            if (!value) {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    IntimatorName: false
                }));
                return;
            }
            var regex = /^[A-Za-z.\-\s]{2,100}$/;
            // const isValid = value.length >= 2 && value.length <= 100;
            var isValid = regex.test(value);
            setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                IntimatorName: !isValid
            }));
            return;
        },
        value: values.IntimatorName,
        error: errors === null || errors === void 0 ? void 0 : errors.IntimatorName,
        helperText: errors !== null && errors !== void 0 && errors.IntimatorName ? t("Please enter a valid surveyor name (only letters, hyphens, periods, 2-100 characters).") : ""
    })))), (accidentalDetailsConfig === null || accidentalDetailsConfig === void 0 || (_accidentalDetailsCon37 = accidentalDetailsConfig.SurveyorNumber) === null || _accidentalDetailsCon37 === void 0 ? void 0 : _accidentalDetailsCon37.show) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            "&::after": accidentalDetailsConfig !== null && accidentalDetailsConfig !== void 0 && (_accidentalDetailsCon38 = accidentalDetailsConfig.SurveyorNumber) !== null && _accidentalDetailsCon38 !== void 0 && _accidentalDetailsCon38.IsMandatory ? {
                content: '"*"',
                color: "red",
                marginLeft: "2px"
            } : {}
        },
        variant: "h6",
        color: systemColor.lightGrey,
        paddingY: 1
    }, t("Surveyor Mobile Number")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        type: "number",
        disabled: isDisabled,
        tabIndex: 9,
        fullWidth: true,
        name: "IntimatorNumber",
        value: values.IntimatorNumber,
        placeholder: t("Enter surveyor mobile number"),
        size: "small",
        onChange: function (e) {
            var value = e.target.value;
            var numericValue = value.replace(/[^0-9]/g, '').slice(0, 10);
            e.target.value = numericValue;
            handleInputChange(e);
            if (!numericValue) {
                setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                    IntimatorNumber: false
                }));
                return;
            }
            var isValid = /^[6-9]\d{9}$/.test(numericValue);
            setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                IntimatorNumber: !isValid
            }));
        },
        error: errors === null || errors === void 0 ? void 0 : errors.IntimatorNumber,
        helperText: errors !== null && errors !== void 0 && errors.IntimatorNumber ? t("Please enter a valid 10-digit mobile number starting with 6/7/8/9.") : ""
    })))))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        bgcolor: systemColor.white,
        p: 1.5,
        border: '1px solid',
        borderColor: 'secondary.200',
        borderRadius: 2,
        spacing: 2,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: lgMode ? 1 : 0,
        rowSpacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        id: "Campaign-details",
        sx: {
            fontWeight: 600
        }
    }, t("Other details"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        paddingY: 1,
        color: 'secondary.500'
    }, t("Campaign")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormSearchSelect, {
        tabIndex: 4,
        placeholder: t('CAMPAIGN_PLACEHOLDER'),
        fullWidth: true,
        name: "Compaign",
        value: campaign,
        getListData: getCampaignListAPICall,
        apiKey: "campaignListData",
        displayExpr: "Name",
        getOptionLabel: function (option) {
            var _option$Name, _option$Code;
            return "".concat((_option$Name = option.Name) !== null && _option$Name !== void 0 ? _option$Name : '-', " (").concat((_option$Code = option.Code) !== null && _option$Code !== void 0 ? _option$Code : '-', ")");
        },
        renderOption: function (props, option) {
            var _option$Name2, _option$Code2;
            var fromDate = option !== null && option !== void 0 && option.DateEffectiveFrom ? dayjs(option.DateEffectiveFrom).format('DD MMM, YYYY') : '-';
            var toDate = option !== null && option !== void 0 && option.DateEffectiveTo ? dayjs(option.DateEffectiveTo).format('DD MMM, YYYY') : '-';
            var date = fromDate && toDate ? "".concat(fromDate, " - ").concat(toDate) : fromDate || toDate || '';
            return /*#__PURE__*/ React.createElement(Box, _extends({
                component: "li"
            }, props, {
                sx: {
                    p: 2
                }
            }), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
                fontSize: '14px'
            }, "".concat((_option$Name2 = option.Name) !== null && _option$Name2 !== void 0 ? _option$Name2 : '-', " (").concat((_option$Code2 = option.Code) !== null && _option$Code2 !== void 0 ? _option$Code2 : '-', ")")), /*#__PURE__*/ React.createElement(Typography, {
                fontSize: '12px',
                color: "text.secondary"
            }, date)));
        },
        valueExpr: "id",
        onChange: function (e, newValue) {
            setCampaign((newValue === null || newValue === void 0 ? void 0 : newValue.id) || null);
            dispatch(setDocDataUpdated(true));
        }
        // options={filterList?.compaignList || []}
        ,
        disabled: !serviceType || isDisabled,
        error: errors === null || errors === void 0 ? void 0 : errors.Compaign,
        id: "campaign"
    })))), UCN_CODE_TRANSACTION_TYPES.includes(parentComponent) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        color: 'secondary.500',
        paddingY: 1
    }, t("UCN")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'row'
    }, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 5,
        size: "small",
        id: "UCN-input",
        placeholder: "Please enter UCN.",
        variant: "outlined",
        disabled: isUcnFieldDisabled() || ucnState === 'Send' || ucnState === 'Check UCN',
        onChange: function (event) {
            setUcnState('Apply');
            setUcnCode(event.target.value ? event.target.value.trim() : "");
            setUcnHelperText(UCN_HELPER_TEXT_STATE.INFO);
        },
        value: ucnCode,
        InputProps: {
            endAdornment: /*#__PURE__*/ React.createElement(React.Fragment, null, ucnState === 'Resend' && IsSendUCNDisabled ? /*#__PURE__*/ React.createElement(React.Fragment, null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
                sx: {
                    height: "100%"
                },
                orientation: "vertical"
            }), /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "end"
            }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
                variant: "text",
                loading: loader.isLoaderOpen,
                style: {
                    backgroundColor: "transparent",
                    paddingRight: "12px"
                },
                onClick: handleUcnButtonClick,
                name: loader.isLoaderOpen ? '' : t(ucnState),
                disabled: isUcnButtonDisbaled()
            })))),
            style: {
                paddingRight: 0
            }
        },
        fullWidth: true
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'row',
        spacing: 0.5,
        paddingTop: 0.5
    }, getUcnHelperText())))))), /*#__PURE__*/ React.createElement(MuiStack, {
        display: (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' ? 'flex' : parentComponent === EParentModuleName.Appointment && (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Update' ? 'flex' : 'none',
        direction: 'column',
        bgcolor: systemColor.white,
        p: 1.5,
        border: '1px solid #DEE4EB',
        borderRadius: 2,
        spacing: 2,
        width: '100%'
    }, (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' && /*#__PURE__*/ React.createElement(React.Fragment, null, selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationId && SystemName == ESystemName.Appointment && getCurrentCalendarData && Array.isArray(getCurrentCalendarData) && getCurrentCalendarData.length > 0 ? /*#__PURE__*/ React.createElement(Grid, {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(CalendarComponent, {
        getCurrentCalendarData: getCurrentCalendarData,
        fullDate: fullDate,
        onArrowDateChange: function (value) { return onArrowDateChange(value); },
        maxSlotValue: maxSlotValue
        // dateFormate={(value: any) => dateFormate(value)}
        ,
        onClickOfSlotBar: function (data) { return onClickOfSlotBar(data); },
        selectedTimeSlot: selectedTimeSlot
    })) : /*#__PURE__*/ React.createElement(Grid, {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, null, 'No slots available.')))), (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' && getCurrentCalendarData && Array.isArray(getCurrentCalendarData) && getCurrentCalendarData.length > 0 && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
        paddingBottom: '4px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        justifyContent: 'flex-start',
        paddingTop: '24px'
    }, (timeSlotData === null || timeSlotData === void 0 ? void 0 : timeSlotData.length) > 0 ? timeSlotData === null || timeSlotData === void 0 ? void 0 : timeSlotData.map(function (value, index) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 3,
        key: index
    }, /*#__PURE__*/ React.createElement(Button, {
        disabled: getSlotDisable(value === null || value === void 0 ? void 0 : value.EndTime, value.Day, value.AvailabilityCount),
        id: "slotButton",
        style: {
            width: '100%',
            border: '1px solid #DEE4EB',
            borderRadius: '8px',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
            padding: '5px 4px',
            marginTop: '16px',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: (selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.EndTime) == value.EndTime ? systemColor.primary : systemColor.mainColor,
            opacity: getSlotDisable(value === null || value === void 0 ? void 0 : value.EndTime, value.Day, value.AvailabilityCount) ? 0.5 : 1
        },
        onClick: function () {
            onTimeSlotSelectedClick(value);
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "slot-time",
        style: {
            fontSize: '11px',
            fontWeight: 500
        },
        color: (selectedTimeSlot === null || selectedTimeSlot === void 0 ? void 0 : selectedTimeSlot.StartTime) === value.StartTime ? '#FFF' : '#6A7682'
    }, getTime(value === null || value === void 0 ? void 0 : value.StartTime) + ' - ' + getTime(value === null || value === void 0 ? void 0 : value.EndTime)), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            backgroundColor: '#F4F7FA',
            border: '1px solid #DEE4EB',
            borderRadius: '12px',
            padding: 3,
            marginLeft: '10px',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "available-slots",
        style: {
            fontSize: '11px',
            fontWeight: 500,
            color: '#1B1D21'
        }
    }, value.AvailabilityCount + '/' + value.TotalCount)))); }) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isSkeleton && dateValue && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        display: 'flex',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("No slots available")))))), parentComponent === EParentModuleName.Appointment && (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Update' && /*#__PURE__*/ React.createElement(Grid, {
        lg: 3,
        md: 3,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        paddingY: 1,
        sx: {
            fontWeight: 600
        }
    }, t("Date & time slot")), /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 5,
        placeholder: t("Date & time slot"),
        fullWidth: true,
        size: "small",
        value: scheduledTime ? "".concat(dateFormate(scheduledTime), " ").concat(getTime(scheduledTime)) : '-'
        // value={`${new Date(scheduledDate).toLocaleDateString()} ${new Date(scheduledTime).toLocaleTimeString()}`}
        ,
        name: "scheduledDate",
        disabled: true
        // helperText={usageReadingError.errorMessage}
        ,
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#F4F7FA",
                borderRadius: '8px'
            }
        },
        id: "date-time-slot"
    })))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        bgcolor: systemColor.white,
        p: 1.5,
        border: '1px solid #DEE4EB',
        borderRadius: 2,
        spacing: 2,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        rowSpacing: 1
    }, SystemName == ESystemName.Jobcard && /*#__PURE__*/ React.createElement(Grid, {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        paddingY: 1
    }, t("Estimated delivery time")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "service-type",
        size: "small",
        style: {
            marginTop: '8px'
        }
        // value={`${dateFormate(data?.EstimateDeliveryDateTime)}  ${getTime(data?.EstimateDeliveryDateTime)}`}
        ,
        name: "ServiceType"
        // onChange={handleInputChange}
        ,
        disabled: true
    }))), !(customerVoiceSectionDetails !== null && customerVoiceSectionDetails !== void 0 && (_customerVoiceSection11 = customerVoiceSectionDetails.SectionAttributes[0]) !== null && _customerVoiceSection11 !== void 0 && _customerVoiceSection11.HIDE) && /*#__PURE__*/ React.createElement(Grid, {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: _objectSpread(_objectSpread({}, (customerVoiceSectionDetails === null || customerVoiceSectionDetails === void 0 || (_customerVoiceSection12 = customerVoiceSectionDetails.SectionAttributes[0]) === null || _customerVoiceSection12 === void 0 ? void 0 : _customerVoiceSection12.MANDATORY) && {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            }
        }), {}, {
            fontWeight: 600
        }),
        fontSize: "base",
        paddingY: 1
    }, t("Customer complaint")), (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Create' ? /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid',
            borderColor: 'secondary.200',
            borderRadius: "8px",
            padding: '2px',
            background: ''
        },
        width: "100%",
        marginY: 1.5
    }, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 4,
        id: "customerDescription",
        placeholder: "Enter concerns...",
        value: customerComplaint,
        multiline: true,
        rows: 4,
        variant: "outlined",
        fullWidth: true,
        onChange: handleInputBox,
        sx: {
            "& fieldset": {
                border: 'none'
            },
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#F4F7FA"
            }
        },
        inputProps: {
            maxLength: 1000
        }
    })) : "", /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'end'
    }, "(", customerConcern, "/", 1000, ")"), (UpdateFlow || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == "Create" || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == "Create") && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(CustomerComplaintView, {
        showInAccordian: false,
        isDisabled: isDisabled,
        url: CustomerComplaintUrl(module),
        requestID: parentModuleDocumentId,
        apiRequestParam: module,
        apiRequestPayload: apiRequestPayload,
        parentModuleDocumentId: parentModuleDocumentId,
        disabledConfirmDocument: function (value) { return setDisabledConfirmCustomerComplaint(value); },
        createAndEditFlow: createAndEditFlow,
        IsFromParentAPt: IsFromParentAPt,
        vehicleList: vehicleDetails,
        SystemName: SystemName
    })))))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        rowSpacing: 1,
        sx: {
            // Default styles (not fixed for larger screens)
            position: 'relative',
            width: '100%',
            backgroundColor: '#F4F7FA',
            zIndex: 10,
            '@media (max-width: 600px)': {
                position: 'sticky',
                bottom: 0,
                left: 0
                // zIndex: 10,
            }
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
        marginTop: '0px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column',
        justifyContent: 'flex-end',
        paddingBottom: "10px"
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%'
        }
    })), (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) === 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) === 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) === "Update" ? /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "".concat(SystemName + "updateDocument"),
        variant: "contained",
        name: t("Next"),
        style: {
            alignSelf: 'flex-end',
            marginTop: '15px'
        },
        onClick: OnClickNext,
        disabled: nextButtonDissabled()
    }) : /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "".concat(SystemName + "createDocument"),
        variant: "contained",
        name: getSubmitText(),
        style: {
            alignSelf: 'flex-end',
            marginTop: '15px'
        },
        onClick: OnClickNext,
        disabled: createDocumentDisabled()
    })))), /*#__PURE__*/ React.createElement(AmcContractPopup, {
        isOpen: openAmcContractPopup,
        amcServiceTypeDetails: amcServiceTypeDetails,
        onClosePopup: handleOnClickNoAmcContract,
        onClickNoBtn: handleOnClickNoAmcContract,
        onClickYesBtn: handleOnClickYesAmcContract
    }), /*#__PURE__*/ React.createElement(OdometerConfirmPopUp, {
        isOpen: isOpen,
        amcServiceTypeDetails: amcServiceTypeDetails,
        onClosePopup: handleOnClickNoAmcContract,
        onClickNoBtn: function () {
            setIsOdometerChecked(false), setIsopen(false);
        },
        onClickYesBtn: function () { return setIsopen(false); }
    }), techPackPopup.open && /*#__PURE__*/ React.createElement(TechPackPopup, {
        open: techPackPopup.open,
        onClose: techPackPopup.onClose,
        heading: techPackPopup.heading,
        description: techPackPopup.description,
        popupType: techPackPopup.popupType,
        declineButton: techPackPopup.declineButton,
        acceptButton: techPackPopup.acceptButton
    }), /*#__PURE__*/ React.createElement(ImageCaptureAndFileupload, {
        open: openUpload,
        clearPopUpImages: false,
        isImageEmpty: function (value) { return handleEmptyImage(value); },
        handleModelClose: function (value) { return handleCancleClick(value); },
        handleConfirm: function (data) {
            // console.log("data", data);
            handleConfirmClick(data);
            // onChange?.(null, data)
        },
        downloadedImages: accidentalDetailsPhotographList !== null && accidentalDetailsPhotographList !== void 0 ? accidentalDetailsPhotographList : [],
        maxImageUploadLimit: 10,
        ParentId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy109 = documentDetailsGetById.data) === null || _documentDetailsGetBy109 === void 0 ? void 0 : _documentDetailsGetBy109.id,
        systemName: 'PreJobCardAccidentalDetail',
        deleteUrl: deleteAllAttachmentUrl
    }), /*#__PURE__*/ React.createElement(AudioCapturePopUpComponent, {
        open: audioCaptureClick,
        handleModelClick: function (value) { return setAudioCaptureClick(value); },
        handleConfirmClick: function (audio) { return onConfirmClick(audio); }
    }), isViewImageDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isViewImageDrawerOpen,
        onClose: function () {
            setImageURL('');
            setIsViewImageDrawerOpen(false);
        },
        image: imageURL
    }), /*#__PURE__*/ React.createElement(ViewAllImagePopUp, {
        isOpen: viewAllImages,
        onClosed: function () { return setViewAllImages(false); },
        images: accidentalDetailsPhotographList
    }), parentComponent !== EParentModuleName.Appointment && !(serviceTypeError !== null && serviceTypeError !== void 0 && serviceTypeError.error) && showFutureAdvicePopup && (futureAdviceList === null || futureAdviceList === void 0 ? void 0 : futureAdviceList.length) > 0 && /*#__PURE__*/ React.createElement(FutureAdvicePopup, {
        futureAdviceList: futureAdviceList,
        onClose: function () { return setShowFutureAdvicePopup(false); }
    }));
};
export default ServiceDetailsComponent;
